// import { firestore } from 'firebase';
import React, { Component } from "react";
import Swal from "sweetalert2";
import Select from "react-select";
// import API from "../utils/API";
// import ReactDOM from 'react-dom';
import firebase from "../Firebase";
import { storage } from "../Firebase";

//import alamat
//lokal data alamat
import dataProvinsi from "../json/provinsi-converted.json";
import dataKabupaten from "../json/kabupaten-converted.json";
import dataKecamatan from "../json/kecamatan-converted.json";
import dataDesa from "../json/desa-converted.json";
import {
  isForm1FileUrlsComplete,
  isNonstaffStatus,
  validateForm1Complete,
} from "../utils/form1Completeness";
import { resolveEmployeeDoc } from "../utils/employeeIdentity";
import DocumentOcrUpload from "./DocumentOcrUpload";
import FormStepNav from "./FormStepNav";
import { getValidateByOcrFieldName } from "../utils/ocrApi";

class Form extends Component {
  constructor() {
    super();
    this.ref = firebase.firestore().collection("employees");
    // ✅ Debounce timer untuk mencegah race condition
    this.validationTimer = null;
    this.autosaveTimer = null;
    this.pendingAutosave = {};
    this.flushAutosaveOnLeave = () => {
      this.flushAutosave();
    };
    this.state = {
      username_admin: "",
      form_1_submitted: "",
      form_2_submitted: "",

      nik: "",
      golongan_darah: "",
      foto_pribadi_label: null,
      fotoFile: null,
      fotoUrl: null,
      ktpFile: null,
      ktpUrl: null,
      npwpFile: null,
      npwpUrl: null,
      kkFile: null,
      kkUrl: null,
      foto_url: "",
      ktp_url: "",
      npwp_url: "",
      kk_url: "",
      foto_validate_by_ocr: false,
      ktp_validate_by_ocr: false,
      npwp_validate_by_ocr: false,
      kk_validate_by_ocr: false,

      //state untuk checked npwp pemadanan
      npwp_pemadanan_checked: false,

      //State yang kurang untuk foto-foto
      // foto_pribadi: "",
      // foto_ktp: "",
      // foto_npwp: "",
      foto_npwp_label: null,
      // foto_kk: "",
      foto_kk_label: null,
      // foto_cv: "",

      // State CV
      foto_cv_status: "",
      cvFile: null,
      cvUrl: null,
      foto_cv_label: null,
      cv_url: "",
      cv_validate_by_ocr: false,
      trial: false,

      // //state rekening bank untuk upload
      // foto_rekening_bank: "",
      // foto_rekening_bank_status: "",
      // foto_rekening_bank_label: null,
      // rekeningBankFile: null,
      // rekeningBankUrl: null,
      // rekening_bank_url: "",
      //state selected rekening
      selected_bank: "",
      rekening_error: "",
      nomor_rekening_bank: "",

      //State untuk nama sertifikasi dan lembaga pemberi
      nama_sertifikasi_1: "",
      nama_sertifikasi_2: "",
      nama_sertifikasi_3: "",
      nama_sertifikasi_4: "",

      lembaga_pemberi_1: "",
      lembaga_pemberi_2: "",
      lembaga_pemberi_3: "",
      lembaga_pemberi_4: "",

      //state foto sertifikasi training 1
      foto_sertifikasi_training_1: "",
      foto_sertifikasi_training_1_status: "",
      foto_sertifikasi_training_1_label: null,
      sertifikasiTraining1File: null,
      sertifikasiTraining1Url: null,
      sertifikasi_training_1_url: "",

      // State untuk sertifikasi 2
      foto_sertifikasi_training_2: "",
      foto_sertifikasi_training_2_status: "",
      foto_sertifikasi_training_2_label: null,
      sertifikasiTraining2File: null,
      sertifikasiTraining2Url: null,
      sertifikasi_training_2_url: "",

      // State untuk sertifikasi 3
      foto_sertifikasi_training_3: "",
      foto_sertifikasi_training_3_status: "",
      foto_sertifikasi_training_3_label: null,
      sertifikasiTraining3File: null,
      sertifikasiTraining3Url: null,
      sertifikasi_training_3_url: "",

      // State untuk sertifikasi 4
      foto_sertifikasi_training_4: "",
      foto_sertifikasi_training_4_status: "",
      foto_sertifikasi_training_4_label: null,
      sertifikasiTraining4File: null,
      sertifikasiTraining4Url: null,
      sertifikasi_training_4_url: "",

      pengalaman_kerja_perusahaan: [],
      alamatDisabled: true,
      ASalamatDisabled: true,
      provincesData: [],
      regenciesData: [],
      districtsData: [],
      villagesData: [],
      province: "",
      provinceName: "",
      regency: "",
      regencyName: "",
      district: "",
      districtName: "",
      village: "",
      villageName: "",
      addressDetail: "",

      ASprovincesData: [],
      ASregenciesData: [],
      ASdistrictsData: [],
      ASvillagesData: [],

      ASprovince: "",
      ASregency: "",
      ASdistrict: "",
      ASvillage: "",
      ASaddressDetail: "",

      nomor_ktp: JSON.parse(localStorage.getItem("id"))[0].nik,
      nama_lengkap: "",
      nomor_kk: "",
      nomor_npwp: "",
      alamatSesuaiKtp: true,

      agama: "",
      jenis_kelamin: "",
      tempat_lahir: "",
      tanggal_lahir: "",
      tanggal_lahir_formatted: "",
      // tanggal_lahir_formatted: "",
      tanggal_masuk: this.currentDate(),
      status_perdata: "Belum Menikah",
      nama_pasangan: "",
      tempat_pernikahan: "",
      tanggal_pernikahan: "",
      tempat_lahir_pasangan: "",
      tanggal_lahir_pasangan: "",
      pekerjaan_pasangan: "",
      tempat_pasangan_bekerja: "",

      pengalaman_kerja_perusahaan_1: "",
      pengalaman_kerja_perusahaan_2: "",
      pengalaman_kerja_perusahaan_3: "",
      pengalaman_kerja_perusahaan_4: "",

      pengalaman_kerja_jabatan_1: "",
      pengalaman_kerja_jabatan_2: "",
      pengalaman_kerja_jabatan_3: "",
      pengalaman_kerja_jabatan_4: "",

      pengalaman_kerja_tanggal_mulai_1: "",
      pengalaman_kerja_tanggal_mulai_2: "",
      pengalaman_kerja_tanggal_mulai_3: "",
      pengalaman_kerja_tanggal_mulai_4: "",

      pengalaman_kerja_tanggal_selesai_1: "",
      pengalaman_kerja_tanggal_selesai_2: "",
      pengalaman_kerja_tanggal_selesai_3: "",
      pengalaman_kerja_tanggal_selesai_4: "",

      pengalaman_kerja_kota_1: "",
      pengalaman_kerja_kota_2: "",
      pengalaman_kerja_kota_3: "",
      pengalaman_kerja_kota_4: "",

      orang_tua_nama_ayah: "",
      orang_tua_nama_ibu: "",

      kontak_darurat_nama: "",
      kontak_darurat_hubungan: "",
      kontak_darurat_hubungan_kerabat: "",
      kontak_darurat_no_telepon: "",

      anak_anak_nama_1: "",
      anak_anak_jenis_kelamin_1: "",
      anak_anak_tempat_lahir_1: "",
      anak_anak_tanggal_lahir_1: "",

      anak_anak_nama_2: "",
      anak_anak_jenis_kelamin_2: "",
      anak_anak_tempat_lahir_2: "",
      anak_anak_tanggal_lahir_2: "",

      anak_anak_nama_3: "",
      anak_anak_jenis_kelamin_3: "",
      anak_anak_tempat_lahir_3: "",
      anak_anak_tanggal_lahir_3: "",

      anak_anak_nama_4: "",
      anak_anak_jenis_kelamin_4: "",
      anak_anak_tempat_lahir_4: "",
      anak_anak_tanggal_lahir_4: "",

      orang_tua_tempat_lahir_ayah: "",
      orang_tua_tanggal_lahir_ayah: "",
      orang_tua_tempat_lahir_ibu: "",
      orang_tua_tanggal_lahir_ibu: "",

      saudara_kandung_nama_1: "",
      saudara_kandung_jenis_kelamin_1: "",
      saudara_kandung_tempat_lahir_1: "",
      saudara_kandung_tanggal_lahir_1: "",

      saudara_kandung_nama_2: "",
      saudara_kandung_jenis_kelamin_2: "",
      saudara_kandung_tempat_lahir_2: "",
      saudara_kandung_tanggal_lahir_2: "",

      saudara_kandung_nama_3: "",
      saudara_kandung_jenis_kelamin_3: "",
      saudara_kandung_tempat_lahir_3: "",
      saudara_kandung_tanggal_lahir_3: "",

      saudara_kandung_nama_4: "",
      saudara_kandung_jenis_kelamin_4: "",
      saudara_kandung_tempat_lahir_4: "",
      saudara_kandung_tanggal_lahir_4: "",

      mertua_nama_ayah: "",
      mertua_tempat_lahir_ayah: "",
      mertua_tanggal_lahir_ayah: "",
      mertua_nama_ibu: "",
      mertua_tempat_lahir_ibu: "",
      mertua_tanggal_lahir_ibu: "",

      //bpjs
      nomor_kartu_bpjs_kesehatan: "",
      nomor_kartu_bpjs_ketenagakerjaan: "",
      keterangan_kartu_bpjs_kesehatan: "Belum Dapat",
      keterangan_kartu_bpjs_ketenagakerjaan: "Belum Dapat",

      // ✅ State vaksinasi
      jenis_vaksin: "",
      tanggal_vaksin_1: "",
      lokasi_vaksin_1: "",
      tanggal_vaksin_2: "",
      lokasi_vaksin_2: "",
      tanggal_vaksin_3: "",
      lokasi_vaksin_3: "",

      email: "",
      nomor_hp: "",
      sosmed_facebook: "",
      sosmed_twitter: "",
      sosmed_linkedin: "",
      sosmed_instagram: "",

      agreement: false,
      submiting: false,
      isFormValid: false,

      foto_npwp_status: "",
      foto_pribadi_status: "",
      foto_ktp_status: "",
      foto_kk_status: "",

      pendidikan_terakhir: "",
      pendidikan_nama_sekolah: "",
      pendidikan_jurusan: "",
      pendidikan_kursus: "",
    };
  }

  componentDidMount() {
    this.getProvinces();
    this.cekLogin();
    window.addEventListener("beforeunload", this.flushAutosaveOnLeave);

    // setTimeout(() => {
    //   this.updateSubmitButtonStatus();
    // }, 1000);
  }

  // ✅ PERBAIKAN: Cleanup timer untuk mencegah memory leak
  componentWillUnmount() {
    if (this.validationTimer) {
      clearTimeout(this.validationTimer);
      this.validationTimer = null;
    }
    window.removeEventListener("beforeunload", this.flushAutosaveOnLeave);
    this.flushAutosave();
  }

  // componentDidUpdate(prevProps, prevState) {
  //   // ✅ Jika selected_bank berubah, trigger validasi ulang
  //   if (prevState.selected_bank !== this.state.selected_bank) {
  //     console.log("🔄 Bank selection changed, re-validating...");

  //     // Reset error saat bank berubah
  //     this.setState({
  //       rekening_error: "",
  //     });

  //     // Jika ada nomor rekening, validate ulang
  //     if (
  //       this.state.nomor_rekening_bank &&
  //       this.state.nomor_rekening_bank.trim() !== ""
  //     ) {
  //       // ✅ PERBAIKI: Pastikan event object valid
  //       const syntheticEvent = {
  //         target: {
  //           value: this.state.nomor_rekening_bank.toString(), // ✅ Pastikan string
  //           name: "nomor_rekening_bank",
  //         },
  //       };

  //       setTimeout(() => {
  //         this.validateRekeningBank(syntheticEvent);
  //       }, 100);
  //     } else {
  //       // Update submit button status
  //       setTimeout(() => {
  //         this.updateSubmitButtonStatus();
  //       }, 100);
  //     }
  //   }

  //   // ✅ Jika nomor rekening berubah, trigger validasi
  //   if (prevState.nomor_rekening_bank !== this.state.nomor_rekening_bank) {
  //     console.log("🔄 Rekening number changed, updating validation...");
  //     setTimeout(() => {
  //       this.updateSubmitButtonStatus();
  //     }, 100);
  //   }
  // }

  cekLogin = async () => {
    const id = localStorage.getItem("id");
    if (id == null) {
      // Ini sudah login, masuk ke form
      this.props.history.push("/");
    } else {
      const lStorage = JSON.parse(id);
      const nik = lStorage[0].nik;
      const status_karyawan = lStorage[0].status_karyawan
        ? lStorage[0].status_karyawan.toLowerCase()
        : "";
      const tanggal_lahir_raw = lStorage[0].tanggal_lahir;
      const username_admin = lStorage[0].username_admin;

      console.log(status_karyawan);

      let bank = "";
      if (status_karyawan === "staff") {
        bank = "mas";
      } else if (isNonstaffStatus(status_karyawan)) {
        bank = "";
      } else {
        bank = "";
      }

      // ✅ TAMBAH: Function untuk format tanggal lahir
      const formatTanggalLahir = (rawDate) => {
        if (!rawDate || rawDate.length !== 8) {
          console.log("❌ Format tanggal lahir tidak valid:", rawDate);
          return "";
        }

        try {
          // Parse tanggal dari format ddmmyyyy
          const day = rawDate.substring(0, 2); // "30"
          const month = rawDate.substring(2, 4); // "03"
          const year = rawDate.substring(4, 8); // "2002"

          // Validasi basic
          if (parseInt(day) < 1 || parseInt(day) > 31) {
            console.log("❌ Hari tidak valid:", day);
            return "";
          }
          if (parseInt(month) < 1 || parseInt(month) > 12) {
            console.log("❌ Bulan tidak valid:", month);
            return "";
          }
          if (
            parseInt(year) < 1900 ||
            parseInt(year) > new Date().getFullYear()
          ) {
            console.log("❌ Tahun tidak valid:", year);
            return "";
          }

          // Format ke yyyy-mm-dd untuk input date
          const formattedDate = `${year}-${month}-${day}`;
          console.log(
            "✅ Tanggal lahir diformat:",
            `${rawDate} → ${formattedDate}`,
          );

          return formattedDate;
        } catch (error) {
          console.error("❌ Error formatting tanggal lahir:", error);
          return "";
        }
      };

      const tanggal_lahir_formatted = formatTanggalLahir(tanggal_lahir_raw);

      //ambil data dari firebase untuk validasi data
      const resolved = await resolveEmployeeDoc(this.ref, {
        docId: lStorage[0].docId || null,
        nik,
        tanggalLahir: tanggal_lahir_raw,
      });

      let existingData = {};
      let docId = null;

      const normalizeAgama = (agamaRaw) => {
        if (!agamaRaw || typeof agamaRaw !== "string") return "";

        const agamaNormalized = String(agamaRaw).trim().toUpperCase();
        const agamaMapping = {
          ISLAM: "islam",
          MOSLEM: "islam",
          MUSLIM: "islam",
          KRISTEN: "kristen",
          KRISTIANI: "kristen",
          PROTESTAN: "kristen",
          KATOLIK: "katolik",
          KATHOLIK: "katolik",
          "KRISTEN KATOLIK": "katolik",
          HINDU: "hindu",
          HINDUISME: "hindu",
          BUDHA: "budha",
          BUDDHA: "budha",
          BUDDHIST: "budha",
          "KONG HU CU": "kong hu cu",
          "KONG HUCU": "kong hu cu",
          KONGHUCU: "kong hu cu",
        };

        return agamaMapping[agamaNormalized] || agamaNormalized.toLowerCase();
      };

      if (resolved.doc) {
        const doc = resolved.doc;
        existingData = doc.data();
        docId = doc.id;

        const rekeningMCU =
          existingData.nomor_rekening_bank_mcu ||
          existingData.nomor_rekening_mandiri_mcu ||
          existingData.nomor_rekening_mas_mcu ||
          "";

        console.log("🏦 Rekening MCU found:", rekeningMCU);

        const agamaMCU = normalizeAgama(existingData.agama_mcu);
        console.log("🛐 Agama MCU normalized:", {
          original: existingData.agama_mcu,
          normalized: agamaMCU,
        });

        this.setState(
          {
            nik: lStorage[0].nik,
            status_karyawan: status_karyawan,
            tanggal_lahir: tanggal_lahir_raw,
            tanggal_lahir_formatted: tanggal_lahir_formatted,
            username_admin: username_admin,

            //state untuk mcu yang akan untuk patokan validasi
            // Data Pribadi MCU
            nomor_npwp_mcu: existingData.nomor_ktp_mcu || "",
            jenis_kelamin_mcu: existingData.jenis_kelamin_mcu || "",
            nomor_ktp_mcu: existingData.nomor_ktp_mcu || nik,
            nama_lengkap_mcu: existingData.nama_lengkap_mcu || "",
            tempat_lahir_mcu: existingData.tempat_lahir_mcu || "",
            nomor_hp_mcu: existingData.nomor_hp_mcu || "",
            email_mcu: existingData.email_mcu || "",
            agama_mcu: agamaMCU || "",
            nomor_rekening_bank_mcu: String(rekeningMCU),
            nomor_kartu_bpjs_kesehatan_mcu:
              existingData.nomor_kartu_bpjs_kesehatan_mcu || "",

            // Data Alamat MCU
            addressDetail_mcu: existingData.alamat_ktp_mcu || "",
            ASaddressDetail_mcu: existingData.alamat_domisili_mcu || "",

            // Data Pendidikan MCU
            pendidikan_terakhir_mcu: existingData.pendidikan_terakhir_mcu || "",
            pendidikan_nama_sekolah_mcu:
              existingData.pendidikan_nama_sekolah_mcu || "",
            pendidikan_jurusan_mcu: existingData.pendidikan_jurusan_mcu || "",

            // Data Orang Tua MCU
            orang_tua_nama_ayah_mcu: existingData.orang_tua_nama_ayah_mcu || "",
            orang_tua_tempat_lahir_ayah_mcu:
              existingData.orang_tua_tempat_lahir_ayah_mcu || "",
            orang_tua_tanggal_lahir_ayah_mcu:
              existingData.orang_tua_tanggal_lahir_ayah_mcu || "",
            orang_tua_nama_ibu_mcu: existingData.orang_tua_nama_ibu_mcu || "",
            orang_tua_tempat_lahir_ibu_mcu:
              existingData.orang_tua_tempat_lahir_ibu_mcu || "",
            orang_tua_tanggal_lahir_ibu_mcu:
              existingData.orang_tua_tanggal_lahir_ibu_mcu || "",

            //state pengalaman kerja
            pengalaman_kerja_perusahaan_1_mcu:
              existingData.pengalaman_kerja_perusahaan_1_mcu || "",
            pengalaman_kerja_perusahaan_2_mcu:
              existingData.pengalaman_kerja_perusahaan_2_mcu || "",
            pengalaman_kerja_perusahaan_3_mcu:
              existingData.pengalaman_kerja_perusahaan_3_mcu || "",
            pengalaman_kerja_perusahaan_4_mcu:
              existingData.pengalaman_kerja_perusahaan_4_mcu || "",

            pengalaman_kerja_jabatan_1_mcu:
              existingData.pengalaman_kerja_jabatan_1_mcu || "",
            pengalaman_kerja_jabatan_2_mcu:
              existingData.pengalaman_kerja_jabatan_2_mcu || "",
            pengalaman_kerja_jabatan_3_mcu:
              existingData.pengalaman_kerja_jabatan_3_mcu || "",
            pengalaman_kerja_jabatan_4_mcu:
              existingData.pengalaman_kerja_jabatan_4_mcu || "",

            pengalaman_kerja_tanggal_mulai_1_mcu:
              existingData.pengalaman_kerja_tanggal_mulai_1_mcu || "",
            pengalaman_kerja_tanggal_mulai_2_mcu:
              existingData.pengalaman_kerja_tanggal_mulai_2_mcu || "",
            pengalaman_kerja_tanggal_mulai_3_mcu:
              existingData.pengalaman_kerja_tanggal_mulai_3_mcu || "",
            pengalaman_kerja_tanggal_mulai_4_mcu:
              existingData.pengalaman_kerja_tanggal_mulai_4_mcu || "",

            pengalaman_kerja_tanggal_selesai_1_mcu:
              existingData.pengalaman_kerja_tanggal_selesai_1_mcu || "",
            pengalaman_kerja_tanggal_selesai_2_mcu:
              existingData.pengalaman_kerja_tanggal_selesai_2_mcu || "",
            pengalaman_kerja_tanggal_selesai_3_mcu:
              existingData.pengalaman_kerja_tanggal_selesai_3_mcu || "",
            pengalaman_kerja_tanggal_selesai_4_mcu:
              existingData.pengalaman_kerja_tanggal_selesai_4_mcu || "",

            pengalaman_kerja_kota_1_mcu:
              existingData.pengalaman_kerja_kota_1_mcu || "",
            pengalaman_kerja_kota_2_mcu:
              existingData.pengalaman_kerja_kota_2_mcu || "",
            pengalaman_kerja_kota_3_mcu:
              existingData.pengalaman_kerja_kota_3_mcu || "",
            pengalaman_kerja_kota_4_mcu:
              existingData.pengalaman_kerja_kota_4_mcu || "",

            //state yang dipake di input untuk autofill di form
            // Data Pribadi
            nomor_npwp: existingData.nomor_ktp_mcu || "",
            jenis_kelamin: existingData.jenis_kelamin_mcu || "",
            nomor_ktp: existingData.nomor_ktp_mcu || nik,
            nama_lengkap: existingData.nama_lengkap_mcu || "",
            tempat_lahir: existingData.tempat_lahir_mcu || "",
            nomor_hp: existingData.nomor_hp_mcu || "",
            email: existingData.email_mcu || "",
            agama: agamaMCU || "",
            nomor_rekening_bank: String(rekeningMCU),
            nomor_kartu_bpjs_kesehatan:
              existingData.nomor_kartu_bpjs_kesehatan_mcu || "",

            // Data Alamat
            addressDetail: existingData.alamat_ktp_mcu || "",
            ASaddressDetail: existingData.alamat_domisili_mcu || "",

            // Data Pendidikan
            pendidikan_terakhir: existingData.pendidikan_terakhir_mcu || "",
            pendidikan_nama_sekolah:
              existingData.pendidikan_nama_sekolah_mcu || "",
            pendidikan_jurusan: existingData.pendidikan_jurusan_mcu || "",

            // Data Orang Tua
            orang_tua_nama_ayah: existingData.orang_tua_nama_ayah_mcu || "",
            orang_tua_tempat_lahir_ayah:
              existingData.orang_tua_tempat_lahir_ayah_mcu || "",
            orang_tua_tanggal_lahir_ayah:
              existingData.orang_tua_tanggal_lahir_ayah_mcu || "",
            orang_tua_nama_ibu: existingData.orang_tua_nama_ibu_mcu || "",
            orang_tua_tempat_lahir_ibu:
              existingData.orang_tua_tempat_lahir_ibu_mcu || "",
            orang_tua_tanggal_lahir_ibu:
              existingData.orang_tua_tanggal_lahir_ibu_mcu || "",

            //kontak darurat
            kontak_darurat_nama: existingData.kontak_darurat_nama_mcu || "",
            kontak_darurat_hubungan:
              existingData.kontak_darurat_hubungan_mcu || "",
            kontak_darurat_no_telepon:
              existingData.kontak_darurat_no_telepon_mcu || "",

            //pengalaman pekerjaan
            pengalaman_kerja_perusahaan_1:
              existingData.pengalaman_kerja_perusahaan_1_mcu || "",
            pengalaman_kerja_perusahaan_2:
              existingData.pengalaman_kerja_perusahaan_2_mcu || "",
            pengalaman_kerja_perusahaan_3:
              existingData.pengalaman_kerja_perusahaan_3_mcu || "",

            pengalaman_kerja_jabatan_1:
              existingData.pengalaman_kerja_jabatan_1_mcu || "",
            pengalaman_kerja_jabatan_2:
              existingData.pengalaman_kerja_jabatan_2_mcu || "",
            pengalaman_kerja_jabatan_3:
              existingData.pengalaman_kerja_jabatan_3_mcu || "",

            pengalaman_kerja_tanggal_mulai_1:
              existingData.pengalaman_kerja_tanggal_mulai_1_mcu || "",
            pengalaman_kerja_tanggal_mulai_2:
              existingData.pengalaman_kerja_tanggal_mulai_2_mcu || "",
            pengalaman_kerja_tanggal_mulai_3:
              existingData.pengalaman_kerja_tanggal_mulai_3_mcu || "",

            pengalaman_kerja_tanggal_selesai_1:
              existingData.pengalaman_kerja_tanggal_selesai_1_mcu || "",
            pengalaman_kerja_tanggal_selesai_2:
              existingData.pengalaman_kerja_tanggal_selesai_2_mcu || "",
            pengalaman_kerja_tanggal_selesai_3:
              existingData.pengalaman_kerja_tanggal_selesai_3_mcu || "",

            pengalaman_kerja_kota_1:
              existingData.pengalaman_kerja_kota_1_mcu || "",
            pengalaman_kerja_kota_2:
              existingData.pengalaman_kerja_kota_2_mcu || "",
            pengalaman_kerja_kota_3:
              existingData.pengalaman_kerja_kota_3_mcu || "",
          },
          () => {
            // Reuse dokumen yang sudah di-fetch di cekLogin (hemat 1 query)
            this.getPreviousData(doc);
            if (rekeningMCU && rekeningMCU.toString().trim() !== "") {
              console.log("🔄 Triggering rekening validation for MCU data");

              // Auto-detect bank berdasarkan panjang rekening MCU
              const rekeningLength = rekeningMCU.toString().length;
              let detectedBank = bank;

              if (isNonstaffStatus(status_karyawan) && bank === "") {
                if (rekeningLength === 10) {
                  detectedBank = "mas";
                } else if (rekeningLength === 13) {
                  detectedBank = "mandiri";
                }

                if (detectedBank !== "") {
                  console.log(
                    `🤖 Auto-detected bank: ${detectedBank} based on MCU rekening length`,
                  );
                  this.setState({ selected_bank: detectedBank });
                }
              }

              // Trigger validasi setelah delay
              setTimeout(() => {
                const syntheticEvent = {
                  target: {
                    value: String(rekeningMCU),
                    name: "nomor_rekening_bank",
                  },
                };
                this.validateRekeningBank(syntheticEvent);
              }, 200);
            }

            // ✅ PERBAIKAN: Update submit button status setelah semua data ready dengan debounce
            this.debouncedUpdateSubmitButtonStatus();
          },
        );

        // Simpan docId agar autosave tidak perlu query/get ulang
        try {
          lStorage[0].docId = docId;
          localStorage.setItem("id", JSON.stringify(lStorage));
        } catch (err) {
          console.warn("Gagal simpan docId ke localStorage:", err);
        }
      } else {
        console.log("ℹ️ Data employee belum ada di Firebase");

        this.setState({
          nik: lStorage[0].nik,
          status_karyawan: status_karyawan,
          tanggal_lahir: tanggal_lahir_raw,
          tanggal_lahir_formatted: tanggal_lahir_formatted,
          username_admin: username_admin,

          //state untuk mcu yang akan untuk patokan validasi
          // Data Pribadi MCU
          nomor_npwp_mcu: "",
          jenis_kelamin_mcu: "",
          nomor_ktp_mcu: nik,
          nama_lengkap_mcu: "",
          tempat_lahir_mcu: "",
          nomor_hp_mcu: "",
          email_mcu: "",
          agama_mcu: "",
          nomor_rekening_bank_mcu: "",
          nomor_kartu_bpjs_kesehatan_mcu: "",

          // Data Alamat MCU
          addressDetail_mcu: "",
          ASaddressDetail_mcu: "",

          // Data Pendidikan MCU
          pendidikan_terakhir_mcu: "",
          pendidikan_nama_sekolah_mcu: "",
          pendidikan_jurusan_mcu: "",

          // Data Orang Tua MCU
          orang_tua_nama_ayah_mcu: "",
          orang_tua_tempat_lahir_ayah_mcu: "",
          orang_tua_tanggal_lahir_ayah_mcu: "",
          orang_tua_nama_ibu_mcu: existingData.orang_tua_nama_ibu_mcu || "",
          orang_tua_tempat_lahir_ibu_mcu:
            existingData.orang_tua_tempat_lahir_ibu_mcu || "",
          orang_tua_tanggal_lahir_ibu_mcu: "",
        });
      }
    }
  };

  getPreviousData = async (prefetchedDoc = null) => {
    try {
      let doc = prefetchedDoc;

      if (!doc) {
        const id = localStorage.getItem("id");
        if (!id) return;

        const lStorage = JSON.parse(id);
        if (lStorage[0] && lStorage[0].docId) {
          doc = await this.ref.doc(lStorage[0].docId).get();
          if (!doc.exists) {
            doc = null;
          }
        }

        if (!doc) {
          const nik = lStorage[0].nik;
          const tanggal_lahir = lStorage[0].tanggal_lahir;
          const snapshot = await this.ref
            .where("nik", "==", nik)
            .where("tanggal_lahir", "==", tanggal_lahir)
            .get();

          if (snapshot.empty) return;
          doc = snapshot.docs[0];
          try {
            lStorage[0].docId = doc.id;
            localStorage.setItem("id", JSON.stringify(lStorage));
          } catch (err) {
            console.warn("Gagal simpan docId:", err);
          }
        }
      }

      const data = typeof doc.data === "function" ? doc.data() : doc;
      if (!data) return;

        // Mapping data ke state yang ada
        this.setState(
          {
            username_admin: data.username_admin || "",
            form_1_submitted: data.form_1_submitted || "",
            form_2_submitted: data.form_2_submitted || "",
            nik: data.nik || "",
            golongan_darah: data.golongan_darah || "",
            foto_pribadi_label: data.foto_pribadi_label || null,
            fotoFile: null,
            fotoUrl: data.foto_url || null,
            foto_pribadi_status:
              typeof data.foto_url === "string" && data.foto_url.trim() !== ""
                ? "Upload selesai"
                : "",
            ktpFile: null,
            ktpUrl: data.ktp_url || null,
            foto_ktp_status:
              data.ktp_url && data.ktp_url.trim() !== ""
                ? "Upload selesai"
                : "",
            npwpFile: null,
            npwpUrl: data.npwp_url || null,
            foto_npwp_status:
              data.npwp_url && data.npwp_url.trim() !== ""
                ? "Upload selesai"
                : "",
            kkFile: null,
            kkUrl: data.kk_url || null,
            foto_kk_status:
              data.kk_url && data.kk_url.trim() !== "" ? "Upload selesai" : "",
            cvFile: null,
            cvUrl: data.cv_url || null,
            foto_cv_status:
              data.cv_url && data.cv_url.trim() !== "" ? "Upload selesai" : "",
            foto_url: data.foto_url || "",
            ktp_url: data.ktp_url || "",
            npwp_url: data.npwp_url || "",
            kk_url: data.kk_url || "",
            cv_url: data.cv_url || "",
            foto_validate_by_ocr: data.foto_validate_by_ocr === true,
            ktp_validate_by_ocr: data.ktp_validate_by_ocr === true,
            npwp_validate_by_ocr: data.npwp_validate_by_ocr === true,
            kk_validate_by_ocr: data.kk_validate_by_ocr === true,
            cv_validate_by_ocr: data.cv_validate_by_ocr === true,
            trial: data.trial === true,
            npwp_pemadanan_checked: data.npwp_pemadanan_checked || false,
            foto_npwp_label: data.foto_npwp_label || null,
            foto_kk_label: data.foto_kk_label || null,
            foto_cv_label: data.foto_cv_label || null,
            selected_bank: data.selected_bank || "",
            rekening_error: data.rekening_error || "",
            nomor_rekening_bank: data.nomor_rekening_bank || "",
            nama_sertifikasi_1: data.nama_sertifikasi_1 || "",
            nama_sertifikasi_2: data.nama_sertifikasi_2 || "",
            nama_sertifikasi_3: data.nama_sertifikasi_3 || "",
            nama_sertifikasi_4: data.nama_sertifikasi_4 || "",
            lembaga_pemberi_1: data.lembaga_pemberi_1 || "",
            lembaga_pemberi_2: data.lembaga_pemberi_2 || "",
            lembaga_pemberi_3: data.lembaga_pemberi_3 || "",
            lembaga_pemberi_4: data.lembaga_pemberi_4 || "",
            foto_sertifikasi_training_1: data.foto_sertifikasi_training_1 || "",
            foto_sertifikasi_training_1_status:
              data.foto_sertifikasi_training_1_status || "",
            foto_sertifikasi_training_1_label:
              data.foto_sertifikasi_training_1_label || null,
            sertifikasiTraining1File: null,
            sertifikasiTraining1Url: data.sertifikasiTraining1Url || null,
            sertifikasi_training_1_url: data.sertifikasi_training_1_url || "",
            foto_sertifikasi_training_2: data.foto_sertifikasi_training_2 || "",
            foto_sertifikasi_training_2_status:
              data.foto_sertifikasi_training_2_status || "",
            foto_sertifikasi_training_2_label:
              data.foto_sertifikasi_training_2_label || null,
            sertifikasiTraining2File: null,
            sertifikasiTraining2Url: data.sertifikasiTraining2Url || null,
            sertifikasi_training_2_url: data.sertifikasi_training_2_url || "",
            foto_sertifikasi_training_3: data.foto_sertifikasi_training_3 || "",
            foto_sertifikasi_training_3_status:
              data.foto_sertifikasi_training_3_status || "",
            foto_sertifikasi_training_3_label:
              data.foto_sertifikasi_training_3_label || null,
            sertifikasiTraining3File: null,
            sertifikasiTraining3Url: data.sertifikasiTraining3Url || null,
            sertifikasi_training_3_url: data.sertifikasi_training_3_url || "",
            foto_sertifikasi_training_4: data.foto_sertifikasi_training_4 || "",
            foto_sertifikasi_training_4_status:
              data.foto_sertifikasi_training_4_status || "",
            foto_sertifikasi_training_4_label:
              data.foto_sertifikasi_training_4_label || null,
            sertifikasiTraining4File: null,
            sertifikasiTraining4Url: data.sertifikasiTraining4Url || null,
            sertifikasi_training_4_url: data.sertifikasi_training_4_url || "",
            pengalaman_kerja_perusahaan: data.pengalaman_kerja_perusahaan || [],
            alamatDisabled: true,
            ASalamatDisabled: true,
            provincesData: this.state.provincesData,
            regenciesData: this.state.regenciesData,
            districtsData: this.state.districtsData,
            villagesData: this.state.villagesData,
            province: data.province || "",
            provinceName: data.provinceName || "",
            regency: data.regency || "",
            regencyName: data.regencyName || "",
            district: data.district || "",
            districtName: data.districtName || "",
            village: data.village || "",
            villageName: data.villageName || "",
            addressDetail: data.addressDetail || "",
            ASprovincesData: this.state.ASprovincesData,
            ASregenciesData: this.state.ASregenciesData,
            ASdistrictsData: this.state.ASdistrictsData,
            ASvillagesData: this.state.ASvillagesData,
            ASprovince: data.ASprovince || "",
            ASregency: data.ASregency || "",
            ASdistrict: data.ASdistrict || "",
            ASvillage: data.ASvillage || "",
            ASaddressDetail: data.ASaddressDetail || "",
            nomor_ktp: data.nik || "",
            nama_lengkap: data.nama_lengkap || "",
            nomor_kk: data.nomor_kk || "",
            nomor_npwp: data.nomor_npwp || "",
            alamatSesuaiKtp:
              data.alamatSesuaiKtp !== undefined ? data.alamatSesuaiKtp : true,
            agama: data.agama || "",
            jenis_kelamin: data.jenis_kelamin || "",
            tempat_lahir: data.tempat_lahir || "",
            tanggal_lahir: data.tanggal_lahir || "",
            tanggal_lahir_formatted:
              this.ddmmyyyyToYyyyMmDd(data.tanggal_lahir || "") ||
              this.state.tanggal_lahir_formatted ||
              "",
            tanggal_masuk: data.tanggal_masuk || this.currentDate(),
            status_perdata:
              this.state.status_karyawan === "nonstaff helper" &&
              data.status_perdata === "Menikah"
                ? ""
                : data.status_perdata || "Belum Menikah",
            nama_pasangan: data.nama_pasangan || "",
            tempat_pernikahan: data.tempat_pernikahan || "",
            tanggal_pernikahan: data.tanggal_pernikahan || "",
            tempat_lahir_pasangan: data.tempat_lahir_pasangan || "",
            tanggal_lahir_pasangan: data.tanggal_lahir_pasangan || "",
            pekerjaan_pasangan: data.pekerjaan_pasangan || "",
            tempat_pasangan_bekerja: data.tempat_pasangan_bekerja || "",
            pengalaman_kerja_perusahaan_1:
              data.pengalaman_kerja_perusahaan_1 || "",
            pengalaman_kerja_perusahaan_2:
              data.pengalaman_kerja_perusahaan_2 || "",
            pengalaman_kerja_perusahaan_3:
              data.pengalaman_kerja_perusahaan_3 || "",
            pengalaman_kerja_perusahaan_4:
              data.pengalaman_kerja_perusahaan_4 || "",
            pengalaman_kerja_jabatan_1: data.pengalaman_kerja_jabatan_1 || "",
            pengalaman_kerja_jabatan_2: data.pengalaman_kerja_jabatan_2 || "",
            pengalaman_kerja_jabatan_3: data.pengalaman_kerja_jabatan_3 || "",
            pengalaman_kerja_jabatan_4: data.pengalaman_kerja_jabatan_4 || "",
            pengalaman_kerja_tanggal_mulai_1:
              data.pengalaman_kerja_tanggal_mulai_1 || "",
            pengalaman_kerja_tanggal_mulai_2:
              data.pengalaman_kerja_tanggal_mulai_2 || "",
            pengalaman_kerja_tanggal_mulai_3:
              data.pengalaman_kerja_tanggal_mulai_3 || "",
            pengalaman_kerja_tanggal_mulai_4:
              data.pengalaman_kerja_tanggal_mulai_4 || "",
            pengalaman_kerja_tanggal_selesai_1:
              data.pengalaman_kerja_tanggal_selesai_1 || "",
            pengalaman_kerja_tanggal_selesai_2:
              data.pengalaman_kerja_tanggal_selesai_2 || "",
            pengalaman_kerja_tanggal_selesai_3:
              data.pengalaman_kerja_tanggal_selesai_3 || "",
            pengalaman_kerja_tanggal_selesai_4:
              data.pengalaman_kerja_tanggal_selesai_4 || "",
            pengalaman_kerja_kota_1: data.pengalaman_kerja_kota_1 || "",
            pengalaman_kerja_kota_2: data.pengalaman_kerja_kota_2 || "",
            pengalaman_kerja_kota_3: data.pengalaman_kerja_kota_3 || "",
            pengalaman_kerja_kota_4: data.pengalaman_kerja_kota_4 || "",
            orang_tua_nama_ayah: data.orang_tua_nama_ayah || "",
            orang_tua_nama_ibu: data.orang_tua_nama_ibu || "",
            kontak_darurat_nama: data.kontak_darurat_nama || "",
            kontak_darurat_hubungan: data.kontak_darurat_hubungan || "",
            kontak_darurat_no_telepon: data.kontak_darurat_no_telepon || "",
            anak_anak_nama_1: data.anak_anak_nama_1 || "",
            anak_anak_jenis_kelamin_1: data.anak_anak_jenis_kelamin_1 || "",
            anak_anak_tempat_lahir_1: data.anak_anak_tempat_lahir_1 || "",
            anak_anak_tanggal_lahir_1: data.anak_anak_tanggal_lahir_1 || "",
            anak_anak_nama_2: data.anak_anak_nama_2 || "",
            anak_anak_jenis_kelamin_2: data.anak_anak_jenis_kelamin_2 || "",
            anak_anak_tempat_lahir_2: data.anak_anak_tempat_lahir_2 || "",
            anak_anak_tanggal_lahir_2: data.anak_anak_tanggal_lahir_2 || "",
            anak_anak_nama_3: data.anak_anak_nama_3 || "",
            anak_anak_jenis_kelamin_3: data.anak_anak_jenis_kelamin_3 || "",
            anak_anak_tempat_lahir_3: data.anak_anak_tempat_lahir_3 || "",
            anak_anak_tanggal_lahir_3: data.anak_anak_tanggal_lahir_3 || "",
            anak_anak_nama_4: data.anak_anak_nama_4 || "",
            anak_anak_jenis_kelamin_4: data.anak_anak_jenis_kelamin_4 || "",
            anak_anak_tempat_lahir_4: data.anak_anak_tempat_lahir_4 || "",
            anak_anak_tanggal_lahir_4: data.anak_anak_tanggal_lahir_4 || "",
            orang_tua_tempat_lahir_ayah: data.orang_tua_tempat_lahir_ayah || "",
            orang_tua_tanggal_lahir_ayah:
              data.orang_tua_tanggal_lahir_ayah || "",
            orang_tua_tempat_lahir_ibu: data.orang_tua_tempat_lahir_ibu || "",
            orang_tua_tanggal_lahir_ibu: data.orang_tua_tanggal_lahir_ibu || "",
            saudara_kandung_nama_1: data.saudara_kandung_nama_1 || "",
            saudara_kandung_jenis_kelamin_1:
              data.saudara_kandung_jenis_kelamin_1 || "",
            saudara_kandung_tempat_lahir_1:
              data.saudara_kandung_tempat_lahir_1 || "",
            saudara_kandung_tanggal_lahir_1:
              data.saudara_kandung_tanggal_lahir_1 || "",
            saudara_kandung_nama_2: data.saudara_kandung_nama_2 || "",
            saudara_kandung_jenis_kelamin_2:
              data.saudara_kandung_jenis_kelamin_2 || "",
            saudara_kandung_tempat_lahir_2:
              data.saudara_kandung_tempat_lahir_2 || "",
            saudara_kandung_tanggal_lahir_2:
              data.saudara_kandung_tanggal_lahir_2 || "",
            saudara_kandung_nama_3: data.saudara_kandung_nama_3 || "",
            saudara_kandung_jenis_kelamin_3:
              data.saudara_kandung_jenis_kelamin_3 || "",
            saudara_kandung_tempat_lahir_3:
              data.saudara_kandung_tempat_lahir_3 || "",
            saudara_kandung_tanggal_lahir_3:
              data.saudara_kandung_tanggal_lahir_3 || "",
            saudara_kandung_nama_4: data.saudara_kandung_nama_4 || "",
            saudara_kandung_jenis_kelamin_4:
              data.saudara_kandung_jenis_kelamin_4 || "",
            saudara_kandung_tempat_lahir_4:
              data.saudara_kandung_tempat_lahir_4 || "",
            saudara_kandung_tanggal_lahir_4:
              data.saudara_kandung_tanggal_lahir_4 || "",
            mertua_nama_ayah: data.mertua_nama_ayah || "",
            mertua_tempat_lahir_ayah: data.mertua_tempat_lahir_ayah || "",
            mertua_tanggal_lahir_ayah: data.mertua_tanggal_lahir_ayah || "",
            mertua_nama_ibu: data.mertua_nama_ibu || "",
            mertua_tempat_lahir_ibu: data.mertua_tempat_lahir_ibu || "",
            mertua_tanggal_lahir_ibu: data.mertua_tanggal_lahir_ibu || "",
            nomor_kartu_bpjs_kesehatan: data.nomor_kartu_bpjs_kesehatan || "",
            nomor_kartu_bpjs_ketenagakerjaan:
              data.nomor_kartu_bpjs_ketenagakerjaan || "",
            keterangan_kartu_bpjs_kesehatan:
              data.keterangan_kartu_bpjs_kesehatan || "Belum Dapat",
            keterangan_kartu_bpjs_ketenagakerjaan:
              data.keterangan_kartu_bpjs_ketenagakerjaan || "Belum Dapat",
            jenis_vaksin: data.jenis_vaksin || "",
            tanggal_vaksin_1: data.tanggal_vaksin_1 || "",
            lokasi_vaksin_1: data.lokasi_vaksin_1 || "",
            tanggal_vaksin_2: data.tanggal_vaksin_2 || "",
            lokasi_vaksin_2: data.lokasi_vaksin_2 || "",
            tanggal_vaksin_3: data.tanggal_vaksin_3 || "",
            lokasi_vaksin_3: data.lokasi_vaksin_3 || "",
            email: data.email || "",
            nomor_hp: data.nomor_hp || "",
            sosmed_facebook: data.sosmed_facebook || "",
            sosmed_twitter: data.sosmed_twitter || "",
            sosmed_linkedin: data.sosmed_linkedin || "",
            sosmed_instagram: data.sosmed_instagram || "",
            agreement: data.agreement || false,
            submiting: false,
            isFormValid: false,
            pendidikan_terakhir: data.pendidikan_terakhir || "",
            pendidikan_nama_sekolah: data.pendidikan_nama_sekolah || "",
            pendidikan_jurusan: data.pendidikan_jurusan || "",
            pendidikan_kursus: data.pendidikan_kursus || "",
          },
          () => {
            // ✅ PERBAIKAN: Update submit button status setelah state terupdate dengan debounce
            this.debouncedUpdateSubmitButtonStatus();
          },
        );
    } catch (error) {
      console.error("❌ Error fetching employee data:", error);
    }
  };

  handleLogout = () => {
    localStorage.removeItem("id");
    this.props.history.push("/");
  };

  canOpenForm3 = () => {
    try {
      const stored = JSON.parse(localStorage.getItem("id") || "[]")[0] || {};
      const form1 =
        this.state.form_1_submitted || stored.form_1_submitted || "";
      const form2 =
        this.state.form_2_submitted || stored.form_2_submitted || "";
      return form1 === "diisi" && form2 === "diisi";
    } catch (err) {
      return false;
    }
  };

  goToForm1 = (e) => {
    if (e) e.preventDefault();
    this.flushAutosave();
    this.props.history.push("/form");
  };

  goToForm2 = (e) => {
    if (e) e.preventDefault();
    this.flushAutosave();
    this.props.history.push("/form-2");
  };

  goToForm3 = (e) => {
    if (e) e.preventDefault();
    if (!this.canOpenForm3()) return;
    this.flushAutosave();
    this.props.history.push("/form-3");
  };

  getProvinces = async () => {
    try {
      // let response = await API.get("/provinces/all");
      const provincesData = dataProvinsi;
      // if (response.status !== 200) {
      //   alert("Failed to load provices");
      //   window.location.reload();
      // }
      this.setState({
        provincesData: provincesData,
        ASprovincesData: provincesData,
      });

      // console.log(response.data.data);
    } catch (e) {
      console.log(`Data provinces not found : ${e}`);
    }
  };

  getRegencies = async (province_id) => {
    try {
      // let response = await API.get("/regencies/by-province/" + province_id);
      const regenciesData = dataKabupaten.filter((kabupaten) => {
        return kabupaten.province_id === province_id;
      });
      // if (response.status !== 200) {
      //   alert("Failed to load regency");
      //   // window.location.reload();
      // }
      this.setState({
        regenciesData: regenciesData,
      });

      // console.log(response.data.data);
    } catch (e) {
      console.log(`Data regencies not found : ${e}`);
    }
  };

  ASgetRegencies = async (province_id) => {
    try {
      // let response = await API.get("/regencies/by-province/" + province_id);
      // if (response.status !== 200) {
      //   alert("Failed to load regency");
      //   // window.location.reload();
      // }

      const regenciesData = dataKabupaten.filter((kabupaten) => {
        return kabupaten.province_id === province_id;
      });

      this.setState({
        ASregenciesData: regenciesData,
      });

      // console.log(response.data.data);
    } catch (e) {
      console.log(`Data regencies not found : ${e}`);
    }
  };

  getDistricts = async (regency_id) => {
    try {
      // let response = await API.get("/districts/by-regency/" + regency_id);
      // if (response.status !== 200) {
      //   alert("Failed to load districts");
      //   // window.location.reload();
      // }

      const districtsData = dataKecamatan.filter((kecamatan) => {
        return kecamatan.regency_id === regency_id;
      });

      this.setState({
        districtsData: districtsData,
      });

      // console.log(response.data.data);
    } catch (e) {
      console.log(`Data districts not found : ${e}`);
    }
  };

  ASgetDistricts = async (regency_id) => {
    try {
      const districtsData = dataKecamatan.filter((kecamatan) => {
        return kecamatan.regency_id === regency_id;
      });

      this.setState({
        ASdistrictsData: districtsData,
      });

      // console.log(response.data.data);
    } catch (e) {
      console.log(`Data districts not found : ${e}`);
    }
  };

  getVillages = async (district_id) => {
    try {
      const villagesData = dataDesa.filter((desa) => {
        return desa.district_id === district_id;
      });

      this.setState({
        villagesData: villagesData,
      });

      // console.log(response.data.data);
    } catch (e) {
      console.log(`Data villages not found : ${e}`);
    }
  };

  ASgetVillages = async (district_id) => {
    try {
      const villagesData = dataDesa.filter((desa) => {
        return desa.district_id === district_id;
      });

      this.setState({
        ASvillagesData: villagesData,
      });

      // console.log(response.data.data);
    } catch (e) {
      console.log(`Data villages not found : ${e}`);
    }
  };

  onStatusPerdataChange = (e) => {
    const value = e.target.value;
    if (
      this.state.status_karyawan === "nonstaff helper" &&
      value === "Menikah"
    ) {
      Swal.fire({
        icon: "warning",
        title: "Status perkawinan tidak sesuai",
        text: "Status perkawinan nonstaff helper harus belum kawin.",
        confirmButtonText: "Oke",
      });
      return;
    }
    this.onChange(e);
  };

  onChange = (e) => {
    console.log("📝 Field changed:", e.target.name, "=", e.target.value); // ✅ DEBUG

    const fieldName = e.target.name;
    const fieldValue = e.target.value;

    // ✅ PERBAIKAN: Gunakan functional setState dan debounced validation
    this.setState(
      {
        [fieldName]: fieldValue,
      },
      () => {
        // ✅ TRIGGER: Update status button setelah state berubah dengan debounce
        this.debouncedUpdateSubmitButtonStatus();
        this.queueAutosave({ [fieldName]: fieldValue });
      },
    );
  };

  /** ddmmyyyy → yyyy-mm-dd untuk input type="date" */
  ddmmyyyyToYyyyMmDd = (raw) => {
    if (!raw || typeof raw !== "string" || raw.length !== 8) return "";
    const day = raw.substring(0, 2);
    const month = raw.substring(2, 4);
    const year = raw.substring(4, 8);
    const d = parseInt(day, 10);
    const m = parseInt(month, 10);
    const y = parseInt(year, 10);
    if (
      d < 1 ||
      d > 31 ||
      m < 1 ||
      m > 12 ||
      y < 1900 ||
      y > new Date().getFullYear()
    ) {
      return "";
    }
    return `${year}-${month}-${day}`;
  };

  /** yyyy-mm-dd → ddmmyyyy untuk Firestore / localStorage */
  yyyyMmDdToDdmmyyyy = (yyyyMmDd) => {
    if (!yyyyMmDd || typeof yyyyMmDd !== "string" || yyyyMmDd.length !== 10) {
      return "";
    }
    const parts = yyyyMmDd.split("-");
    if (parts.length !== 3) return "";
    const [y, m, d] = parts;
    if (!y || !m || !d || y.length !== 4) return "";
    return `${d}${m}${y}`;
  };

  onTanggalLahirChange = (e) => {
    const yyyyMmDd = e.target.value;
    const ddmmyyyy = this.yyyyMmDdToDdmmyyyy(yyyyMmDd);
    this.setState(
      {
        tanggal_lahir: ddmmyyyy,
        tanggal_lahir_formatted: yyyyMmDd,
      },
      () => {
        try {
          const raw = localStorage.getItem("id");
          if (raw) {
            const arr = JSON.parse(raw);
            if (arr && arr[0]) {
              arr[0].tanggal_lahir = ddmmyyyy;
              localStorage.setItem("id", JSON.stringify(arr));
            }
          }
        } catch (err) {
          console.error("Update tanggal_lahir di localStorage:", err);
        }
        this.debouncedUpdateSubmitButtonStatus();
        this.queueAutosave({
          tanggal_lahir: ddmmyyyy,
        });
      },
    );
  };

  onRadioChange = (e) => {
    const fieldName = e.target.name;
    const newValue = e.target.value;

    console.log(`📝 Radio changed: ${fieldName} = ${newValue}`);

    // ✅ PERBAIKAN: Gunakan functional setState dan debounced validation
    this.setState(
      {
        [fieldName]: newValue,
      },
      () => {
        // ✅ STEP 2: Setelah state terupdate, lakukan validasi dengan debounce
        this.validateFieldChangeWithSwal(fieldName, newValue);
        this.debouncedUpdateSubmitButtonStatus();
        this.queueAutosave({ [fieldName]: newValue });
      },
    );
  };

  onCheckboxChange = (e) => {
    const fieldName = e.target.name;
    const isChecked = e.target.checked;

    console.log(`☑️ Checkbox changed: ${fieldName} = ${isChecked}`);

    // ✅ PERBAIKAN: Update state berdasarkan nama checkbox dengan debounced validation
    if (fieldName === "npwp-pemadanan-checklist") {
      this.setState(
        {
          npwp_pemadanan_checked: isChecked,
        },
        () => {
          // ✅ Update submit button status setelah checkbox berubah dengan debounce
          this.debouncedUpdateSubmitButtonStatus();
          this.queueAutosave({ npwp_pemadanan_checked: isChecked });
        },
      );
    }
    // ✅ BISA DITAMBAH: Handler untuk checkbox lain jika ada
    else {
      console.log(`⚠️ Unknown checkbox: ${fieldName}`);
    }
  };

  // ✅ TAMBAH: Handler untuk perubahan pilihan bank (khusus nonstaff)
  onBankChange = (e) => {
    const selectedBank = e.target.value;

    console.log("🏦 Bank selection changed:", {
      from: this.state.selected_bank,
      to: selectedBank,
      status_karyawan: this.state.status_karyawan,
    });

    // ✅ PERBAIKAN: Gunakan debounced validation
    this.setState(
      {
        selected_bank: selectedBank,
        nomor_rekening_bank: "", // Reset nomor rekening saat ganti bank
        rekening_error: "", // Reset error
      },
      () => {
        // Update submit button status setelah bank berubah dengan debounce
        this.debouncedUpdateSubmitButtonStatus();
        this.queueAutosave({
          selected_bank: selectedBank,
          nomor_rekening_bank: "",
        });
      },
    );
  };

  selectFotoPribadi = (e) => {
    // ✅ TAMBAH: Cek apakah ada file yang dipilih
    if (!e.target.files || e.target.files.length === 0) {
      console.log("❌ No file selected");
      return;
    }

    const file = e.target.files[0];

    // ✅ TAMBAH: Double check file ada
    if (!file) {
      console.log("❌ File is undefined");
      return;
    }

    // ✅ VALIDASI: Cek apakah file adalah gambar
    if (!this.validateImageFile(file)) {
      alert(
        "❌ Mohon maaf, hanya file gambar (JPG, JPEG, PNG) yang diperbolehkan!",
      );
      // Reset input file
      e.target.value = "";
      this.setState({
        foto_pribadi_status: "File harus berupa gambar",
      });
      return;
    }

    // ✅ TAMBAH: Validasi ukuran file
    if (!file.size) {
      alert("❌ File tidak valid atau rusak");
      e.target.value = "";
      this.setState({
        foto_pribadi_status: "File tidak valid",
      });
      return;
    }

    // Batasi ukuran file hanya 3 MB
    var FileSize = file.size / 1024 / 1024; // in MiB
    if (FileSize > 3) {
      alert("Mohon maaf, ukuran file tidak boleh lebih dari 3 MiB");
      this.setState({
        foto_pribadi_status: "Melebihi ukuran maksimal",
      });
      return; // ✅ TAMBAH: return untuk stop eksekusi
    }

    // ✅ Lanjutkan dengan proses upload jika semua validasi lolos
    this.setState({
      fotoFile: file,
      foto_pribadi_label: file.name,
      foto_pribadi_status: "Uploading...",
    });

    const fileReader = new FileReader();
    fileReader.onloadend = () => {
      this.setState({ fotoFile: file, fotoUrl: fileReader.result });
    };

    if (file) {
      fileReader.readAsDataURL(file);
    }

    const file_name = Date.now() + "-" + file.name;
    const folder_name =
      this.state.tanggal_masuk.split("-")[0] +
      this.state.tanggal_masuk.split("-")[1];
    const uploadTask = storage.ref(`${folder_name}/${file_name}`).put(file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
        );
        console.log(progress);
      },
      (error) => {
        console.log(error);
        this.setState({
          foto_pribadi_status: "Upload gagal",
        });
      },
      () => {
        storage
          .ref(`${folder_name}`)
          .child(file_name)
          .getDownloadURL()
          .then((url) => {
            console.log("URL " + url);
            // ✅ PERBAIKAN: Gunakan callback setState untuk memastikan state terupdate sebelum validasi
            this.setState(
              {
                foto_url: url,
                foto_pribadi_status: "Upload selesai",
              },
              () => {
                // ✅ TAMBAH: Simpan URL langsung ke database setelah upload
                this.saveFileUrlToDatabase("foto_url", url);
                this.updateSubmitButtonStatus(); // Langsung validasi karena upload sudah selesai
              },
            );
          })
          .catch((error) => {
            console.error("Error getting download URL:", error);
            this.setState({
              foto_pribadi_status: "Upload gagal",
            });
          });
      },
    );
  };

  selectFotoKTP = (e) => {
    // ✅ TAMBAH: Cek apakah ada file yang dipilih
    if (!e.target.files || e.target.files.length === 0) {
      console.log("❌ No file selected");
      return;
    }

    const file = e.target.files[0];

    // ✅ TAMBAH: Double check file ada
    if (!file) {
      console.log("❌ File is undefined");
      return;
    }

    // ✅ VALIDASI: Cek apakah file adalah gambar
    if (!this.validateImageFile(file)) {
      alert(
        "❌ Mohon maaf, hanya file gambar (JPG, JPEG, PNG) yang diperbolehkan!",
      );
      // Reset input file
      e.target.value = "";
      this.setState({
        foto_ktp_status: "File harus berupa gambar",
      });
      return;
    }

    // ✅ TAMBAH: Validasi ukuran file
    if (!file.size) {
      alert("❌ File tidak valid atau rusak");
      e.target.value = "";
      this.setState({
        foto_ktp_status: "File tidak valid",
      });
      return;
    }

    // Batasi ukuran file hanya 3 MB
    var FileSize = file.size / 1024 / 1024; // in MiB
    if (FileSize > 3) {
      alert("Mohon maaf, ukuran file tidak boleh lebih dari 3 MiB");
      this.setState({
        foto_ktp_status: "Melebihi ukuran maksimal",
      });
      return; // ✅ TAMBAH: return untuk stop eksekusi
    }

    // ✅ Lanjutkan dengan proses upload jika semua validasi lolos
    this.setState({
      ktpFile: file,
      foto_ktp_label: file.name,
      foto_ktp_status: "Uploading...",
    });

    const fileReader = new FileReader();
    fileReader.onloadend = () => {
      this.setState({ ktpFile: file, ktpUrl: fileReader.result });
    };

    if (file) {
      fileReader.readAsDataURL(file);
    }

    const file_name = Date.now() + "-" + file.name;
    const folder_name =
      this.state.tanggal_masuk.split("-")[0] +
      this.state.tanggal_masuk.split("-")[1];
    const uploadTask = storage.ref(`${folder_name}/${file_name}`).put(file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
        );
        console.log("📸 Upload progress KTP:", progress + "%");
        this.setState({
          foto_ktp_status: `Uploading... ${progress}%`,
        });
      },
      (error) => {
        console.log("❌ Upload error KTP:", error);
        this.setState({
          foto_ktp_status: "Upload gagal",
        });
      },
      () => {
        storage
          .ref(`${folder_name}`)
          .child(file_name)
          .getDownloadURL()
          .then((url) => {
            console.log("✅ KTP URL:", url);
            // ✅ PERBAIKAN: Gunakan callback setState untuk memastikan state terupdate sebelum validasi
            this.setState(
              {
                ktp_url: url,
                foto_ktp_status: "Upload selesai",
              },
              () => {
                // ✅ TAMBAH: Simpan URL langsung ke database setelah upload
                this.saveFileUrlToDatabase("ktp_url", url);
                this.updateSubmitButtonStatus(); // Langsung validasi karena upload sudah selesai
              },
            );
          })
          .catch((error) => {
            console.error("❌ Error getting KTP download URL:", error);
            this.setState({
              foto_ktp_status: "Upload gagal",
            });
          });
      },
    );
  };

  selectFotoNPWP = (e) => {
    // ✅ TAMBAH: Cek apakah ada file yang dipilih
    if (!e.target.files || e.target.files.length === 0) {
      console.log("❌ No file selected");
      return;
    }

    const file = e.target.files[0];

    // ✅ TAMBAH: Double check file ada
    if (!file) {
      console.log("❌ File is undefined");
      return;
    }

    // ✅ VALIDASI: Cek apakah file adalah gambar
    if (!this.validateImageFile(file)) {
      alert(
        "❌ Mohon maaf, hanya file gambar (JPG, JPEG, PNG) yang diperbolehkan!",
      );
      // Reset input file
      e.target.value = "";
      this.setState({
        foto_npwp_status: "File harus berupa gambar",
      });
      return;
    }

    // ✅ TAMBAH: Validasi ukuran file
    if (!file.size) {
      alert("❌ File tidak valid atau rusak");
      e.target.value = "";
      this.setState({
        foto_npwp_status: "File tidak valid",
      });
      return;
    }

    // Batasi ukuran file hanya 3 MB
    var FileSize = file.size / 1024 / 1024; // in MiB
    if (FileSize > 3) {
      alert("Mohon maaf, ukuran file tidak boleh lebih dari 3 MiB");
      this.setState({
        foto_npwp_status: "Melebihi ukuran maksimal",
      });
      return;
    }

    // ✅ Lanjutkan dengan proses upload jika semua validasi lolos
    this.setState({
      npwpFile: file,
      foto_npwp_label: file.name,
      foto_npwp_status: "Uploading...",
    });

    const fileReader = new FileReader();
    fileReader.onloadend = () => {
      this.setState({ npwpFile: file, npwpUrl: fileReader.result });
    };

    if (file) {
      fileReader.readAsDataURL(file);
    }

    const file_name = Date.now() + "-" + file.name;
    const folder_name =
      this.state.tanggal_masuk.split("-")[0] +
      this.state.tanggal_masuk.split("-")[1];
    const uploadTask = storage.ref(`${folder_name}/${file_name}`).put(file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
        );
        console.log("📸 Upload progress NPWP:", progress + "%");
        this.setState({
          foto_npwp_status: `Uploading... ${progress}%`,
        });
      },
      (error) => {
        console.log("❌ Upload error NPWP:", error);
        this.setState({
          foto_npwp_status: "Upload gagal",
        });
      },
      () => {
        storage
          .ref(`${folder_name}`)
          .child(file_name)
          .getDownloadURL()
          .then((url) => {
            console.log("✅ NPWP URL:", url);
            // ✅ PERBAIKAN: Gunakan callback setState untuk memastikan state terupdate sebelum validasi
            this.setState(
              {
                npwp_url: url,
                foto_npwp_status: "Upload selesai",
              },
              () => {
                // ✅ TAMBAH: Simpan URL langsung ke database setelah upload
                this.saveFileUrlToDatabase("npwp_url", url);
                this.updateSubmitButtonStatus(); // Langsung validasi karena upload sudah selesai
              },
            );
          })
          .catch((error) => {
            console.error("❌ Error getting NPWP download URL:", error);
            this.setState({
              foto_npwp_status: "Upload gagal",
            });
          });
      },
    );
  };

  selectFotoKK = (e) => {
    // ✅ TAMBAH: Cek apakah ada file yang dipilih
    if (!e.target.files || e.target.files.length === 0) {
      console.log("❌ No file selected");
      return;
    }

    const file = e.target.files[0];

    // ✅ TAMBAH: Double check file ada
    if (!file) {
      console.log("❌ File is undefined");
      return;
    }

    // ✅ VALIDASI: Cek apakah file adalah gambar
    if (!this.validateImageFile(file)) {
      alert(
        "❌ Mohon maaf, hanya file gambar (JPG, JPEG, PNG) yang diperbolehkan!",
      );
      // Reset input file
      e.target.value = "";
      this.setState({
        foto_kk_status: "File harus berupa gambar",
      });
      return;
    }

    // ✅ TAMBAH: Validasi ukuran file
    if (!file.size) {
      alert("❌ File tidak valid atau rusak");
      e.target.value = "";
      this.setState({
        foto_kk_status: "File tidak valid",
      });
      return;
    }

    // Batasi ukuran file hanya 3 MB
    var FileSize = file.size / 1024 / 1024; // in MiB
    if (FileSize > 3) {
      alert("Mohon maaf, ukuran file tidak boleh lebih dari 3 MiB");
      this.setState({
        foto_kk_status: "Melebihi ukuran maksimal",
      });
      return;
    }

    // ✅ Lanjutkan dengan proses upload jika semua validasi lolos
    this.setState({
      kkFile: file,
      foto_kk_label: file.name,
      foto_kk_status: "Uploading...",
    });

    const fileReader = new FileReader();
    fileReader.onloadend = () => {
      this.setState({ kkFile: file, kkUrl: fileReader.result });
    };

    if (file) {
      fileReader.readAsDataURL(file);
    }

    const file_name = Date.now() + "-" + file.name;
    const folder_name =
      this.state.tanggal_masuk.split("-")[0] +
      this.state.tanggal_masuk.split("-")[1];
    const uploadTask = storage.ref(`${folder_name}/${file_name}`).put(file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
        );
        console.log("📸 Upload progress KK:", progress + "%");
        this.setState({
          foto_kk_status: `Uploading... ${progress}%`,
        });
      },
      (error) => {
        console.log("❌ Upload error KK:", error);
        this.setState({
          foto_kk_status: "Upload gagal",
        });
      },
      () => {
        storage
          .ref(`${folder_name}`)
          .child(file_name)
          .getDownloadURL()
          .then((url) => {
            console.log("✅ KK URL:", url);
            // ✅ PERBAIKAN: Gunakan callback setState untuk memastikan state terupdate sebelum validasi
            this.setState(
              {
                kk_url: url,
                foto_kk_status: "Upload selesai",
              },
              () => {
                // ✅ TAMBAH: Simpan URL langsung ke database setelah upload
                this.saveFileUrlToDatabase("kk_url", url);
                this.updateSubmitButtonStatus(); // Langsung validasi karena upload sudah selesai
              },
            );
          })
          .catch((error) => {
            console.error("❌ Error getting KK download URL:", error);
            this.setState({
              foto_kk_status: "Upload gagal",
            });
          });
      },
    );
  };

  // selectFotoRekening = (e) => {
  //   // ✅ TAMBAH: Cek apakah ada file yang dipilih
  //   if (!e.target.files || e.target.files.length === 0) {
  //     console.log("❌ No file selected");
  //     return;
  //   }

  //   const file = e.target.files[0];

  //   // ✅ TAMBAH: Double check file ada
  //   if (!file) {
  //     console.log("❌ File is undefined");
  //     return;
  //   }

  //   // ✅ VALIDASI: Cek apakah file adalah gambar
  //   if (!this.validateImageFile(file)) {
  //     alert(
  //       "❌ Mohon maaf, hanya file gambar (JPG, JPEG, PNG) yang diperbolehkan!"
  //     );
  //     // Reset input file
  //     e.target.value = "";
  //     this.setState({
  //       foto_rekening_bank_status: "File harus berupa gambar",
  //     });
  //     return;
  //   }

  //   // ✅ TAMBAH: Validasi ukuran file
  //   if (!file.size) {
  //     alert("❌ File tidak valid atau rusak");
  //     e.target.value = "";
  //     this.setState({
  //       foto_rekening_bank_status: "File tidak valid",
  //     });
  //     return;
  //   }

  //   // Batasi ukuran file hanya 1 MB
  //   var FileSize = file.size / 1024 / 1024; // in MiB
  //   if (FileSize > 1) {
  //     alert("Mohon maaf, ukuran file tidak boleh lebih dari 1 MiB");
  //     this.setState({
  //       foto_rekening_bank_status: "Melebihi ukuran maksimal",
  //     });
  //     return;
  //   }

  //   // ✅ Lanjutkan dengan proses upload jika semua validasi lolos
  //   this.setState({
  //     rekeningBankFile: file,
  //     foto_rekening_bank_label: file.name,
  //     foto_rekening_bank_status: "Uploading...",
  //   });

  //   const fileReader = new FileReader();
  //   fileReader.onloadend = () => {
  //     this.setState({
  //       rekeningBankFile: file,
  //       rekeningBankUrl: fileReader.result,
  //     });
  //   };

  //   if (file) {
  //     fileReader.readAsDataURL(file);
  //   }

  //   const file_name = Date.now() + "-" + file.name;
  //   const folder_name =
  //     this.state.tanggal_masuk.split("-")[0] +
  //     this.state.tanggal_masuk.split("-")[1];
  //   const uploadTask = storage.ref(`${folder_name}/${file_name}`).put(file);

  //   uploadTask.on(
  //     "state_changed",
  //     (snapshot) => {
  //       const progress = Math.round(
  //         (snapshot.bytesTransferred / snapshot.totalBytes) * 100
  //       );
  //       console.log("📸 Upload progress rekening:", progress + "%");
  //       this.setState({
  //         foto_rekening_bank_status: `Uploading... ${progress}%`,
  //       });
  //     },
  //     (error) => {
  //       console.log("❌ Upload error rekening:", error);
  //       this.setState({
  //         foto_rekening_bank_status: "Upload gagal",
  //       });
  //     },
  //     () => {
  //       storage
  //         .ref(`${folder_name}`)
  //         .child(file_name)
  //         .getDownloadURL()
  //         .then((url) => {
  //           console.log("✅ Rekening URL:", url);
  //           this.setState({
  //             rekening_bank_url: url,
  //             foto_rekening_bank_status: "Upload selesai",
  //           });
  //           this.updateSubmitButtonStatus();
  //         })
  //         .catch((error) => {
  //           console.error("❌ Error getting rekening download URL:", error);
  //           this.setState({
  //             foto_rekening_bank_status: "Upload gagal",
  //           });
  //         });
  //     }
  //   );
  // };

  selectFotoCV = (e) => {
    // ✅ TAMBAH: Cek apakah ada file yang dipilih
    if (!e.target.files || e.target.files.length === 0) {
      console.log("❌ No file selected");
      return;
    }

    const file = e.target.files[0];

    // ✅ TAMBAH: Double check file ada
    if (!file) {
      console.log("❌ File is undefined");
      return;
    }

    // ✅ VALIDASI: Cek apakah file adalah PDF
    if (!this.validatePdfFile(file)) {
      alert("❌ Mohon maaf, hanya file PDF yang diperbolehkan untuk CV!");
      // Reset input file
      e.target.value = "";
      this.setState({
        foto_cv_status: "File harus berupa PDF",
      });
      return;
    }

    // ✅ TAMBAH: Validasi ukuran file
    if (!file.size) {
      alert("❌ File tidak valid atau rusak");
      e.target.value = "";
      this.setState({
        foto_cv_status: "File tidak valid",
      });
      return;
    }

    // Batasi ukuran file maksimal 3 MB untuk PDF
    var FileSize = file.size / 1024 / 1024; // in MiB
    if (FileSize > 3) {
      alert("Mohon maaf, ukuran file CV tidak boleh lebih dari 3 MB");
      this.setState({
        foto_cv_status: "Melebihi ukuran maksimal",
      });
      return;
    }

    // ✅ Lanjutkan dengan proses upload jika semua validasi lolos
    this.setState({
      cvFile: file,
      foto_cv_label: file.name,
      foto_cv_status: "Uploading...",
    });

    const file_name = Date.now() + "-" + file.name;
    const folder_name =
      this.state.tanggal_masuk.split("-")[0] +
      this.state.tanggal_masuk.split("-")[1];
    const uploadTask = storage.ref(`${folder_name}/${file_name}`).put(file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
        );
        console.log("📄 Upload progress CV:", progress + "%");
        this.setState({
          foto_cv_status: `Uploading... ${progress}%`,
        });
      },
      (error) => {
        console.log("❌ Upload error CV:", error);
        this.setState({
          foto_cv_status: "Upload gagal",
        });
      },
      () => {
        storage
          .ref(`${folder_name}`)
          .child(file_name)
          .getDownloadURL()
          .then((url) => {
            console.log("✅ CV URL:", url);
            // ✅ PERBAIKAN: Gunakan callback setState untuk memastikan state terupdate sebelum validasi
            this.setState(
              {
                cv_url: url,
                cvUrl: url, // ✅ Set untuk keperluan display
                foto_cv_status: "Upload selesai",
              },
              () => {
                // ✅ TAMBAH: Simpan URL langsung ke database setelah upload
                this.saveFileUrlToDatabase("cv_url", url);
                this.updateSubmitButtonStatus(); // Langsung validasi karena upload sudah selesai
              },
            );
          })
          .catch((error) => {
            console.error("❌ Error getting CV download URL:", error);
            this.setState({
              foto_cv_status: "Upload gagal",
            });
          });
      },
    );
  };

  selectFotoSertifikasiTraining = (object) => (e) => {
    console.log(`Memilih foto sertifikasi training ${object}`);

    // ✅ TAMBAH: Cek apakah ada file yang dipilih
    if (!e.target.files || e.target.files.length === 0) {
      console.log("❌ No file selected");
      return;
    }

    const file = e.target.files[0];

    // ✅ TAMBAH: Double check file ada
    if (!file) {
      console.log("❌ File is undefined");
      return;
    }

    // ✅ VALIDASI: Cek apakah file adalah gambar
    if (!this.validateImageFile(file)) {
      alert(
        "❌ Mohon maaf, hanya file gambar (JPG, JPEG, PNG) yang diperbolehkan!",
      );
      e.target.value = "";
      this.setState({
        [`foto_sertifikasi_training_${object}_status`]:
          "File harus berupa gambar",
      });
      return;
    }

    // ✅ TAMBAH: Validasi ukuran file
    if (!file.size) {
      alert("❌ File tidak valid atau rusak");
      e.target.value = "";
      this.setState({
        [`foto_sertifikasi_training_${object}_status`]: "File tidak valid",
      });
      return;
    }

    // Batasi ukuran file hanya 3 MB
    var FileSize = file.size / 1024 / 1024;
    if (FileSize > 3) {
      alert("Mohon maaf, ukuran file tidak boleh lebih dari 3 MiB");
      this.setState({
        [`foto_sertifikasi_training_${object}_status`]:
          "Melebihi ukuran maksimal",
      });
      return;
    }

    // ✅ Lanjutkan dengan proses upload jika semua validasi lolos
    this.setState({
      [`sertifikasiTraining${object}File`]: file,
      [`foto_sertifikasi_training_${object}_label`]: file.name,
      [`foto_sertifikasi_training_${object}_status`]: "Uploading...",
    });

    const fileReader = new FileReader();
    fileReader.onloadend = () => {
      this.setState({
        [`sertifikasiTraining${object}File`]: file,
        [`sertifikasiTraining${object}Url`]: fileReader.result,
      });
    };

    if (file) {
      fileReader.readAsDataURL(file);
    }

    const file_name = Date.now() + "-" + file.name;
    const folder_name =
      this.state.tanggal_masuk.split("-")[0] +
      this.state.tanggal_masuk.split("-")[1];
    const uploadTask = storage.ref(`${folder_name}/${file_name}`).put(file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
        );
        console.log(
          `📸 Upload progress sertifikasi ${object}:`,
          progress + "%",
        );
        this.setState({
          [`foto_sertifikasi_training_${object}_status`]: `Uploading... ${progress}%`,
        });
      },
      (error) => {
        console.log(`❌ Upload error sertifikasi ${object}:`, error);
        this.setState({
          [`foto_sertifikasi_training_${object}_status`]: "Upload gagal",
        });
      },
      () => {
        storage
          .ref(`${folder_name}`)
          .child(file_name)
          .getDownloadURL()
          .then((url) => {
            console.log(`✅ Sertifikasi ${object} URL:`, url);
            // ✅ PERBAIKAN: Gunakan callback setState untuk memastikan state terupdate sebelum validasi
            this.setState(
              {
                [`sertifikasi_training_${object}_url`]: url,
                [`foto_sertifikasi_training_${object}_status`]:
                  "Upload selesai",
              },
              () => {
                this.updateSubmitButtonStatus(); // Langsung validasi karena upload sudah selesai
              },
            );
          })
          .catch((error) => {
            console.error(
              `❌ Error getting sertifikasi ${object} download URL:`,
              error,
            );
            this.setState({
              [`foto_sertifikasi_training_${object}_status`]: "Upload gagal",
            });
          });
      },
    );
  };

  getStorageFolder = () => {
    const parts = this.state.tanggal_masuk.split("-");
    return parts[0] + parts[1];
  };

  handleOcrPreviewChange = (previewKey, fileKey) => (previewUrl, file) => {
    this.setState({
      [previewKey]: previewUrl,
      [fileKey]: file,
    });
  };

  handleOcrUploadComplete = (urlField, statusField, previewField) => (
    url,
    _file,
    meta = {},
  ) => {
    const validateByOcr = meta.validate_by_ocr === true;
    const validateField = getValidateByOcrFieldName(urlField);
    const updates = {
      [urlField]: url,
      [statusField]: "Upload selesai",
    };
    if (previewField) {
      updates[previewField] = url;
    }
    // Hanya tandai state OCR jika benar-benar tervalidasi
    if (validateField && validateByOcr) {
      updates[validateField] = true;
    } else if (validateField) {
      updates[validateField] = false;
    }
    this.setState(updates, () => {
      this.saveFileUrlToDatabase(urlField, url, {
        validateField,
        validateByOcr,
      });
      this.updateSubmitButtonStatus();
    });
  };

  buildCvEducationQuery = () => {
    const { pendidikan_terakhir, pendidikan_jurusan, pendidikan_nama_sekolah } =
      this.state;
    return [pendidikan_terakhir, pendidikan_jurusan, pendidikan_nama_sekolah]
      .map((value) => (value != null ? String(value).trim() : ""))
      .filter(Boolean)
      .join(" ");
  };

  buildCvExperienceQuery = () => {
    const parts = [];
    for (let i = 1; i <= 4; i += 1) {
      const jabatan = this.state[`pengalaman_kerja_jabatan_${i}`];
      const perusahaan = this.state[`pengalaman_kerja_perusahaan_${i}`];
      if (jabatan) parts.push(String(jabatan).trim());
      if (perusahaan) parts.push(String(perusahaan).trim());
    }
    return parts.filter(Boolean).join(" ");
  };

  validateImageFile = (file) => {
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
    const allowedExtensions = [".jpg", ".jpeg", ".png", ".webp"];

    // Validasi berdasarkan MIME type
    if (!allowedTypes.includes(file.type)) {
      return false;
    }

    // Validasi berdasarkan ekstensi file
    const fileName = file.name.toLowerCase();
    const hasValidExtension = allowedExtensions.some((ext) =>
      fileName.endsWith(ext),
    );

    if (!hasValidExtension) {
      return false;
    }

    return true;
  };

  validatePdfFile = (file) => {
    const allowedTypes = ["application/pdf"];
    const allowedExtensions = [".pdf"];

    // Validasi berdasarkan MIME type
    if (!allowedTypes.includes(file.type)) {
      return false;
    }

    // Validasi berdasarkan ekstensi file
    const fileName = file.name.toLowerCase();
    const hasValidExtension = allowedExtensions.some((ext) =>
      fileName.endsWith(ext),
    );

    if (!hasValidExtension) {
      return false;
    }

    return true;
  };

  //Update validateRekeningBank untuk tidak konflik dengan validasi MCU
  validateRekeningBank = (e) => {
    const rawInputValue = e.target.value;
    const inputValue = rawInputValue ? rawInputValue.toString() : "";
    const { selected_bank, status_karyawan } = this.state;

    console.log("🔍 Validating rekening bank:", {
      rawInputValue,
      inputValue,
      inputType: typeof inputValue,
      selected_bank,
      status_karyawan,
      inputLength: inputValue.length,
    });

    if (typeof inputValue !== "string") {
      console.error("❌ InputValue is not a string:", inputValue);
      return;
    }

    // Hanya izinkan angka dan hapus karakter non-digit
    const numericValue = inputValue.replace(/\D/g, "");

    // Tentukan batas maksimal berdasarkan bank atau status karyawan
    let maxDigits = 0;
    let bankType = selected_bank;

    // ✅ Untuk staff, selalu MAS
    if (status_karyawan === "staff") {
      maxDigits = 10;
      bankType = "mas";

      if (selected_bank !== "mas") {
        this.setState({ selected_bank: "mas" });
      }
    }
    // ✅ Untuk nonstaff, cek berdasarkan bank yang dipilih ATAU prediksi dari panjang digit
    else if (isNonstaffStatus(status_karyawan)) {
      if (selected_bank === "mandiri") {
        maxDigits = 13;
        bankType = "mandiri";
      } else if (selected_bank === "mas") {
        maxDigits = 10;
        bankType = "mas";
      } else if (selected_bank === "" && numericValue.length > 0) {
        if (numericValue.length <= 10) {
          maxDigits = 10;
          bankType = "mas";
          console.log("🤖 Auto-detecting MAS bank based on digit length");
        } else if (numericValue.length <= 13) {
          maxDigits = 13;
          bankType = "mandiri";
          console.log("🤖 Auto-detecting Mandiri bank based on digit length");
        } else {
          maxDigits = 13;
          bankType = "mandiri";
        }

        // ✅ Auto-set bank yang terdeteksi hanya jika tidak ada data MCU
        if (
          bankType &&
          this.state.selected_bank === "" &&
          !this.state.nomor_rekening_bank_mcu
        ) {
          this.setState({ selected_bank: bankType });
        }
      }
    }

    // Potong jika melebihi batas maksimal
    const limitedValue =
      maxDigits > 0 ? numericValue.substring(0, maxDigits) : numericValue;

    // Update state dengan nilai yang sudah dibatasi
    this.setState(
      {
        nomor_rekening_bank: limitedValue,
      },
      () => {
        // Validasi dan set error message
        let error = "";
        let isValidLength = false;

        if (status_karyawan === "staff") {
          isValidLength = limitedValue.length === 10;
          if (limitedValue.length > 0 && !isValidLength) {
            error = `Nomor rekening MAS: ${limitedValue.length}/10 digit`;
          }
        } else if (isNonstaffStatus(status_karyawan)) {
          if (bankType === "mandiri") {
            isValidLength = limitedValue.length === 13;
            if (limitedValue.length > 0 && !isValidLength) {
              error = `Nomor rekening Mandiri: ${limitedValue.length}/13 digit`;
            }
          } else if (bankType === "mas") {
            isValidLength = limitedValue.length === 10;
            if (limitedValue.length > 0 && !isValidLength) {
              error = `Nomor rekening MAS: ${limitedValue.length}/10 digit`;
            }
          } else if (limitedValue.length > 0) {
            error = "Pilih bank yang sesuai dengan nomor rekening";
          }
        }

        // ✅ PERBAIKAN: Gunakan debounced validation untuk menghindari race condition
        this.setState(
          {
            rekening_error: error,
          },
          () => {
            this.debouncedUpdateSubmitButtonStatus();
            this.queueAutosave({
              nomor_rekening_bank: limitedValue,
              selected_bank: this.state.selected_bank,
            });
          },
        );

        console.log("✅ Rekening validation result:", {
          limitedValue,
          length: limitedValue.length,
          requiredLength: maxDigits,
          detectedBank: bankType,
          isValidLength,
          error,
        });
      },
    );
  };

  isUploadComplete = (status) => {
    return status === "Upload selesai";
  };

  validateRequiredFields = () => {
    console.log("🔍 Processing Validate Required Fields");
    if (
      this.state.status_karyawan === "staff" &&
      this.state.selected_bank !== "mas"
    ) {
      this.setState({ selected_bank: "mas" });
    }

    const stateForValidation =
      this.state.status_karyawan === "staff"
        ? { ...this.state, selected_bank: "mas" }
        : this.state;

    const result = validateForm1Complete(stateForValidation);

    if (result.failedFields.length > 0) {
      console.log("❌ Field yang belum diisi:", result.failedFields);
      this.setState({ missingRequiredFields: result.failedFields });
    } else {
      this.setState({ missingRequiredFields: [] });
    }

    if (result.failedUploads.length > 0) {
      this.setState({ missingRequiredUploads: result.failedUploads });
    } else {
      this.setState({ missingRequiredUploads: [] });
    }

    console.log("🔍 Validation Summary:", result);

    return result.ok;
  };

  updateSubmitButtonStatus = () => {
    console.log("🔘 Update Submit Button Status");
    try {
      console.log(this.state);
      const isFormValid = this.validateRequiredFields();
      this.setState({
        isFormValid: isFormValid,
      });
    } catch (error) {
      console.error("Error in updateSubmitButtonStatus:", error);
      this.setState({
        isFormValid: false,
      });
    }
  };

  // ✅ Debounced version untuk mencegah multiple calls yang tumpang tindih
  debouncedUpdateSubmitButtonStatus = () => {
    // Clear existing timer
    if (this.validationTimer) {
      clearTimeout(this.validationTimer);
    }
    // Set new timer dengan delay minimal untuk memastikan state sudah terupdate
    this.validationTimer = setTimeout(() => {
      this.updateSubmitButtonStatus();
      this.validationTimer = null;
    }, 50); // Delay minimal 50ms untuk memastikan state terupdate
  };

  // agreementChange = (e) => {
  //   this.setState({
  //     agreement: !this.state.agreement,
  //   });
  //   // console.log(e.target.name)
  // };

  agreementChange = (e) => {
    try {
      console.log("🔘 Agreement checkbox clicked"); // Debug log

      // ✅ PERBAIKAN: Gunakan functional setState dan debounced validation
      this.setState(
        (prevState) => ({
          agreement: !prevState.agreement,
        }),
        () => {
          console.log("✅ Agreement updated to:", this.state.agreement); // Debug log
          this.debouncedUpdateSubmitButtonStatus();
          this.queueAutosave({ agreement: this.state.agreement });
        },
      );
    } catch (error) {
      console.error("Error in agreementChange:", error);
    }
  };

  onProvinceChange = (selectedOption) => {
    this.setState(
      {
        province: selectedOption.id,
        provinceName: selectedOption.name,
        district: "",
        regency: "",
        districtsData: [],
        regenciesData: [],
      },
      () => {
        // Do ajax to get regencies
        this.getRegencies(selectedOption.id);
        // ✅ PERBAIKAN: Gunakan debounced validation
        this.debouncedUpdateSubmitButtonStatus();
        this.queueAutosave({
          province: selectedOption.id,
          provinceName: selectedOption.name,
          district: "",
          regency: "",
        });
      },
    );

    // console.log('You are selected: ', selectedOption);
  };

  onASProvinceChange = (selectedOption) => {
    this.setState(
      {
        ASprovince: selectedOption.id,
        ASdistrict: "",
        ASregency: "",
        ASdistrictsData: [],
        ASregenciesData: [],
      },
      () => {
        // Do ajax to get regencies
        this.ASgetRegencies(selectedOption.id);
        // ✅ PERBAIKAN: Gunakan debounced validation
        this.debouncedUpdateSubmitButtonStatus();
        this.queueAutosave({
          ASprovince: selectedOption.id,
          ASdistrict: "",
          ASregency: "",
        });
      },
    );

    console.log("You are selected: ", selectedOption);
  };

  onRegencyChange = (selectedOption) => {
    this.setState(
      {
        regency: selectedOption.id,
        regencyName: selectedOption.name,
      },
      () => {
        // Do ajax to get regencies
        this.getDistricts(selectedOption.id);
        // ✅ PERBAIKAN: Gunakan debounced validation
        this.debouncedUpdateSubmitButtonStatus();
        this.queueAutosave({
          regency: selectedOption.id,
          regencyName: selectedOption.name,
        });
      },
    );

    console.log("You are selected: ", selectedOption);
  };

  onASRegencyChange = (selectedOption) => {
    this.setState(
      {
        ASregency: selectedOption.id,
      },
      () => {
        // Do ajax to get regencies
        this.ASgetDistricts(selectedOption.id);
        // ✅ PERBAIKAN: Gunakan debounced validation
        this.debouncedUpdateSubmitButtonStatus();
        this.queueAutosave({ ASregency: selectedOption.id });
      },
    );

    console.log("You are selected: ", selectedOption);
  };

  onDistrictChange = (selectedOption) => {
    this.setState(
      {
        district: selectedOption.id,
        districtName: selectedOption.name,
      },
      () => {
        // Do ajax to get regencies
        this.getVillages(selectedOption.id);
        // ✅ PERBAIKAN: Gunakan debounced validation
        this.debouncedUpdateSubmitButtonStatus();
        this.queueAutosave({
          district: selectedOption.id,
          districtName: selectedOption.name,
        });
      },
    );

    console.log("You are selected: ", selectedOption);
  };

  onASDistrictChange = (selectedOption) => {
    this.setState(
      {
        ASdistrict: selectedOption.id,
      },
      () => {
        // Do ajax to get regencies
        this.ASgetVillages(selectedOption.id);
        // ✅ PERBAIKAN: Gunakan debounced validation
        this.debouncedUpdateSubmitButtonStatus();
        this.queueAutosave({ ASdistrict: selectedOption.id });
      },
    );

    console.log("You are selected: ", selectedOption);
  };

  onVillageChange = (selectedOption) => {
    this.setState(
      {
        village: selectedOption.id,
        villageName: selectedOption.name,
        alamatDisabled: false,
      },
      () => {
        // ✅ PERBAIKAN: Gunakan debounced validation
        this.debouncedUpdateSubmitButtonStatus();
        this.queueAutosave({
          village: selectedOption.id,
          villageName: selectedOption.name,
        });
      },
    );

    console.log("You are selected: ", selectedOption);
  };

  onASVillageChange = (selectedOption) => {
    this.setState(
      {
        ASvillage: selectedOption.id,
        ASalamatDisabled: false,
      },
      () => {
        // ✅ PERBAIKAN: Gunakan debounced validation
        this.debouncedUpdateSubmitButtonStatus();
        this.queueAutosave({ ASvillage: selectedOption.id });
      },
    );

    console.log("You are selected: ", selectedOption);
  };

  onAddressChange = (e) => {
    const addressDetail = e.target.value;
    this.setState(
      {
        addressDetail,
      },
      () => {
        // ✅ PERBAIKAN: Gunakan debounced validation
        this.debouncedUpdateSubmitButtonStatus();
        this.queueAutosave({ addressDetail });
      },
    );
  };

  onASAddressChange = (e) => {
    const ASaddressDetail = e.target.value;
    this.setState(
      {
        ASaddressDetail,
      },
      () => {
        // ✅ PERBAIKAN: Gunakan debounced validation
        this.debouncedUpdateSubmitButtonStatus();
        this.queueAutosave({ ASaddressDetail });
      },
    );
  };

  toggleAlamatSesuaiKTP = () => {
    // ✅ PERBAIKAN: Gunakan functional setState dan debounced validation
    this.setState(
      (prevState) => ({
        alamatSesuaiKtp: !prevState.alamatSesuaiKtp,
      }),
      () => {
        console.log(this.state.alamatSesuaiKtp);
        this.debouncedUpdateSubmitButtonStatus();
        this.queueAutosave({ alamatSesuaiKtp: this.state.alamatSesuaiKtp });
      },
    );
  };

  /**
   * Resolve dokumen karyawan di Firestore untuk autosave / upload.
   * Tidak pernah membuat dokumen baru (hindari duplikasi NIK).
   */
  getEmployeeDocRef = async () => {
    const raw = localStorage.getItem("id");
    if (!raw) return null;

    const userData = JSON.parse(raw)[0];
    if (!userData) return null;

    try {
      const resolved = await resolveEmployeeDoc(this.ref, {
        docId: userData.docId || null,
        nik: userData.nik,
        tanggalLahir: userData.tanggal_lahir,
      });

      if (!resolved.doc) {
        console.warn("⚠️ Document tidak ditemukan untuk autosave");
        return null;
      }

      if (resolved.docs.length > 1) {
        console.warn(
          "⚠️ Autosave: ada",
          resolved.docs.length,
          "dokumen untuk NIK yang sama; memakai yang terbaru:",
          resolved.doc.id,
        );
      }

      if (userData.docId !== resolved.doc.id) {
        userData.docId = resolved.doc.id;
        localStorage.setItem("id", JSON.stringify([userData]));
      }

      return this.ref.doc(resolved.doc.id);
    } catch (error) {
      console.error("❌ Error resolve employee doc:", error);
      return null;
    }
  };

  /** Antre perubahan field, flush ke Firestore setelah user berhenti mengetik. */
  queueAutosave = (fields) => {
    if (!fields || typeof fields !== "object") return;
    Object.assign(this.pendingAutosave, fields);
    if (this.autosaveTimer) {
      clearTimeout(this.autosaveTimer);
    }
    this.autosaveTimer = setTimeout(() => {
      const payload = { ...this.pendingAutosave };
      this.pendingAutosave = {};
      this.autosaveTimer = null;
      this.saveFieldsToDatabase(payload);
    }, 700);
  };

  flushAutosave = () => {
    if (this.autosaveTimer) {
      clearTimeout(this.autosaveTimer);
      this.autosaveTimer = null;
    }
    const payload = { ...this.pendingAutosave };
    this.pendingAutosave = {};
    if (Object.keys(payload).length > 0) {
      return this.saveFieldsToDatabase(payload);
    }
    return Promise.resolve();
  };

  saveFieldsToDatabase = async (fields) => {
    try {
      if (!fields || typeof fields !== "object") return;

      const sanitized = {};
      Object.keys(fields).forEach((key) => {
        const value = fields[key];
        if (value === undefined) return;
        if (typeof File !== "undefined" && value instanceof File) return;
        if (typeof Blob !== "undefined" && value instanceof Blob) return;
        sanitized[key] = value;
      });

      if (Object.keys(sanitized).length === 0) return;

      const docRef = await this.getEmployeeDocRef();
      if (!docRef) return;

      await docRef.update({
        ...sanitized,
        updated_at: new Date().toISOString(),
      });

      console.log("💾 Autosave Form 1:", Object.keys(sanitized));
    } catch (error) {
      console.error("❌ Error autosave Form 1:", error);
    }
  };

  // ✅ Function untuk menyimpan file URL + flag OCR setelah upload
  saveFileUrlToDatabase = async (fieldName, url, ocrMeta = {}) => {
    try {
      console.log(`💾 Menyimpan ${fieldName} ke database`, ocrMeta);

      const updateData = {
        [fieldName]: url,
      };

      const validateField =
        ocrMeta.validateField || getValidateByOcrFieldName(fieldName);
      // Hanya set flag jika OCR benar-benar lolos (true).
      // Upload tanpa OCR: jangan isi / jangan centang *_validate_by_ocr.
      if (validateField && ocrMeta.validateByOcr === true) {
        updateData[validateField] = true;
      }

      await this.saveFieldsToDatabase(updateData);

      console.log(
        `✅ ${fieldName} berhasil disimpan`,
        validateField && ocrMeta.validateByOcr === true
          ? `(${validateField}=true)`
          : "(tanpa validate_by_ocr)",
      );
    } catch (error) {
      console.error(`❌ Error menyimpan ${fieldName} ke database:`, error);
    }
  };

  updateExistingEmployee = async (employeeData) => {
    try {
      const mergedForSubmit = { ...this.state, ...employeeData };
      const completeness = validateForm1Complete(mergedForSubmit);
      if (!completeness.ok) {
        console.error(
          "❌ Penyimpanan ditolak: Form 1 belum lengkap:",
          completeness,
        );
        return {
          success: false,
          error:
            completeness.errorMessage ||
            "Data Form 1 belum lengkap. Tidak dapat menandai sebagai selesai.",
        };
      }

      const userData = JSON.parse(localStorage.getItem("id"))[0];
      const nik = userData.nik;
      const tanggal_lahir = userData.tanggal_lahir;

      console.log(
        "🔄 Updating employee data for NIK:",
        nik,
        "Tanggal Lahir:",
        tanggal_lahir,
      );

      // Jangan pernah membuat dokumen baru dari Form 1 — cegah duplikasi NIK.
      const resolved = await resolveEmployeeDoc(this.ref, {
        docId: userData.docId || null,
        nik,
        tanggalLahir: tanggal_lahir,
      });

      if (!resolved.doc) {
        console.error(
          "❌ Document karyawan tidak ditemukan. Submit dibatalkan (tidak membuat dokumen baru).",
        );
        return {
          success: false,
          error:
            "Data karyawan tidak ditemukan di sistem. Hubungi HRD / admin — jangan submit ulang.",
        };
      }

      if (resolved.docs.length > 1) {
        console.error(
          "⚠️ PERINGATAN: Ada duplikasi data! NIK:",
          nik,
          "memiliki",
          resolved.docs.length,
          "documents. Menggunakan yang terbaru:",
          resolved.doc.id,
        );
      }

      const docRef = this.ref.doc(resolved.doc.id);
      userData.docId = resolved.doc.id;
      localStorage.setItem("id", JSON.stringify([userData]));

      await docRef.set(
        {
          ...employeeData,
          form_1_submitted: "diisi",
          form_1_submitted_date: new Date().toISOString(),
          status: "dibuat", // ✅ Form 1 selesai, menunggu form 2
          updated_at: new Date().toISOString(),
        },
        { merge: true },
      );

      console.log(
        "✅ Successfully updated employee data untuk NIK:",
        nik,
        "docId:",
        docRef.id,
      );
      return { success: true, docId: docRef.id };
    } catch (error) {
      console.error("❌ Error updating employee:", error);
      return { success: false, error: error.message };
    }
  };

  isStatusPerdataBelumMenikahOrCerai = () => {
    return (
      this.state.status_perdata === "Belum Menikah" ||
      this.state.status_perdata === "Cerai"
    );
  };

  isStatusPerdataBelumMenikah = () => {
    return (
      this.state.status_perdata === "Menikah" ||
      this.state.status_perdata === "Cerai"
    );
  };

  isStatusPerdataMenikah = () => {
    return this.state.status_perdata === "Menikah";
  };

  onSubmit = (e) => {
    e.preventDefault();

    // ✅ VALIDASI NOMOR REKENING SEBELUM SUBMIT
    const { selected_bank, nomor_rekening_bank } = this.state;

    if (selected_bank === "mandiri" || selected_bank === "mas") {
      const requiredDigits = selected_bank === "mandiri" ? 13 : 10;
      const bankName = selected_bank === "mandiri" ? "Mandiri" : "MAS";

      // Validasi nomor rekening ada dan sesuai panjang
      if (
        !nomor_rekening_bank ||
        nomor_rekening_bank.toString().length !== requiredDigits
      ) {
        alert(
          `❌ Nomor rekening ${bankName} harus tepat ${requiredDigits} digit!`,
        );
        return false;
      }

      // Validasi hanya berisi angka
      if (!/^\d+$/.test(nomor_rekening_bank)) {
        alert("❌ Nomor rekening hanya boleh berisi angka!");
        return false;
      }
    } else {
      this.setState({
        selected_bank: "",
        nomor_rekening_bank: "",
        rekening_error: "",
      });
    }

    // ✅ VALIDASI: Gunakan validateRequiredFields untuk validasi lengkap
    if (!this.validateRequiredFields()) {
      alert("❌ Mohon lengkapi semua field yang wajib diisi!");
      return false;
    }

    if (!isForm1FileUrlsComplete(this.state)) {
      alert(
        "❌ URL dokumen wajib belum valid. Pastikan foto, KTP, NPWP, KK, dan CV sudah ter-upload (bukan hanya spasi).",
      );
      return false;
    }

    const {
      nik,
      golongan_darah,
      nomor_ktp,
      nama_lengkap,
      nomor_kk,
      nomor_npwp,
      agama,
      jenis_kelamin,
      tempat_lahir,
      tanggal_lahir,
      tanggal_lahir_formatted,
      tanggal_masuk,
      status_perdata,
      orang_tua_nama_ayah,
      orang_tua_nama_ibu,
      kontak_darurat_nama,
      kontak_darurat_hubungan,
      kontak_darurat_no_telepon,
      province,
      regency,
      district,
      village,
      addressDetail,
      agreement,
      nama_pasangan,
      tempat_pernikahan,
      tanggal_pernikahan,
      tempat_lahir_pasangan,
      tanggal_lahir_pasangan,
      pekerjaan_pasangan,
      tempat_pasangan_bekerja,
      pengalaman_kerja_perusahaan_1,
      pengalaman_kerja_perusahaan_2,
      pengalaman_kerja_perusahaan_3,
      pengalaman_kerja_perusahaan_4,
      pengalaman_kerja_jabatan_1,
      pengalaman_kerja_jabatan_2,
      pengalaman_kerja_jabatan_3,
      pengalaman_kerja_jabatan_4,
      pengalaman_kerja_tanggal_mulai_1,
      pengalaman_kerja_tanggal_mulai_2,
      pengalaman_kerja_tanggal_mulai_3,
      pengalaman_kerja_tanggal_mulai_4,
      pengalaman_kerja_tanggal_selesai_1,
      pengalaman_kerja_tanggal_selesai_2,
      pengalaman_kerja_tanggal_selesai_3,
      pengalaman_kerja_tanggal_selesai_4,
      pengalaman_kerja_kota_1,
      pengalaman_kerja_kota_2,
      pengalaman_kerja_kota_3,
      pengalaman_kerja_kota_4,
      nama_sertifikasi_1,
      nama_sertifikasi_2,
      nama_sertifikasi_3,
      nama_sertifikasi_4,
      lembaga_pemberi_1,
      lembaga_pemberi_2,
      lembaga_pemberi_3,
      lembaga_pemberi_4,
      sertifikasi_training_1_url,
      sertifikasi_training_2_url,
      sertifikasi_training_3_url,
      sertifikasi_training_4_url,
      cv_url,
      // rekening_bank_url,
      anak_anak_nama_1,
      anak_anak_jenis_kelamin_1,
      anak_anak_tempat_lahir_1,
      anak_anak_tanggal_lahir_1,
      anak_anak_nama_2,
      anak_anak_jenis_kelamin_2,
      anak_anak_tempat_lahir_2,
      anak_anak_tanggal_lahir_2,
      anak_anak_nama_3,
      anak_anak_jenis_kelamin_3,
      anak_anak_tempat_lahir_3,
      anak_anak_tanggal_lahir_3,
      anak_anak_nama_4,
      anak_anak_jenis_kelamin_4,
      anak_anak_tempat_lahir_4,
      anak_anak_tanggal_lahir_4,
      orang_tua_tempat_lahir_ayah,
      orang_tua_tanggal_lahir_ayah,
      orang_tua_tempat_lahir_ibu,
      orang_tua_tanggal_lahir_ibu,
      saudara_kandung_nama_1,
      saudara_kandung_jenis_kelamin_1,
      saudara_kandung_tempat_lahir_1,
      saudara_kandung_tanggal_lahir_1,
      saudara_kandung_nama_2,
      saudara_kandung_jenis_kelamin_2,
      saudara_kandung_tempat_lahir_2,
      saudara_kandung_tanggal_lahir_2,
      saudara_kandung_nama_3,
      saudara_kandung_jenis_kelamin_3,
      saudara_kandung_tempat_lahir_3,
      saudara_kandung_tanggal_lahir_3,
      saudara_kandung_nama_4,
      saudara_kandung_jenis_kelamin_4,
      saudara_kandung_tempat_lahir_4,
      saudara_kandung_tanggal_lahir_4,
      mertua_nama_ayah,
      mertua_tempat_lahir_ayah,
      mertua_tanggal_lahir_ayah,
      mertua_nama_ibu,
      mertua_tempat_lahir_ibu,
      mertua_tanggal_lahir_ibu,
      alamatSesuaiKtp,
      ASprovince,
      ASregency,
      ASdistrict,
      ASvillage,
      ASaddressDetail,

      nomor_kartu_bpjs_kesehatan,
      nomor_kartu_bpjs_ketenagakerjaan,
      keterangan_kartu_bpjs_kesehatan,
      keterangan_kartu_bpjs_ketenagakerjaan,

      // ✅ State vaksinasi
      jenis_vaksin,
      tanggal_vaksin_1,
      lokasi_vaksin_1,
      tanggal_vaksin_2,
      lokasi_vaksin_2,
      tanggal_vaksin_3,
      lokasi_vaksin_3,
      foto_url,
      ktp_url,
      npwp_url,
      kk_url,
      foto_validate_by_ocr,
      ktp_validate_by_ocr,
      npwp_validate_by_ocr,
      kk_validate_by_ocr,
      cv_validate_by_ocr,
      nomor_hp,
      email,
      sosmed_facebook,
      sosmed_twitter,
      sosmed_linkedin,
      sosmed_instagram,
      pendidikan_terakhir,
      pendidikan_nama_sekolah,
      pendidikan_jurusan,
      pendidikan_kursus,
    } = this.state;

    if (
      province === "" ||
      regency === "" ||
      district === "" ||
      village === ""
    ) {
      alert("Mohon isi dulu alamat");
      return false;
    }

    if (agreement !== true) {
      alert("Anda harus menyetujui agreement!");
      return false;
    }

    if (this.state.foto_pribadi_status !== "Upload selesai") {
      alert("Mohon tunggu upload foto pribadi selesai");
      return false;
    }

    if (this.state.foto_ktp_status !== "Upload selesai") {
      alert("Mohon tunggu upload foto ktp selesai");
      return false;
    }

    if (this.state.foto_kk_status !== "Upload selesai") {
      alert("Mohon tunggu upload foto kk selesai");
      return false;
    }

    if (jenis_kelamin === "") {
      alert("Mohon pilih jenis kelamin");
      return false;
    }

    // Mulai submit
    this.setState({
      submiting: true,
    });

    // var alamat_sekarang_provinsi = ASprovince;
    // var alamat_sekarang_kota = ASregency;
    // var alamat_sekarang_kecamatan = ASdistrict;
    // var alamat_sekarang_desa = ASvillage;
    // var alamat_sekarang_alamat = ASaddressDetail;

    // if (alamatSesuaiKtp === true) {
    //   alamat_sekarang_provinsi = province;
    //   alamat_sekarang_kota = regency;
    //   alamat_sekarang_kecamatan = district;
    //   alamat_sekarang_desa = village;
    //   alamat_sekarang_alamat = addressDetail;
    // }

    const form1Data = {
      nik,
      golongan_darah,
      nomor_ktp,
      nama_lengkap,
      nomor_kk,
      nomor_npwp,
      agama,
      jenis_kelamin,
      tempat_lahir,
      tanggal_lahir,
      tanggal_lahir_formatted,
      tanggal_masuk,
      status_perdata,
      orang_tua_nama_ayah,
      orang_tua_nama_ibu,
      kontak_darurat_nama,
      kontak_darurat_hubungan,
      kontak_darurat_no_telepon,
      province,
      regency,
      district,
      village,
      addressDetail,
      ASprovince,
      ASregency,
      ASdistrict,
      ASvillage,
      ASaddressDetail,
      nama_pasangan,
      tempat_pernikahan,
      tanggal_pernikahan,
      tempat_lahir_pasangan,
      tanggal_lahir_pasangan,
      pekerjaan_pasangan,
      tempat_pasangan_bekerja,
      pengalaman_kerja_perusahaan_1,
      pengalaman_kerja_perusahaan_2,
      pengalaman_kerja_perusahaan_3,
      pengalaman_kerja_perusahaan_4,
      pengalaman_kerja_jabatan_1,
      pengalaman_kerja_jabatan_2,
      pengalaman_kerja_jabatan_3,
      pengalaman_kerja_jabatan_4,
      pengalaman_kerja_tanggal_mulai_1,
      pengalaman_kerja_tanggal_mulai_2,
      pengalaman_kerja_tanggal_mulai_3,
      pengalaman_kerja_tanggal_mulai_4,
      pengalaman_kerja_tanggal_selesai_1,
      pengalaman_kerja_tanggal_selesai_2,
      pengalaman_kerja_tanggal_selesai_3,
      pengalaman_kerja_tanggal_selesai_4,
      pengalaman_kerja_kota_1,
      pengalaman_kerja_kota_2,
      pengalaman_kerja_kota_3,
      pengalaman_kerja_kota_4,
      nama_sertifikasi_1,
      nama_sertifikasi_2,
      nama_sertifikasi_3,
      nama_sertifikasi_4,
      lembaga_pemberi_1,
      lembaga_pemberi_2,
      lembaga_pemberi_3,
      lembaga_pemberi_4,
      sertifikasi_training_1_url,
      sertifikasi_training_2_url,
      sertifikasi_training_3_url,
      sertifikasi_training_4_url,
      cv_url,
      // rekening_bank_url,
      anak_anak_nama_1,
      anak_anak_jenis_kelamin_1,
      anak_anak_tempat_lahir_1,
      anak_anak_tanggal_lahir_1,
      anak_anak_nama_2,
      anak_anak_jenis_kelamin_2,
      anak_anak_tempat_lahir_2,
      anak_anak_tanggal_lahir_2,
      anak_anak_nama_3,
      anak_anak_jenis_kelamin_3,
      anak_anak_tempat_lahir_3,
      anak_anak_tanggal_lahir_3,
      anak_anak_nama_4,
      anak_anak_jenis_kelamin_4,
      anak_anak_tempat_lahir_4,
      anak_anak_tanggal_lahir_4,
      orang_tua_tempat_lahir_ayah,
      orang_tua_tanggal_lahir_ayah,
      orang_tua_tempat_lahir_ibu,
      orang_tua_tanggal_lahir_ibu,
      saudara_kandung_nama_1,
      saudara_kandung_jenis_kelamin_1,
      saudara_kandung_tempat_lahir_1,
      saudara_kandung_tanggal_lahir_1,
      saudara_kandung_nama_2,
      saudara_kandung_jenis_kelamin_2,
      saudara_kandung_tempat_lahir_2,
      saudara_kandung_tanggal_lahir_2,
      saudara_kandung_nama_3,
      saudara_kandung_jenis_kelamin_3,
      saudara_kandung_tempat_lahir_3,
      saudara_kandung_tanggal_lahir_3,
      saudara_kandung_nama_4,
      saudara_kandung_jenis_kelamin_4,
      saudara_kandung_tempat_lahir_4,
      saudara_kandung_tanggal_lahir_4,
      mertua_nama_ayah,
      mertua_tempat_lahir_ayah,
      mertua_tanggal_lahir_ayah,
      mertua_nama_ibu,
      mertua_tempat_lahir_ibu,
      mertua_tanggal_lahir_ibu,
      nomor_kartu_bpjs_kesehatan,
      nomor_kartu_bpjs_ketenagakerjaan,
      keterangan_kartu_bpjs_kesehatan,
      keterangan_kartu_bpjs_ketenagakerjaan,
      jenis_vaksin,
      tanggal_vaksin_1,
      lokasi_vaksin_1,
      tanggal_vaksin_2,
      lokasi_vaksin_2,
      tanggal_vaksin_3,
      lokasi_vaksin_3,
      nomor_rekening_bank,
      selected_bank,
      foto_url,
      ktp_url,
      npwp_url,
      kk_url,
      ...(foto_validate_by_ocr === true ? { foto_validate_by_ocr: true } : {}),
      ...(ktp_validate_by_ocr === true ? { ktp_validate_by_ocr: true } : {}),
      ...(npwp_validate_by_ocr === true ? { npwp_validate_by_ocr: true } : {}),
      ...(kk_validate_by_ocr === true ? { kk_validate_by_ocr: true } : {}),
      ...(cv_validate_by_ocr === true ? { cv_validate_by_ocr: true } : {}),
      nomor_hp,
      email,
      sosmed_facebook,
      sosmed_twitter,
      sosmed_linkedin,
      sosmed_instagram,
      pendidikan_terakhir,
      pendidikan_nama_sekolah,
      pendidikan_jurusan,
      pendidikan_kursus,
    };

    // ✅ GUNAKAN: updateExistingEmployee alih-alih ref.add
    this.updateExistingEmployee(form1Data)
      .then((result) => {
        this.setState({ submiting: false });

        if (result.success) {
          // ✅ Update localStorage
          const currentData = JSON.parse(localStorage.getItem("id"));
          if (currentData && currentData.length > 0) {
            currentData[0].form_1_submitted = "diisi";
            currentData[0].form_1_submitted_date = new Date().toISOString();
            currentData[0].docId = result.docId; // ✅ Simpan document ID
            localStorage.setItem("id", JSON.stringify(currentData));
          }

          Swal.fire({
            title: "Data Berhasil Dikirim",
            text: "Data anda pada form 1 sudah berhasil dikirimkan kepada tim HRD. Silahkan melanjutkan form kedua!",
            icon: "success",
            showCancelButton: false,
            confirmButtonText: "Oke",
          }).then((result) => {
            window.location.href = "/form-2";
          });
        } else {
          alert("❌ Gagal menyimpan Form 1: " + result.error);
        }
      })
      .catch((error) => {
        console.error("Error updating document: " + error);
        this.setState({ submiting: false });
        alert("Terjadi kesalahan saat menyimpan Form 1.");
      });
  };

  currentDate = () => {
    const date = new Date();
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  _onFocus = (e) => {
    e.currentTarget.type = "date";
  };

  handleAutosaveBlur = (e) => {
    const el = e.target;
    if (!el || !el.name) return;
    if (el.type === "file") return;
    if (el.type === "button" || el.type === "submit") return;

    const fieldName = el.name;
    let fieldValue = el.value;
    if (el.type === "checkbox") {
      fieldValue = el.checked;
    } else if (
      el.type === "text" ||
      el.type === "tel" ||
      el.type === "number" ||
      el.type === "date" ||
      el.type === "email" ||
      el.tagName === "TEXTAREA"
    ) {
      fieldValue = typeof fieldValue === "string" ? fieldValue.trim() : fieldValue;
    }

    this.queueAutosave({ [fieldName]: fieldValue });
    this.flushAutosave();
  };

  _onBlur = (e) => {
    const fieldName = e.target.name;
    const newValue = e.target.value.trim();

    console.log(
      `🔍 onBlur triggered for field: ${fieldName}, new value: ${newValue}`,
    );

    // Validasi MCU; simpan Firebase lewat onBlur form (handleAutosaveBlur).
    this.validateFieldChangeWithSwal(fieldName, newValue);
  };

  // ✅ HELPER FUNCTION: Validasi format berdasarkan jenis field
  validateFieldFormat = (fieldName, value) => {
    switch (fieldName) {
      case "nomor_npwp":
        if (value.length !== 16 || !/^\d+$/.test(value)) {
          return {
            isValid: false,
            message: "Nomor NPWP harus 16 digit angka!",
          };
        }
        break;

      case "nomor_ktp":
        if (value.length !== 16 || !/^\d+$/.test(value)) {
          return {
            isValid: false,
            message: "Nomor KTP harus 16 digit angka!",
          };
        }
        break;

      case "nomor_kk":
        if (value.length !== 16 || !/^\d+$/.test(value)) {
          return {
            isValid: false,
            message: "Nomor KK harus 16 digit angka!",
          };
        }
        break;

      case "nomor_hp":
        if (value.length < 10 || value.length > 16 || !/^\d+$/.test(value)) {
          return {
            isValid: false,
            message: "Nomor HP harus 10-16 digit angka!",
          };
        }
        break;

      case "email":
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) {
          return {
            isValid: false,
            message: "Format email tidak valid!",
          };
        }
        break;

      case "nama_lengkap":
        if (value.length < 2) {
          return {
            isValid: false,
            message: "Nama lengkap minimal 2 karakter!",
          };
        }
        break;

      case "tempat_lahir":
      case "orang_tua_nama_ayah":
      case "orang_tua_nama_ibu":
      case "kontak_darurat_nama":
        if (value.length < 2) {
          return {
            isValid: false,
            message: `${this.getFieldDisplayName(
              fieldName,
            )} minimal 2 karakter!`,
          };
        }
        break;

      case "kontak_darurat_no_telepon":
        if (value.length < 10 || !/^\d+$/.test(value)) {
          return {
            isValid: false,
            message: "Nomor telepon kontak darurat minimal 10 digit angka!",
          };
        }
        break;

      case "pendidikan_nama_sekolah":
      case "pendidikan_jurusan":
        if (value.length < 2) {
          return {
            isValid: false,
            message: `${this.getFieldDisplayName(
              fieldName,
            )} minimal 2 karakter!`,
          };
        }
        break;

      // ✅ TAMBAHAN: Validasi field alamat
      case "addressDetail":
      case "ASaddressDetail":
        if (value.length < 5) {
          return {
            isValid: false,
            message: "Alamat detail minimal 5 karakter!",
          };
        }
        break;

      // Validasi untuk pengalaman kerja
      case "pengalaman_kerja_perusahaan_1":
      case "pengalaman_kerja_perusahaan_2":
      case "pengalaman_kerja_perusahaan_3":
      case "pengalaman_kerja_perusahaan_4":
        if (value.length > 0 && value.length < 2) {
          return {
            isValid: false,
            message: "Nama perusahaan minimal 2 karakter!",
          };
        }
        break;

      case "pengalaman_kerja_jabatan_1":
      case "pengalaman_kerja_jabatan_2":
      case "pengalaman_kerja_jabatan_3":
      case "pengalaman_kerja_jabatan_4":
        if (value.length > 0 && value.length < 2) {
          return {
            isValid: false,
            message: "Jabatan minimal 2 karakter!",
          };
        }
        break;

      case "pengalaman_kerja_kota_1":
      case "pengalaman_kerja_kota_2":
      case "pengalaman_kerja_kota_3":
      case "pengalaman_kerja_kota_4":
        if (value.length > 0 && value.length < 2) {
          return {
            isValid: false,
            message: "Nama kota minimal 2 karakter!",
          };
        }
        break;

      case "pengalaman_kerja_tanggal_mulai_1":
      case "pengalaman_kerja_tanggal_mulai_2":
      case "pengalaman_kerja_tanggal_mulai_3":
      case "pengalaman_kerja_tanggal_mulai_4":
      case "pengalaman_kerja_tanggal_selesai_1":
      case "pengalaman_kerja_tanggal_selesai_2":
      case "pengalaman_kerja_tanggal_selesai_3":
      case "pengalaman_kerja_tanggal_selesai_4":
        if (value.length > 0) {
          // Validasi format tanggal yyyy-mm-dd
          const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
          if (!dateRegex.test(value)) {
            return {
              isValid: false,
              message: "Format tanggal tidak valid!",
            };
          }
        }
        break;

      default:
        // ✅ DEFAULT: Untuk field yang tidak ada validasi khusus
        return { isValid: true };
    }

    return { isValid: true };
  };

  // validateRekeningBankWithMCU = async (newValue) => {
  //   const mcuRekeningValue = this.state.nomor_rekening_bank_mcu;
  //   const { status_karyawan, selected_bank } = this.state;

  //   console.log("🏦 Validating rekening with MCU:", {
  //     newValue,
  //     mcuValue: mcuRekeningValue,
  //     status_karyawan,
  //     selected_bank,
  //   });

  //   // ✅ Validasi format terlebih dahulu
  //   const formatValidation = this.validateRekeningFormat(
  //     newValue,
  //     selected_bank,
  //     status_karyawan
  //   );

  //   if (!formatValidation.isValid) {
  //     await Swal.fire({
  //       title: "Format Rekening Salah!",
  //       text: formatValidation.message,
  //       icon: "error",
  //       confirmButtonText: "OK",
  //     });

  //     // Reset ke nilai MCU jika ada, atau kosongkan
  //     this.setState({
  //       nomor_rekening_bank: mcuRekeningValue || "",
  //       rekening_error: "",
  //     });
  //     return;
  //   }

  //   // ✅ Cek apakah ada data MCU untuk dibandingkan
  //   if (
  //     mcuRekeningValue &&
  //     mcuRekeningValue !== "" &&
  //     mcuRekeningValue !== newValue
  //   ) {
  //     // ✅ Popup konfirmasi dengan SweetAlert2
  //     const result = await Swal.fire({
  //       title: `Nomor Rekening Bank Berubah!`,
  //       html: `
  //       <div style="text-align: left;">
  //         <p><strong>Data MCU:</strong> ${mcuRekeningValue}</p>
  //         <p><strong>Data Baru:</strong> ${newValue}</p>
  //         <br>
  //         <p>Pilih data yang ingin digunakan:</p>
  //       </div>
  //     `,
  //       icon: "question",
  //       showCancelButton: true,
  //       confirmButtonColor: "#3085d6",
  //       cancelButtonColor: "#6c757d",
  //       confirmButtonText: "✅ Gunakan Data Baru",
  //       cancelButtonText: "↩️ Gunakan Data MCU",
  //       reverseButtons: true,
  //     });

  //     if (result.isConfirmed) {
  //       // Gunakan data baru
  //       this.setState(
  //         {
  //           nomor_rekening_bank: newValue,
  //           rekening_error: "",
  //         },
  //         () => {
  //           this.updateSubmitButtonStatus();
  //           Swal.fire({
  //             title: "Berhasil!",
  //             text: `Nomor rekening bank berhasil diperbarui`,
  //             icon: "success",
  //             timer: 2000,
  //             showConfirmButton: false,
  //           });
  //         }
  //       );
  //     } else {
  //       // Gunakan data MCU
  //       this.setState(
  //         {
  //           nomor_rekening_bank: mcuRekeningValue,
  //           rekening_error: "",
  //         },
  //         () => {
  //           this.updateSubmitButtonStatus();
  //           Swal.fire({
  //             title: "Data Dikembalikan",
  //             text: `Menggunakan nomor rekening dari MCU`,
  //             icon: "info",
  //             timer: 2000,
  //             showConfirmButton: false,
  //           });
  //         }
  //       );
  //     }
  //   } else {
  //     // ✅ Tidak ada data MCU atau sama, hanya update validation
  //     this.updateSubmitButtonStatus();
  //   }
  // };

  // // ✅ TAMBAH: Function untuk validasi format rekening
  // validateRekeningFormat = (value, selectedBank, statusKaryawan) => {
  //   if (!value || value.length === 0) {
  //     return { isValid: true }; // Kosong boleh untuk sementara
  //   }

  //   // Hanya angka
  //   if (!/^\d+$/.test(value)) {
  //     return {
  //       isValid: false,
  //       message: "Nomor rekening hanya boleh berisi angka!",
  //     };
  //   }

  //   // ✅ Validasi berdasarkan status karyawan dan bank
  //   if (statusKaryawan === "staff") {
  //     if (value.length !== 10) {
  //       return {
  //         isValid: false,
  //         message: "Nomor rekening MAS harus tepat 10 digit!",
  //       };
  //     }
  //   } else if (statusKaryawan === "nonstaff") {
  //     if (selectedBank === "mandiri") {
  //       if (value.length !== 13) {
  //         return {
  //           isValid: false,
  //           message: "Nomor rekening Mandiri harus tepat 13 digit!",
  //         };
  //       }
  //     } else if (selectedBank === "mas") {
  //       if (value.length !== 10) {
  //         return {
  //           isValid: false,
  //           message: "Nomor rekening MAS harus tepat 10 digit!",
  //         };
  //       }
  //     } else if (selectedBank === "") {
  //       // ✅ Auto-detect berdasarkan panjang
  //       if (value.length !== 10 && value.length !== 13) {
  //         return {
  //           isValid: false,
  //           message:
  //             "Nomor rekening harus 10 digit (MAS) atau 13 digit (Mandiri)!",
  //         };
  //       }
  //     }
  //   }

  //   return { isValid: true };
  // };

  // ✅ HELPER FUNCTION: Mendapatkan nama field yang user-friendly
  getFieldDisplayName = (fieldName) => {
    const fieldNames = {
      nomor_npwp: "NPWP",
      nomor_ktp: "KTP",
      nomor_kk: "Kartu Keluarga",
      nama_lengkap: "Nama Lengkap",
      nomor_hp: "Nomor HP",
      email: "Email",
      tempat_lahir: "Tempat Lahir",
      agama: "Agama",
      jenis_kelamin: "Jenis Kelamin",
      orang_tua_nama_ayah: "Nama Ayah",
      orang_tua_nama_ibu: "Nama Ibu",
      orang_tua_tempat_lahir_ayah: "Tempat Lahir Ayah",
      orang_tua_tempat_lahir_ibu: "Tempat Lahir Ibu",
      orang_tua_tanggal_lahir_ayah: "Tanggal Lahir Ayah",
      orang_tua_tanggal_lahir_ibu: "Tanggal Lahir Ibu",
      kontak_darurat_nama: "Nama Kontak Darurat",
      kontak_darurat_hubungan: "Hubungan Kontak Darurat",
      kontak_darurat_no_telepon: "Nomor Telepon Kontak Darurat",
      pendidikan_terakhir: "Pendidikan Terakhir",
      pendidikan_nama_sekolah: "Nama Sekolah",
      pendidikan_jurusan: "Jurusan",
      addressDetail: "Alamat KTP",
      ASaddressDetail: "Alamat Domisili",
      province: "Provinsi",
      regency: "Kabupaten/Kota",
      district: "Kecamatan",
      village: "Desa/Kelurahan",
      selected_bank: "Bank",
      nomor_rekening_bank: "Nomor Rekening Bank",
      agreement: "Persetujuan",
      npwp_pemadanan_checked: "Checklist NPWP Pemadanan",

      // ✅ TAMBAHAN: Field pengalaman kerja
      pengalaman_kerja_perusahaan_1: "Perusahaan Pengalaman Kerja 1",
      pengalaman_kerja_perusahaan_2: "Perusahaan Pengalaman Kerja 2",
      pengalaman_kerja_perusahaan_3: "Perusahaan Pengalaman Kerja 3",

      pengalaman_kerja_jabatan_1: "Jabatan Pengalaman Kerja 1",
      pengalaman_kerja_jabatan_2: "Jabatan Pengalaman Kerja 2",
      pengalaman_kerja_jabatan_3: "Jabatan Pengalaman Kerja 3",

      pengalaman_kerja_kota_1: "Kota Pengalaman Kerja 1",
      pengalaman_kerja_kota_2: "Kota Pengalaman Kerja 2",
      pengalaman_kerja_kota_3: "Kota Pengalaman Kerja 3",

      pengalaman_kerja_tanggal_mulai_1: "Tanggal Mulai Pengalaman Kerja 1",
      pengalaman_kerja_tanggal_mulai_2: "Tanggal Mulai Pengalaman Kerja 2",
      pengalaman_kerja_tanggal_mulai_3: "Tanggal Mulai Pengalaman Kerja 3",
      // pengalaman_kerja_tanggal_mulai_4: "Tanggal Mulai Pengalaman Kerja 4",

      pengalaman_kerja_tanggal_selesai_1: "Tanggal Selesai Pengalaman Kerja 1",
      pengalaman_kerja_tanggal_selesai_2: "Tanggal Selesai Pengalaman Kerja 2",
      pengalaman_kerja_tanggal_selesai_3: "Tanggal Selesai Pengalaman Kerja 3",
      // pengalaman_kerja_tanggal_selesai_4: "Tanggal Selesai Pengalaman Kerja 4",

      nama_pasangan: "Nama Pasangan",
      tempat_pernikahan: "Tempat Pernikahan",
      tanggal_pernikahan: "Tanggal Pernikahan",
      tempat_lahir_pasangan: "Tempat Lahir Pasangan",
      tanggal_lahir_pasangan: "Tanggal Lahir Pasangan",
      pekerjaan_pasangan: "Pekerjaan Pasangan",
      tempat_pasangan_bekerja: "Tempat Bekerja Pasangan",

      kontak_darurat_hubungan_kerabat: "Hubungan Kerabat",
    };

    return fieldNames[fieldName] || fieldName.replace(/_/g, " ").toUpperCase();
  };

  // ✅ ALTERNATIF: Menggunakan SweetAlert2 untuk popup yang lebih menarik
  validateFieldChangeWithSwal = async (fieldName, newValue) => {
    const mcuFieldName = `${fieldName}_mcu`;
    const mcuValue = this.state[mcuFieldName];

    const normalizeValue = (value) => {
      if (!value || typeof value !== "string") return "";

      return value
        .toString()
        .trim() // Hapus whitespace di awal/akhir
        .toLowerCase() // Ubah ke lowercase
        .replace(/\s+/g, " ") // Ganti multiple spaces dengan single space
        .replace(/[^\w\s]/g, "") // Hapus karakter khusus (opsional)
        .normalize("NFD") // Normalisasi unicode
        .replace(/[\u0300-\u036f]/g, ""); // Hapus diacritics (á → a, é → e)
    };

    const normalizedNewValue = normalizeValue(newValue);
    const normalizedMcuValue = normalizeValue(mcuValue);

    // ✅ DEBUG: Console log untuk troubleshooting
    console.log(`🔍 Comparing field: ${fieldName}`);
    console.log(`📊 Original MCU: "${mcuValue}"`);
    console.log(`📊 Original New: "${newValue}"`);
    console.log(`🔧 Normalized MCU: "${normalizedMcuValue}"`);
    console.log(`🔧 Normalized New: "${normalizedNewValue}"`);
    console.log(`⚖️ Are equal: ${normalizedMcuValue === normalizedNewValue}`);

    if (
      mcuValue &&
      mcuValue !== "" &&
      normalizedMcuValue !== normalizedNewValue
    ) {
      // Validasi format field
      const validationResult = this.validateFieldFormat(fieldName, newValue);

      if (!validationResult.isValid) {
        await Swal.fire({
          title: "Format Data Salah!",
          text: validationResult.message,
          icon: "error",
          confirmButtonText: "OK",
        });
        this.setState({ [fieldName]: mcuValue });
        return;
      }

      // Popup konfirmasi dengan SweetAlert2
      const fieldDisplayName = this.getFieldDisplayName(fieldName);
      const result = await Swal.fire({
        title: `Perbedaan Data ${fieldDisplayName} Terdeteksi!`,
        html: `
        <div style="text-align: left;">
          <p><strong>Data yang pertama dimasukkan :</strong> ${mcuValue}</p>
          <p><strong>Data terbaru yang ditemukan:</strong> ${newValue}</p>
          <br>
          <p>Silahkan pilih data yang benar untuk digunakan:</p>
        </div>
      `,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "✅ Gunakan Data Terbaru",
        cancelButtonText: "↩️ Gunakan Data Lama",
        reverseButtons: true,
      });

      if (result.isConfirmed) {
        // Gunakan data baru
        this.setState({ [fieldName]: newValue }, () => {
          // ✅ PERBAIKAN: Gunakan debounced validation
          this.debouncedUpdateSubmitButtonStatus();
          this.queueAutosave({ [fieldName]: newValue });
          Swal.fire({
            title: "Berhasil!",
            text: `Data ${fieldDisplayName} berhasil diperbarui`,
            icon: "success",
            timer: 2000,
            showConfirmButton: false,
          });
        });
      } else {
        // Gunakan data MCU
        this.setState({ [fieldName]: mcuValue }, () => {
          // ✅ PERBAIKAN: Gunakan debounced validation
          this.debouncedUpdateSubmitButtonStatus();
          this.queueAutosave({ [fieldName]: mcuValue });
          Swal.fire({
            title: "Data Dikembalikan",
            text: `Menggunakan data ${fieldDisplayName} dari yang sebelumnya`,
            icon: "info",
            timer: 2000,
            showConfirmButton: false,
          });
        });
      }
    } else if (newValue.length > 0) {
      const validationResult = this.validateFieldFormat(fieldName, newValue);

      if (!validationResult.isValid) {
        await Swal.fire({
          title: "Format Data Salah!",
          text: validationResult.message,
          icon: "error",
          confirmButtonText: "OK",
        });
        this.setState({ [fieldName]: mcuValue || "" }, () => {
          this.debouncedUpdateSubmitButtonStatus();
          this.queueAutosave({ [fieldName]: mcuValue || "" });
        });
      } else {
        this.debouncedUpdateSubmitButtonStatus();
        this.queueAutosave({ [fieldName]: newValue });
      }
    } else {
      this.debouncedUpdateSubmitButtonStatus();
    }
  };

  render() {
    const {
      alamatDisabled,
      ASalamatDisabled,
      nomor_ktp,
      nama_lengkap,
      nomor_kk,
      nomor_npwp,
      provincesData,
      regenciesData,
      districtsData,
      villagesData,
      ASprovincesData,
      ASregenciesData,
      ASdistrictsData,
      ASvillagesData,
      alamatSesuaiKtp,
      provinceName,
      regencyName,
      districtName,
      villageName,
      addressDetail,
      ASaddressDetail,

      isFormValid,
    } = this.state;
    return (
      <div className="">
        <nav className="main-header-navbar navbar-expand-lg navbar navbar-with-menu bg-white">
          <div className="container-fluid">
            <div className="navbar-wrapper" style={{ width: "100%" }}>
              <div className="navbar-container">
                <div className="navbar-collapse" id="navbar-mobile">
                  <div className="mr-auto float-left bookmark-wrapper d-flex align-items-center logo-container">
                    <div className="navbar-header">
                      <ul className="nav navbar-nav flex-row">
                        <li className="nav-item mr-auto">
                          <a className="navbar-brand" href="/">
                            <div className="brand-logo">
                              <img
                                alt="Logo"
                                className="logo"
                                src={require("../assets/logos/logo-pas.jpg")}
                              />
                            </div>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="mr-auto bookmark-wrapper d-flex align-items-center header-container">
                    <div className="navbar-header">
                      <ul className="nav navbar-nav flex-column">
                        <li className="nav-item text-center">
                          <h1 className="font-header">
                            PT. PRAKARSA ALAM SEGAR
                          </h1>
                        </li>
                        <li className="nav-item text-center">
                          <h2 className="font-sub-header">
                            Human Resource Department
                          </h2>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="bookmark-wrapper d-flex align-items-center">
                    <FormStepNav
                      current="form_1"
                      onGoForm1={this.goToForm1}
                      onGoForm2={this.goToForm2}
                      onGoForm3={this.goToForm3}
                      showForm3={this.canOpenForm3()}
                    />
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={this.handleLogout}
                      style={{ marginLeft: "10px" }}
                    >
                      <i className="bx bx-log-out"></i> Logout
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
        <div className="pembatas"></div>
        <section id="floating-label-layouts">
          <div className="container-fluid">
            <div className="row match-height">
              <div className="col-md-12 col-12">
                <div className="card bg-white">
                  <div className="card-header">
                    <h4 className="card-title text-center">
                      FORM DATA KARTU POKOK KARYAWAN
                    </h4>
                  </div>
                  <div className="card-content">
                    <div className="card-body">
                      <form
                        onSubmit={this.onSubmit}
                        onBlur={this.handleAutosaveBlur}
                        className="form"
                      >
                        <div className="form-body">
                          <div
                            className="alert bg-rgba-secondary alert-dismissible mb-2"
                            role="alert"
                          >
                            <div className="d-flex align-items-center">
                              <i className="bx bx-info-circle"></i>
                              <span>
                                {" "}
                                Setiap kolom dengan tanda (
                                <span className="text-danger">*</span>) wajib di
                                isi
                              </span>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12 margin-top-5 mb-1">
                              <h4>
                                <u>Info Pribadi</u>
                              </h4>
                            </div>
                            <div className="col-sm-6 col-xs-12 margin-top-10">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  value={nomor_ktp}
                                  onChange={this.onChange}
                                  minLength={16}
                                  maxLength={16}
                                  required
                                  pattern="\d*"
                                  type="text"
                                  id="nomor_ktp"
                                  className="form-control"
                                  name="nomor_ktp"
                                  placeholder="Nomor KTP"
                                  readOnly
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-id-card"></i>
                                  <span className="text-danger wajib-diisi">
                                    *
                                  </span>
                                </div>
                                <label htmlFor="nomor_ktp">Nomor KTP</label>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12 margin-top-10">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  value={nama_lengkap}
                                  onChange={this.onChange}
                                  onBlur={this._onBlur}
                                  required
                                  type="text"
                                  id="nama"
                                  className="form-control"
                                  name="nama_lengkap"
                                  placeholder="Nama Lengkap"
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-id-card"></i>
                                  <span className="text-danger wajib-diisi">
                                    *
                                  </span>
                                </div>
                                <label htmlFor="nama">Nama Lengkap</label>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  value={nomor_kk}
                                  onChange={this.onChange}
                                  minLength="16"
                                  maxLength="16"
                                  required
                                  pattern="\d*"
                                  type="text"
                                  id="nomor_kk"
                                  className="form-control"
                                  name="nomor_kk"
                                  placeholder="Nomor KK"
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-id-card"></i>
                                  <span className="text-danger wajib-diisi">
                                    *
                                  </span>
                                </div>
                                <label htmlFor="nomor_kk">Nomor KK</label>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  value={nomor_npwp}
                                  onChange={this.onChange}
                                  onBlur={this._onBlur}
                                  minLength={16}
                                  maxLength={16}
                                  pattern="\d*"
                                  type="text"
                                  id="nomor_npwp"
                                  className="form-control"
                                  name="nomor_npwp"
                                  placeholder="Nomor NIK-NPWP 16 digit"
                                  required
                                />
                                <small className="text-danger text-italic">
                                  Pastikan nomor NIK-NPWP yang tercantum telah
                                  dilakukan pemadanan pada website
                                  djponline.pajak.go.id, karena akan ada upload
                                  bukti pemadanan di form selanjutnya
                                </small>
                                <div className="form-group form-check mb-2">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="npwp-pemadanan-checklist"
                                    name="npwp-pemadanan-checklist"
                                    checked={this.state.npwp_pemadanan_checked}
                                    required
                                    onChange={this.onCheckboxChange}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="npwp-pemadanan-checklist"
                                  >
                                    NPWP telah dilakukan pemadanan
                                  </label>
                                </div>
                                <div className="form-control-position">
                                  <i className="bx bx-id-card"></i>
                                  <span className="text-danger wajib-diisi">
                                    *
                                  </span>
                                </div>
                                <label htmlFor="nomor_npwp">Nomor NPWP</label>
                              </div>
                            </div>

                            <div className="col-sm-6 col-sm-12">
                              <div className="form-group">
                                <label className="d-block">
                                  Agama{" "}
                                  <span className="text-danger wajib-diisi">
                                    *
                                  </span>
                                </label>
                                <div className="custom-control-inline">
                                  <div className="radio mr-1">
                                    <input
                                      onChange={this.onRadioChange}
                                      checked={this.state.agama === "islam"}
                                      value="islam"
                                      type="radio"
                                      name="agama"
                                      id="islam"
                                    />
                                    <label htmlFor="islam">Islam</label>
                                  </div>
                                  <div className="radio mr-1">
                                    <input
                                      onChange={this.onRadioChange}
                                      checked={this.state.agama === "budha"}
                                      value="budha"
                                      type="radio"
                                      name="agama"
                                      id="budha"
                                    />
                                    <label htmlFor="budha">Budha</label>
                                  </div>
                                  <div className="radio mr-1">
                                    <input
                                      onChange={this.onRadioChange}
                                      checked={this.state.agama === "hindu"}
                                      value="hindu"
                                      type="radio"
                                      name="agama"
                                      id="hindu"
                                    />
                                    <label htmlFor="hindu">Hindu</label>
                                  </div>
                                  <div className="radio mr-1">
                                    <input
                                      onChange={this.onRadioChange}
                                      checked={this.state.agama === "katolik"}
                                      value="katolik"
                                      type="radio"
                                      name="agama"
                                      id="katolik"
                                    />
                                    <label htmlFor="katolik">Katolik</label>
                                  </div>
                                  <div className="radio mr-1">
                                    <input
                                      onChange={this.onRadioChange}
                                      checked={this.state.agama === "kristen"}
                                      value="kristen"
                                      type="radio"
                                      name="agama"
                                      id="kristen"
                                    />
                                    <label htmlFor="kristen">Kristen</label>
                                  </div>
                                  <div className="radio mr-1">
                                    <input
                                      onChange={this.onRadioChange}
                                      checked={
                                        this.state.agama === "kong hu cu"
                                      }
                                      value="kong hu cu"
                                      type="radio"
                                      name="agama"
                                      id="kong-hu-cu"
                                    />
                                    <label htmlFor="kong-hu-cu">
                                      Kong Hu Cu
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-6 col-sm-12">
                              <div className="form-group">
                                <label className="d-block">
                                  Jenis Kelamin{" "}
                                  <span className="text-danger wajib-diisi">
                                    *
                                  </span>
                                </label>
                                <div className="custom-control-inline">
                                  <div className="radio mr-1">
                                    <input
                                      onChange={this.onRadioChange}
                                      checked={this.state.jenis_kelamin === "L"}
                                      value="L"
                                      type="radio"
                                      name="jenis_kelamin"
                                      id="pria"
                                    />
                                    <label htmlFor="pria">Laki-laki</label>
                                  </div>
                                  <div className="radio mr-1">
                                    <input
                                      onChange={this.onRadioChange}
                                      checked={this.state.jenis_kelamin === "P"}
                                      value="P"
                                      type="radio"
                                      name="jenis_kelamin"
                                      id="wanita"
                                    />
                                    <label htmlFor="wanita">Perempuan</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12 mt-2">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  value={this.state.tempat_lahir}
                                  onChange={this.onChange}
                                  onBlur={this._onBlur}
                                  required
                                  type="text"
                                  id="tempat-lahir"
                                  className="form-control"
                                  name="tempat_lahir"
                                  placeholder="Tempat Lahir"
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-map"></i>
                                  <span className="text-danger wajib-diisi">
                                    *
                                  </span>
                                </div>
                                <label htmlFor="tempat-lahir">
                                  Tempat Lahir
                                </label>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12 mt-2">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onTanggalLahirChange}
                                  onBlur={this._onBlur}
                                  required
                                  value={this.state.tanggal_lahir_formatted}
                                  type="date"
                                  id="tanggal-lahir"
                                  className="form-control"
                                  name="tanggal_lahir"
                                  placeholder="Tanggal Lahir"
                                />
                                {/* <div className="form-control-position">
                                  <i className="bx bx-calendar"></i>
                                  <span className="text-danger wajib-diisi">
                                    *
                                  </span>
                                </div> */}
                                <label htmlFor="tanggal-lahir">
                                  Tanggal Lahir
                                </label>
                              </div>
                            </div>
                            <div className="col-md-6 col-xs-12">
                              <div className="form-group">
                                <label className="d-block">
                                  Alamat Sesuai KTP
                                  <span className="text-danger wajib-diisi">
                                    *
                                  </span>
                                </label>
                              </div>
                              <div className="form-group">
                                <Select
                                  required
                                  placeholder="Pilih Provinsi"
                                  options={provincesData}
                                  getOptionValue={(option) => `${option.id}`}
                                  getOptionLabel={(option) => `${option.name}`}
                                  onChange={this.onProvinceChange}
                                />
                              </div>
                              <div className="form-group">
                                <Select
                                  required
                                  placeholder="Pilih Kabupaten / Kota"
                                  options={regenciesData}
                                  getOptionValue={(option) => `${option.id}`}
                                  getOptionLabel={(option) => `${option.name}`}
                                  onChange={this.onRegencyChange}
                                />
                              </div>
                              <div className="form-group">
                                <Select
                                  required
                                  placeholder="Pilih Kecamatan"
                                  options={districtsData}
                                  getOptionValue={(option) => `${option.id}`}
                                  getOptionLabel={(option) => `${option.name}`}
                                  onChange={this.onDistrictChange}
                                />
                              </div>
                              <div className="form-group">
                                <Select
                                  required
                                  placeholder="Pilih Desa"
                                  options={villagesData}
                                  getOptionValue={(option) => `${option.id}`}
                                  getOptionLabel={(option) => `${option.name}`}
                                  onChange={this.onVillageChange}
                                />
                              </div>
                              <div className="form-label-group mt-4">
                                <textarea
                                  onChange={this.onAddressChange}
                                  onBlur={this._onBlur}
                                  disabled={alamatDisabled}
                                  required
                                  name="addressDetail"
                                  className="form-control"
                                  id="alamat-rumah"
                                  rows="3"
                                  placeholder="Blok, nomor rumah, rt rw."
                                  spellCheck="false"
                                  value={this.state.addressDetail}
                                ></textarea>
                                <label htmlFor="alamat-rumah">Alamat</label>
                              </div>
                            </div>
                            <div className="col-md-6 col-xs-12">
                              <div className="form-group">
                                <label className="d-block">
                                  Alamat Tempat Tinggal Sekarang
                                  <span className="text-danger wajib-diisi">
                                    *
                                  </span>
                                </label>
                              </div>
                              <label>
                                <input
                                  onChange={this.toggleAlamatSesuaiKTP}
                                  type="checkbox"
                                  checked={alamatSesuaiKtp}
                                />{" "}
                                <span className="alamat-sesuai-ktp">
                                  {" "}
                                  Sama Dengan alamat KTP
                                </span>
                              </label>
                              {!alamatSesuaiKtp ? (
                                <div>
                                  <div className="form-group">
                                    <Select
                                      placeholder="Pilih Provinsi"
                                      options={ASprovincesData}
                                      getOptionValue={(option) =>
                                        `${option.id}`
                                      }
                                      getOptionLabel={(option) =>
                                        `${option.name}`
                                      }
                                      onChange={this.onASProvinceChange}
                                    />
                                  </div>
                                  <div className="form-group">
                                    <Select
                                      placeholder="Pilih Kabupaten / Kota "
                                      options={ASregenciesData}
                                      getOptionValue={(option) =>
                                        `${option.id}`
                                      }
                                      getOptionLabel={(option) =>
                                        `${option.name}`
                                      }
                                      onChange={this.onASRegencyChange}
                                    />
                                  </div>
                                  <div className="form-group">
                                    <Select
                                      placeholder="Pilih Kecamatan"
                                      options={ASdistrictsData}
                                      getOptionValue={(option) =>
                                        `${option.id}`
                                      }
                                      getOptionLabel={(option) =>
                                        `${option.name}`
                                      }
                                      onChange={this.onASDistrictChange}
                                    />
                                  </div>
                                  <div className="form-group">
                                    <Select
                                      placeholder="Pilih Desa"
                                      options={ASvillagesData}
                                      getOptionValue={(option) =>
                                        `${option.id}`
                                      }
                                      getOptionLabel={(option) =>
                                        `${option.name}`
                                      }
                                      onChange={this.onASVillageChange}
                                    />
                                  </div>
                                  <div className="form-label-group mt-4">
                                    <textarea
                                      onChange={this.onASAddressChange}
                                      disabled={ASalamatDisabled}
                                      required
                                      name="ASaddressDisabled"
                                      onBlur={this._onBlur}
                                      className="form-control"
                                      id="alamat-rumah-sekarang"
                                      rows="3"
                                      placeholder="Blok, nomor rumah, rt rw."
                                      spellcheck="false"
                                      value={this.state.ASaddressDetail}
                                    ></textarea>
                                    <label htmlFor="alamat-rumah-sekarang">
                                      Alamat
                                    </label>
                                  </div>
                                </div>
                              ) : (
                                <div className="mt-1">
                                  <div className="form-group row">
                                    <label className="col-3 col-form-label text-right">
                                      Provinsi{" "}
                                    </label>
                                    <div className="col-9">
                                      <input
                                        readOnly
                                        className="form-control"
                                        type="text"
                                        value={provinceName}
                                        id="example-text-input"
                                      />
                                    </div>
                                  </div>
                                  <div className="form-group row">
                                    <label className="col-3 col-form-label text-right">
                                      Kabupaten / Kota{" "}
                                    </label>
                                    <div className="col-9">
                                      <input
                                        readOnly
                                        className="form-control"
                                        type="text"
                                        value={regencyName}
                                        id="example-text-input"
                                      />
                                    </div>
                                  </div>
                                  <div className="form-group row">
                                    <label className="col-3 col-form-label text-right">
                                      Kecamatan{" "}
                                    </label>
                                    <div className="col-9">
                                      <input
                                        readOnly
                                        className="form-control"
                                        type="text"
                                        value={districtName}
                                        id="example-text-input"
                                      />
                                    </div>
                                  </div>
                                  <div className="form-group row">
                                    <label className="col-3 col-form-label text-right">
                                      Desa{" "}
                                    </label>
                                    <div className="col-9">
                                      <input
                                        readOnly
                                        className="form-control"
                                        type="text"
                                        value={villageName}
                                        id="example-text-input"
                                      />
                                    </div>
                                  </div>
                                  <div className="form-group row">
                                    <label className="col-3 col-form-label text-right">
                                      Alamat{" "}
                                    </label>
                                    <div className="col-9">
                                      <textarea
                                        className="form-control"
                                        readOnly
                                        // name="ASaddressDetail" // ✅ TAMBAH: name attribute
                                        value={this.state.addressDetail}
                                      ></textarea>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className="col-sm-6 col-xs-12 mt-2">
                              <div className="form-group">
                                <div className="input-group">
                                  <div className="input-group-prepend">
                                    <label
                                      className="input-group-text bg-white"
                                      htmlFor="keterangan-bpjs-kesehatan"
                                    >
                                      Golongan Darah
                                    </label>
                                  </div>
                                  <select
                                    defaultValue={this.state.golongan_darah}
                                    onChange={this.onChange}
                                    name="golongan_darah"
                                    className="form-control"
                                    id="golongan_darah"
                                  >
                                    <option value="">Tidak Tahu</option>
                                    <option value="A">A</option>
                                    <option value="B">B</option>
                                    <option value="AB">AB</option>
                                    <option value="O">O</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12 mt-2">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onChange}
                                  required
                                  value={this.state.tanggal_masuk}
                                  type="date"
                                  id="tanggal-masuk"
                                  className="form-control"
                                  name="tanggal_masuk"
                                  placeholder="Tanggal Masuk"
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-calendar"></i>
                                  <span className="text-danger wajib-diisi">
                                    *
                                  </span>
                                </div>
                                <label htmlFor="tanggal-masuk">
                                  Tanggal Masuk Kerja
                                </label>
                              </div>
                            </div>

                            <div className="col-12 margin-top-5 mb-1 mt-1">
                              <h4>
                                <u>Info Kontak</u>
                              </h4>
                            </div>
                            <div className="col-sm-6 col-xs-12 margin-top-10">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  value={this.state.nomor_hp}
                                  onChange={this.onChange}
                                  onBlur={this._onBlur}
                                  maxLength="16"
                                  required
                                  pattern="\d*"
                                  type="text"
                                  id="nomor_hp"
                                  className="form-control"
                                  name="nomor_hp"
                                  placeholder="Nomor HP"
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-phone"></i>
                                  <span className="text-danger wajib-diisi">
                                    *
                                  </span>
                                </div>
                                <label htmlFor="nomor_hp">Nomor HP</label>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12 margin-top-10">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  value={this.state.email}
                                  onChange={this.onChange}
                                  onBlur={this._onBlur}
                                  required
                                  type="email"
                                  id="email"
                                  className="form-control"
                                  name="email"
                                  placeholder="Email"
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-envelope"></i>
                                  <span className="text-danger wajib-diisi">
                                    *
                                  </span>
                                </div>
                                <label htmlFor="email">Email</label>
                              </div>
                            </div>

                            <div className="col-12 margin-top-5 mb-1">
                              <h4>
                                <u>Info Sosial Media</u>
                              </h4>
                            </div>
                            <div className="col-sm-6 col-xs-12 margin-top-10">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  value={this.state.sosmed_facebook}
                                  onChange={this.onChange}
                                  maxLength="100"
                                  type="text"
                                  id="sosmed_facebook"
                                  className="form-control"
                                  name="sosmed_facebook"
                                  placeholder="Facebook"
                                />
                                <div className="form-control-position">
                                  <i className="bx bxl-facebook"></i>
                                </div>
                                <label htmlFor="sosmed_facebook">
                                  Facebook
                                </label>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12 margin-top-10">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  value={this.state.sosmed_twitter}
                                  onChange={this.onChange}
                                  maxLength="100"
                                  type="text"
                                  id="sosmed_twitter"
                                  className="form-control"
                                  name="sosmed_twitter"
                                  placeholder="Twitter"
                                />
                                <div className="form-control-position">
                                  <i className="bx bxl-twitter"></i>
                                </div>
                                <label htmlFor="sosmed_twitter">Twitter</label>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12 margin-top-10">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  value={this.state.sosmed_linkedin}
                                  onChange={this.onChange}
                                  maxLength="100"
                                  type="text"
                                  id="sosmed_linkedin"
                                  className="form-control"
                                  name="sosmed_linkedin"
                                  placeholder="Linkedin"
                                />
                                <div className="form-control-position">
                                  <i className="bx bxl-linkedin"></i>
                                </div>
                                <label htmlFor="sosmed_linkedin">
                                  Linkedin
                                </label>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12 margin-top-10">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  value={this.state.sosmed_instagram}
                                  onChange={this.onChange}
                                  maxLength="16"
                                  type="text"
                                  id="sosmed_instagram"
                                  className="form-control"
                                  name="sosmed_instagram"
                                  placeholder="Instagram"
                                />
                                <div className="form-control-position">
                                  <i className="bx bxl-instagram"></i>
                                </div>
                                <label htmlFor="sosmed_instagram">
                                  Instagram
                                </label>
                              </div>
                            </div>

                            <div className="col-sm-6 col-xs-12"></div>

                            <div className="col-12 margin-top-5 mb-1">
                              <h4>
                                <u>Info Pendidikan Terakhir</u>
                              </h4>
                            </div>
                            <div
                              className="col-sm-6 col-xs-12"
                              style={{ marginTop: "-11px" }}
                            >
                              <div className="form-group">
                                <label htmlFor="pendidikan_terakhir">
                                  Pendidikan Terakhir{" "}
                                  <span className="text-danger wajib-diisi">
                                    *
                                  </span>
                                </label>
                                <select
                                  required
                                  className="form-control"
                                  name="pendidikan_terakhir"
                                  id="pendidikan_terakhir"
                                  onChange={this.onChange}
                                  value={this.state.pendidikan_terakhir}
                                >
                                  <option value="">Pilih pendidikan</option>
                                  {/* <option value="SMA">SMA</option>
                                    <option value="D3">D3</option>
                                    <option value="SMU">SMU</option>
                                    <option value="LP3I">LP3I</option>
                                    <option value="STM">STM</option>
                                    <option value="D1">D1</option>
                                    <option value="SLTA">SLTA</option>
                                    <option value="UPER">UPER</option>
                                    <option value="PGTKI Nusantara">PGTKI Nusantara</option> */}
                                  <option value="SD">SD</option>
                                  <option value="SMP">SLTP / SMP</option>
                                  <option value="SMA">
                                    SLTA / SMA / MA / SMU
                                  </option>
                                  <option value="SMK">SMK / STM / SMEA</option>
                                  <option value="D1">D1</option>
                                  <option value="D2">D2</option>
                                  <option value="D3">D3</option>
                                  <option value="D4">D4</option>
                                  <option value="S1">S1</option>
                                  <option value="S2">S2</option>
                                  <option value="S3">S3</option>
                                </select>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12 margin-top-10">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  required
                                  value={this.state.pendidikan_nama_sekolah}
                                  onChange={this.onChange}
                                  onBlur={this._onBlur}
                                  maxLength="150"
                                  type="text"
                                  id="pendidikan_nama_sekolah"
                                  className="form-control"
                                  name="pendidikan_nama_sekolah"
                                  placeholder="Nama Sekolah / Universitas"
                                />
                                <div className="form-control-position">
                                  <i className="bx bxs-school"></i>{" "}
                                  <span className="text-danger wajib-diisi">
                                    *
                                  </span>
                                </div>
                                <label htmlFor="pendidikan_nama_sekolah">
                                  Nama Sekolah / Universitas
                                </label>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12 margin-top-10">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  required
                                  value={this.state.pendidikan_jurusan}
                                  onChange={this.onChange}
                                  onBlur={this._onBlur}
                                  maxLength="150"
                                  type="text"
                                  id="pendidikan_jurusan"
                                  className="form-control"
                                  name="pendidikan_jurusan"
                                  placeholder="Jurusan"
                                />
                                <div className="form-control-position">
                                  <i className="bx bxs-user-detail"></i>{" "}
                                  <span className="text-danger wajib-diisi">
                                    *
                                  </span>
                                </div>
                                <label htmlFor="pendidikan_jurusan">
                                  Jurusan
                                </label>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12 margin-top-10">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  value={this.state.pendidikan_kursus}
                                  onChange={this.onChange}
                                  maxLength="150"
                                  type="text"
                                  id="pendidikan_kursus"
                                  className="form-control"
                                  name="pendidikan_kursus"
                                  placeholder="Kursus"
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-book"></i>
                                </div>
                                <label htmlFor="pendidikan_kursus">
                                  Kursus
                                </label>
                              </div>
                            </div>

                            <div className="col-sm-6 col-xs-12"></div>

                            <div className="col-12">
                              <br />
                              <h4>
                                <u>Info Perdata</u>
                              </h4>
                              <hr />
                            </div>
                            <div className="col-sm-6 col-sm-12">
                              <div className="form-group">
                                <label className="d-block">
                                  Status Perdata{" "}
                                  <span className="text-danger wajib-diisi">
                                    *
                                  </span>
                                </label>
                                <div className="custom-control-inline">
                                  <div className="radio mr-1">
                                    <input
                                      onChange={this.onStatusPerdataChange}
                                      checked={
                                        this.state.status_perdata ===
                                        "Belum Menikah"
                                      }
                                      required
                                      value="Belum Menikah"
                                      type="radio"
                                      name="status_perdata"
                                      id="status-belum-menikah"
                                    />
                                    <label htmlFor="status-belum-menikah">
                                      Belum Menikah
                                    </label>
                                  </div>
                                  <div className="radio mr-1">
                                    <input
                                      onChange={this.onStatusPerdataChange}
                                      checked={
                                        this.state.status_perdata === "Menikah"
                                      }
                                      required
                                      value="Menikah"
                                      type="radio"
                                      name="status_perdata"
                                      id="status-menikah"
                                    />
                                    <label htmlFor="status-menikah">
                                      Menikah
                                    </label>
                                  </div>
                                  <div className="radio mr-1">
                                    <input
                                      onChange={this.onStatusPerdataChange}
                                      checked={
                                        this.state.status_perdata === "Cerai"
                                      }
                                      required
                                      value="Cerai"
                                      type="radio"
                                      name="status_perdata"
                                      id="status-cerai"
                                    />
                                    <label htmlFor="status-cerai">Cerai</label>
                                  </div>
                                </div>
                                {this.state.status_karyawan ===
                                  "nonstaff helper" && (
                                  <small className="text-danger d-block mt-1">
                                    Nonstaff helper harus berstatus belum kawin.
                                  </small>
                                )}
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onChange}
                                  disabled={this.isStatusPerdataBelumMenikahOrCerai()}
                                  type="text"
                                  id="nama-pasangan"
                                  className="form-control"
                                  name="nama_pasangan"
                                  placeholder="Nama Pasangan"
                                  value={this.state.nama_pasangan}
                                  required={
                                    !this.isStatusPerdataBelumMenikahOrCerai()
                                  }
                                />
                                <div className="form-control-position">
                                  <i className="bx bxs-user-detail"></i>
                                  {!this.isStatusPerdataBelumMenikahOrCerai() && (
                                    <span className="text-danger wajib-diisi">
                                      *
                                    </span>
                                  )}
                                </div>
                                <label htmlFor="nama-pasangan">
                                  Nama Pasangan
                                </label>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onChange}
                                  disabled={this.isStatusPerdataBelumMenikahOrCerai()}
                                  type="text"
                                  id="tempat-pernikahan"
                                  className="form-control"
                                  name="tempat_pernikahan"
                                  placeholder="Tempat Pernikahan"
                                  value={this.state.tempat_pernikahan}
                                  required={
                                    !this.isStatusPerdataBelumMenikahOrCerai()
                                  }
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-map"></i>
                                  {!this.isStatusPerdataBelumMenikahOrCerai() && (
                                    <span className="text-danger wajib-diisi">
                                      *
                                    </span>
                                  )}
                                </div>
                                <label htmlFor="tempat-pernikahan">
                                  Tempat Pernikahan
                                </label>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onChange}
                                  disabled={this.isStatusPerdataBelumMenikahOrCerai()}
                                  type="date"
                                  id="tanggal-pernikahan"
                                  className="form-control"
                                  name="tanggal_pernikahan"
                                  placeholder="Tgl Pernikahan"
                                  value={this.state.tanggal_pernikahan}
                                  required={
                                    !this.isStatusPerdataBelumMenikahOrCerai()
                                  }
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-calendar"></i>
                                  {!this.isStatusPerdataBelumMenikahOrCerai() && (
                                    <span className="text-danger wajib-diisi">
                                      *
                                    </span>
                                  )}
                                </div>
                                <label htmlFor="tanggal-pernikahan">
                                  Tanggal Pernikahan
                                </label>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onChange}
                                  disabled={this.isStatusPerdataBelumMenikahOrCerai()}
                                  type="text"
                                  id="tempat-lahir-pasangan"
                                  className="form-control"
                                  name="tempat_lahir_pasangan"
                                  placeholder="Tempat Lahir Pasangan"
                                  value={this.state.tempat_lahir_pasangan}
                                  required={
                                    !this.isStatusPerdataBelumMenikahOrCerai()
                                  }
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-map"></i>
                                  {!this.isStatusPerdataBelumMenikahOrCerai() && (
                                    <span className="text-danger wajib-diisi">
                                      *
                                    </span>
                                  )}
                                </div>
                                <label htmlFor="tempat-lahir-pasangan">
                                  Tempat Lahir Pasangan
                                </label>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onChange}
                                  disabled={this.isStatusPerdataBelumMenikahOrCerai()}
                                  type="date"
                                  id="tanggal-lahir-pasangan"
                                  className="form-control"
                                  name="tanggal_lahir_pasangan"
                                  placeholder="Tgl Lahir Pasangan"
                                  value={this.state.tanggal_lahir_pasangan}
                                  required={
                                    !this.isStatusPerdataBelumMenikahOrCerai()
                                  }
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-calendar"></i>
                                  {!this.isStatusPerdataBelumMenikahOrCerai() && (
                                    <span className="text-danger wajib-diisi">
                                      *
                                    </span>
                                  )}
                                </div>
                                <label htmlFor="tanggal-lahir-pasangan">
                                  Tanggal Lahir Pasangan
                                </label>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onChange}
                                  disabled={this.isStatusPerdataBelumMenikahOrCerai()}
                                  type="text"
                                  id="pekerjaan-pasangan"
                                  className="menikah form-control"
                                  name="pekerjaan_pasangan"
                                  placeholder="Pekerjaan Pasangan"
                                  value={this.state.pekerjaan_pasangan}
                                  required={
                                    !this.isStatusPerdataBelumMenikahOrCerai()
                                  }
                                />
                                <div className="form-control-position">
                                  <i className="bx bxs-user-detail"></i>
                                  {!this.isStatusPerdataBelumMenikahOrCerai() && (
                                    <span className="text-danger wajib-diisi">
                                      *
                                    </span>
                                  )}
                                </div>
                                <label htmlFor="pekerjaan-pasangan">
                                  Pekerjaan Pasangan
                                </label>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onChange}
                                  disabled={this.isStatusPerdataBelumMenikahOrCerai()}
                                  type="text"
                                  id="tempat-pasangan-bekerja"
                                  className="form-control"
                                  name="tempat_pasangan_bekerja"
                                  placeholder="Tempat Pasangan Bekerja"
                                  value={this.state.tempat_pasangan_bekerja}
                                  required={
                                    !this.isStatusPerdataBelumMenikahOrCerai()
                                  }
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-map-pin"></i>
                                  {!this.isStatusPerdataBelumMenikahOrCerai() && (
                                    <span className="text-danger wajib-diisi">
                                      *
                                    </span>
                                  )}
                                </div>
                                <label htmlFor="tempat-pasangan-bekerja">
                                  Tempat Pasangan Bekerja
                                </label>
                              </div>
                            </div>
                            <div className="col-12">
                              <h4>
                                <u>
                                  Pengalaman Kerja (Termasuk PKL, Magang atau
                                  Internship)
                                </u>
                              </h4>
                              <hr />
                            </div>
                            <div className="col-12">
                              <div className="table-responsive">
                                <table
                                  style={{ width: "1200px" }}
                                  className="table hover table-no-padding"
                                >
                                  <thead>
                                    <tr>
                                      <th>NAMA PERUSAHAAN</th>
                                      <th>JABATAN</th>
                                      <th style={{ width: "400px" }}>
                                        LAMA BEKERJA
                                      </th>
                                      <th>KOTA</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {[1, 2, 3, 4].map((object, i) => {
                                      return (
                                        <tr key={i}>
                                          <td>
                                            <textarea
                                              onChange={this.onChange}
                                              onBlur={this._onBlur}
                                              name={
                                                "pengalaman_kerja_perusahaan_" +
                                                object
                                              }
                                              value={
                                                this.state[
                                                  "pengalaman_kerja_perusahaan_" +
                                                    object
                                                ]
                                              }
                                              rows="1"
                                              className="form-control"
                                            ></textarea>
                                          </td>
                                          <td>
                                            <input
                                              onChange={this.onChange}
                                              onBlur={this._onBlur}
                                              name={
                                                "pengalaman_kerja_jabatan_" +
                                                object
                                              }
                                              value={
                                                this.state[
                                                  "pengalaman_kerja_jabatan_" +
                                                    object
                                                ]
                                              }
                                              type="text"
                                              className="form-control"
                                            />
                                          </td>
                                          <td>
                                            <div className="row">
                                              <div className="col-sm-6 col-xs-12">
                                                <input
                                                  onChange={this.onChange}
                                                  onBlur={this._onBlur}
                                                  name={
                                                    "pengalaman_kerja_tanggal_mulai_" +
                                                    object
                                                  }
                                                  value={
                                                    this.state[
                                                      "pengalaman_kerja_tanggal_mulai_" +
                                                        object
                                                    ]
                                                  }
                                                  onFocus={this._onFocus}
                                                  type="date"
                                                  className="form-control"
                                                  placeholder="Tanggal Mulai"
                                                />
                                              </div>
                                              <div className="col-sm-6 col-xs-12">
                                                <input
                                                  onChange={this.onChange}
                                                  onBlur={this._onBlur}
                                                  name={
                                                    "pengalaman_kerja_tanggal_selesai_" +
                                                    object
                                                  }
                                                  value={
                                                    this.state[
                                                      "pengalaman_kerja_tanggal_selesai_" +
                                                        object
                                                    ]
                                                  }
                                                  onFocus={this._onFocus}
                                                  // onBlur={this._onBlur}
                                                  type="date"
                                                  className="form-control"
                                                  placeholder="Tanggal Selesai"
                                                />
                                              </div>
                                            </div>
                                          </td>
                                          <td>
                                            <input
                                              onChange={this.onChange}
                                              onBlur={this._onBlur}
                                              name={
                                                "pengalaman_kerja_kota_" +
                                                object
                                              }
                                              value={
                                                this.state[
                                                  "pengalaman_kerja_kota_" +
                                                    object
                                                ]
                                              }
                                              type="text"
                                              className="form-control"
                                            />
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            <div className="col-12 mt-2">
                              <h4>
                                <u>Sertifikasi Pelatihan / Training</u>
                              </h4>
                              <hr />
                            </div>
                            <div className="col-12">
                              <div className="table-responsive">
                                <table
                                  style={{ width: "1200px" }}
                                  className="table hover table-no-padding"
                                >
                                  <thead>
                                    <tr>
                                      <th>NAMA SERTIFIKASI</th>
                                      <th>LEMBAGA PEMBERI</th>
                                      <th>UPLOAD GAMBAR SERTIFIKASI</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {[1, 2, 3, 4].map((object, i) => {
                                      return (
                                        <tr key={i}>
                                          <td>
                                            <textarea
                                              onChange={this.onChange}
                                              name={
                                                "nama_sertifikasi_" + object
                                              }
                                              rows="1"
                                              className="form-control"
                                            ></textarea>
                                          </td>
                                          <td>
                                            <input
                                              onChange={this.onChange}
                                              name={"lembaga_pemberi_" + object}
                                              type="text"
                                              className="form-control"
                                            />
                                          </td>
                                          <td>
                                            <div className="input-group">
                                              <div className="input-group-prepend">
                                                <span
                                                  className="input-group-text"
                                                  id={
                                                    "file_sertifikasi_" + object
                                                  }
                                                >
                                                  Upload
                                                </span>
                                              </div>
                                              <div className="custom-file">
                                                <input
                                                  accept="image/x-png,image/jpeg,image/jpg"
                                                  type="file"
                                                  value={
                                                    this.state[
                                                      `foto_sertifikasi_training_${object}`
                                                    ]
                                                  }
                                                  onChange={this.selectFotoSertifikasiTraining(
                                                    object,
                                                  )}
                                                  name={
                                                    "file_sertifikasi_" + object
                                                  }
                                                  className="custom-file-input"
                                                  id={
                                                    "file_sertifikasi_" + object
                                                  }
                                                  aria-describedby={
                                                    "file_sertifikasi_" + object
                                                  }
                                                />
                                                <label
                                                  className="custom-file-label"
                                                  htmlFor={
                                                    "file_sertifikasi_" + object
                                                  }
                                                >
                                                  {/* ✅ TAMBAH: Status upload dinamis */}
                                                  {this.state[
                                                    `foto_sertifikasi_training_${object}_label`
                                                  ] || "Choose file"}
                                                </label>
                                              </div>
                                            </div>
                                            {/* ✅ TAMBAH: Status upload */}
                                            <small className="text-muted">
                                              <i>
                                                {
                                                  this.state[
                                                    `foto_sertifikasi_training_${object}_status`
                                                  ]
                                                }
                                              </i>
                                            </small>
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            <div className="col-12">
                              <br />
                              <h4>
                                <u>Data Anak (Sesuai Kartu Keluarga)</u>
                              </h4>
                              <hr />
                            </div>
                            <div className="col-12">
                              <div className="table-responsive">
                                <table
                                  style={{ width: "1200px" }}
                                  className="table hover table-no-padding"
                                >
                                  <thead>
                                    <tr>
                                      <th>NAMA</th>
                                      <th>JENIS KELAMIN</th>
                                      <th>TEMPAT LAHIR</th>
                                      <th>TANGGAL LAHIR</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {[1, 2, 3, 4].map((object, i) => {
                                      return (
                                        <tr key={i}>
                                          <td>
                                            <input
                                              onChange={this.onChange}
                                              name={"anak_anak_nama_" + object}
                                              type="text"
                                              disabled={
                                                !this.isStatusPerdataBelumMenikah()
                                              }
                                              className="form-control"
                                            />
                                          </td>
                                          <td
                                            style={{
                                              backgroundColor:
                                                !this.isStatusPerdataBelumMenikah()
                                                  ? "#f2f4f4"
                                                  : "white",
                                            }}
                                          >
                                            <div className="custom-control-inline">
                                              <div className="radio mr-1">
                                                <input
                                                  onChange={this.onChange}
                                                  value="L"
                                                  type="radio"
                                                  disabled={
                                                    !this.isStatusPerdataBelumMenikah()
                                                  }
                                                  name={
                                                    "anak_anak_jenis_kelamin_" +
                                                    object
                                                  }
                                                  id={"anak-pria-" + object}
                                                />
                                                <label
                                                  htmlFor={
                                                    "anak-pria-" + object
                                                  }
                                                >
                                                  Laki-laki
                                                </label>
                                              </div>
                                              <div className="radio mr-1">
                                                <input
                                                  onChange={this.onChange}
                                                  value="P"
                                                  type="radio"
                                                  disabled={
                                                    !this.isStatusPerdataBelumMenikah()
                                                  }
                                                  name={
                                                    "anak_anak_jenis_kelamin_" +
                                                    object
                                                  }
                                                  id={"anak-wanita-" + object}
                                                />
                                                <label
                                                  htmlFor={
                                                    "anak-wanita-" + object
                                                  }
                                                >
                                                  Perempuan
                                                </label>
                                              </div>
                                            </div>
                                          </td>
                                          <td>
                                            <input
                                              onChange={this.onChange}
                                              name={
                                                "anak_anak_tempat_lahir_" +
                                                object
                                              }
                                              type="text"
                                              disabled={
                                                !this.isStatusPerdataBelumMenikah()
                                              }
                                              className="form-control"
                                            />
                                          </td>
                                          <td>
                                            <input
                                              onChange={this.onChange}
                                              name={
                                                "anak_anak_tanggal_lahir_" +
                                                object
                                              }
                                              disabled={
                                                !this.isStatusPerdataBelumMenikah()
                                              }
                                              type="date"
                                              className="form-control"
                                            />
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            <div className="col-12 mb-1">
                              <br />
                              <h4>
                                <u>Orang Tua (Sesuai Kartu Keluarga)</u>
                              </h4>
                              <hr />
                            </div>
                            <div className="col-12">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onChange}
                                  onBlur={this._onBlur}
                                  required
                                  type="text"
                                  id="nama-ayah"
                                  className="form-control"
                                  name="orang_tua_nama_ayah"
                                  placeholder="Nama Ayah"
                                  value={this.state.orang_tua_nama_ayah}
                                />
                                <div className="form-control-position">
                                  <i className="bx bxs-user-detail"></i>
                                  <span className="text-danger wajib-diisi">
                                    *
                                  </span>
                                </div>
                                <label htmlFor="nama-ayah">Nama Ayah</label>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onChange}
                                  onBlur={this._onBlur}
                                  type="text"
                                  id="tempat-lahir-ayah"
                                  className="form-control"
                                  name="orang_tua_tempat_lahir_ayah"
                                  placeholder="Tempat Lahir Ayah"
                                  value={this.state.orang_tua_tempat_lahir_ayah}
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-map"></i>
                                </div>
                                <label htmlFor="tempat-lahir-ayah">
                                  Tempat Lahir Ayah
                                </label>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onChange}
                                  onBlur={this._onBlur}
                                  type="date"
                                  id="tanggal-lahir-ayah"
                                  className="form-control"
                                  name="orang_tua_tanggal_lahir_ayah"
                                  placeholder="Tgl Lahir Ayah"
                                  value={
                                    this.state.orang_tua_tanggal_lahir_ayah
                                  }
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-calendar"></i>
                                </div>
                                <label htmlFor="tanggal-lahir-ayah">
                                  Tanggal Lahir Ayah
                                </label>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onChange}
                                  onBlur={this._onBlur}
                                  required
                                  type="text"
                                  id="nama-ibu"
                                  className="form-control"
                                  name="orang_tua_nama_ibu"
                                  placeholder="Nama Ibu"
                                  value={this.state.orang_tua_nama_ibu}
                                />
                                <div className="form-control-position">
                                  <i className="bx bxs-user-detail"></i>
                                  <span className="text-danger wajib-diisi">
                                    *
                                  </span>
                                </div>
                                <label htmlFor="nama-ibu">Nama Ibu</label>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onChange}
                                  onBlur={this._onBlur}
                                  type="text"
                                  id="tempat-lahir-ibu"
                                  className="form-control"
                                  name="orang_tua_tempat_lahir_ibu"
                                  placeholder="Tempat Lahir Ibu"
                                  value={this.state.orang_tua_tempat_lahir_ibu}
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-map"></i>
                                </div>
                                <label htmlFor="tempat-lahir-ibu">
                                  Tempat Lahir Ibu
                                </label>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onChange}
                                  onBlur={this._onBlur}
                                  type="date"
                                  id="tanggal-lahir-ibu"
                                  className="form-control"
                                  name="orang_tua_tanggal_lahir_ibu"
                                  placeholder="Tgl Lahir Ibu"
                                  value={this.state.orang_tua_tanggal_lahir_ibu}
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-calendar"></i>
                                </div>
                                <label htmlFor="tanggal-lahir-ibu">
                                  Tanggal Lahir Ibu
                                </label>
                              </div>
                            </div>
                            <div className="col-12">
                              <h4>
                                <u>Saudara Kandung (Sesuai Kartu Keluarga)</u>
                              </h4>
                              <hr />
                            </div>
                            <div className="col-12">
                              <div className="table-responsive">
                                <table
                                  style={{ width: "1200px" }}
                                  className="table hover table-no-padding"
                                >
                                  <thead>
                                    <tr>
                                      <th>NAMA</th>
                                      <th>JENIS KELAMIN</th>
                                      <th>TEMPAT LAHIR</th>
                                      <th>TANGGAL LAHIR</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {[1, 2, 3, 4].map((object, i) => {
                                      return (
                                        <tr key={i}>
                                          <td>
                                            <input
                                              onChange={this.onChange}
                                              name={
                                                "saudara_kandung_nama_" + object
                                              }
                                              type="text"
                                              className="form-control"
                                            />
                                          </td>
                                          <td>
                                            <div className="custom-control-inline">
                                              <div className="radio mr-1">
                                                <input
                                                  onChange={this.onChange}
                                                  value="L"
                                                  type="radio"
                                                  name={
                                                    "saudara_kandung_jenis_kelamin_" +
                                                    object
                                                  }
                                                  id={
                                                    "saudara-kandung-pria-" +
                                                    object
                                                  }
                                                />
                                                <label
                                                  htmlFor={
                                                    "saudara-kandung-pria-" +
                                                    object
                                                  }
                                                >
                                                  Laki-laki
                                                </label>
                                              </div>
                                              <div className="radio mr-1">
                                                <input
                                                  onChange={this.onChange}
                                                  value="P"
                                                  type="radio"
                                                  name={
                                                    "saudara_kandung_jenis_kelamin_" +
                                                    object
                                                  }
                                                  id={
                                                    "saudara-kandung-wanita-" +
                                                    object
                                                  }
                                                />
                                                <label
                                                  htmlFor={
                                                    "saudara-kandung-wanita-" +
                                                    object
                                                  }
                                                >
                                                  Perempuan
                                                </label>
                                              </div>
                                            </div>
                                          </td>
                                          <td>
                                            <input
                                              onChange={this.onChange}
                                              name={
                                                "saudara_kandung_tempat_lahir_" +
                                                object
                                              }
                                              type="text"
                                              className="form-control"
                                            />
                                          </td>
                                          <td>
                                            <input
                                              onChange={this.onChange}
                                              name={
                                                "saudara_kandung_tanggal_lahir_" +
                                                object
                                              }
                                              type="date"
                                              className="form-control"
                                            />
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            <div className="col-12 mt-2 mb-1">
                              <h4>
                                <u>Mertua</u>
                              </h4>
                              <hr />
                            </div>
                            <div className="col-12">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onChange}
                                  type="text"
                                  disabled={this.isStatusPerdataBelumMenikahOrCerai()}
                                  id="mertua-nama-ayah"
                                  className="form-control"
                                  name="mertua_nama_ayah"
                                  required={this.isStatusPerdataMenikah()}
                                  placeholder="Nama Ayah"
                                />
                                <div className="form-control-position">
                                  <i className="bx bxs-user-detail"></i>
                                  {this.isStatusPerdataMenikah() && (
                                    <span className="text-danger wajib-diisi">
                                      *
                                    </span>
                                  )}
                                </div>
                                <label htmlFor="mertua-nama-ayah">
                                  Nama Ayah
                                </label>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onChange}
                                  type="text"
                                  disabled={this.isStatusPerdataBelumMenikahOrCerai()}
                                  id="mertua-tempat-lahir-ayah"
                                  className="form-control"
                                  name="mertua_tempat_lahir_ayah"
                                  required={this.isStatusPerdataMenikah()}
                                  placeholder="Tempat Lahir Ayah"
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-map"></i>
                                  {this.isStatusPerdataMenikah() && (
                                    <span className="text-danger wajib-diisi">
                                      *
                                    </span>
                                  )}
                                </div>
                                <label htmlFor="mertua-tempat-lahir-ayah">
                                  Tempat Lahir Ayah
                                </label>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onChange}
                                  type="date"
                                  disabled={this.isStatusPerdataBelumMenikahOrCerai()}
                                  id="mertua-tanggal-lahir-ayah"
                                  className="form-control"
                                  name="mertua_tanggal_lahir_ayah"
                                  required={this.isStatusPerdataMenikah()}
                                  placeholder="Tgl Lahir Ayah"
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-calendar"></i>
                                  {this.isStatusPerdataMenikah() && (
                                    <span className="text-danger wajib-diisi">
                                      *
                                    </span>
                                  )}
                                </div>
                                <label htmlFor="mertua-tanggal-lahir-ayah">
                                  Tanggal Lahir Ayah
                                </label>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onChange}
                                  type="text"
                                  disabled={this.isStatusPerdataBelumMenikahOrCerai()}
                                  id="mertua-nama-ibu"
                                  className="form-control"
                                  name="mertua_nama_ibu"
                                  required={this.isStatusPerdataMenikah()}
                                  placeholder="Nama Ibu"
                                />
                                <div className="form-control-position">
                                  <i className="bx bxs-user-detail"></i>
                                  {this.isStatusPerdataMenikah() && (
                                    <span className="text-danger wajib-diisi">
                                      *
                                    </span>
                                  )}
                                </div>
                                <label htmlFor="mertua-nama-ibu">
                                  Nama Ibu
                                </label>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onChange}
                                  type="text"
                                  disabled={this.isStatusPerdataBelumMenikahOrCerai()}
                                  id="mertua-tempat-lahir-ibu"
                                  className="form-control"
                                  name="mertua_tempat_lahir_ibu"
                                  required={this.isStatusPerdataMenikah()}
                                  placeholder="Tempat Lahir Ibu"
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-map"></i>
                                  {this.isStatusPerdataMenikah() && (
                                    <span className="text-danger wajib-diisi">
                                      *
                                    </span>
                                  )}
                                </div>
                                <label htmlFor="mertua-tempat-lahir-ibu">
                                  Tempat Lahir Ibu
                                </label>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onChange}
                                  type="date"
                                  id="mertua-tanggal-lahir-ibu"
                                  disabled={this.isStatusPerdataBelumMenikahOrCerai()}
                                  className="form-control"
                                  name="mertua_tanggal_lahir_ibu"
                                  required={this.isStatusPerdataMenikah()}
                                  placeholder="Tgl Lahir Ibu"
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-calendar"></i>
                                  {this.isStatusPerdataMenikah() && (
                                    <span className="text-danger wajib-diisi">
                                      *
                                    </span>
                                  )}
                                </div>
                                <label htmlFor="mertua-tanggal-lahir-ibu">
                                  Tanggal Lahir Ibu
                                </label>
                              </div>
                            </div>
                            <div className="col-12 mt-2 mb-1">
                              <h4>
                                <u>Kontak Darurat</u>
                              </h4>
                              <hr />
                            </div>
                            <div className="col-sm-4 col-xs-12">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onChange}
                                  onBlur={this._onBlur}
                                  required
                                  type="text"
                                  id="kontak-darurat-nama"
                                  className="form-control"
                                  name="kontak_darurat_nama"
                                  placeholder="Nama"
                                  value={this.state.kontak_darurat_nama}
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-user-minus"></i>
                                  <span className="text-danger wajib-diisi">
                                    *
                                  </span>
                                </div>
                                <label htmlFor="kontak-darurat-nama">
                                  Nama
                                </label>
                              </div>
                            </div>
                            <div className="col-sm-4 col-xs-12">
                              <div className="form-label-group position-relative has-icon-left">
                                <label htmlFor="kontak-darurat-hubungan">
                                  Hubungan
                                </label>
                                <select
                                  defaultValue={
                                    this.state.kontak_darurat_hubungan
                                  }
                                  onChange={this.onChange}
                                  onBlur={this._onBlur}
                                  name="kontak_darurat_hubungan"
                                  className="form-control"
                                  id="kontak-darurat-hubungan"
                                >
                                  <option value="">Pilih Hubungan</option>
                                  <option value="Ayah Kandung">
                                    Ayah Kandung
                                  </option>
                                  <option value="Ibu Kandung">
                                    Ibu Kandung
                                  </option>
                                  <option value="Adik Kandung">
                                    Adik Kandung
                                  </option>
                                  <option value="Kakak Kandung">
                                    Kakak Kandung
                                  </option>
                                  <option value="Kerabat Lainnya">
                                    Kerabat Lainnya
                                  </option>
                                </select>

                                <div className="form-control-position">
                                  <i className="bx bx-user-plus"></i>
                                  <span className="text-danger wajib-diisi">
                                    *
                                  </span>
                                </div>
                              </div>
                            </div>
                            {this.state.kontak_darurat_hubungan ===
                              "Kerabat Lainnya" && (
                              <div className="col-sm-4 col-xs-12">
                                <div className="form-label-group position-relative has-icon-left">
                                  <input
                                    onChange={this.onChange}
                                    onBlur={this._onBlur}
                                    required
                                    type="text"
                                    id="kontak-darurat-hubungan-kerabat"
                                    className="form-control"
                                    name="kontak_darurat_hubungan_kerabat"
                                    placeholder="Hubungan kerabat..."
                                    value={
                                      this.state.kontak_darurat_hubungan_kerabat
                                    }
                                  />
                                  <div className="form-control-position">
                                    <i className="bx bx-edit"></i>
                                    <span className="text-danger wajib-diisi">
                                      *
                                    </span>
                                  </div>
                                  <label htmlFor="kontak-darurat-hubungan-kerabat">
                                    Hubungan Kerabat
                                  </label>
                                </div>
                              </div>
                            )}
                            <div className="col-sm-4 col-xs-12">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onChange}
                                  onBlur={this._onBlur}
                                  required
                                  type="number"
                                  id="kontak-darurat-no-telepon"
                                  className="form-control"
                                  name="kontak_darurat_no_telepon"
                                  placeholder="No. Telpon"
                                  value={this.state.kontak_darurat_no_telepon}
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-phone"></i>
                                  <span className="text-danger wajib-diisi">
                                    *
                                  </span>
                                </div>
                                <label htmlFor="kontak-darurat-no-telepon">
                                  No. Telepon
                                </label>
                              </div>
                            </div>
                            <div className="col-12 mt-2">
                              <h4>
                                <u>Keterangan Vaksinasi</u>
                              </h4>
                              <hr />
                            </div>
                            <div className="col-sm-12">
                              <div className="form-group">
                                <label className="d-block">
                                  JENIS VAKSIN{" "}
                                  {/* <span className="text-danger wajib-diisi">
                                    *
                                  </span> */}
                                </label>
                                <div className="custom-control-inline">
                                  <div className="radio mr-1">
                                    <input
                                      onChange={this.onChange}
                                      checked={
                                        this.state.jenis_vaksin === "Sinovac"
                                      }
                                      value="Sinovac"
                                      type="radio"
                                      name="jenis_vaksin"
                                      id="jenis-vaksin-sinovac"
                                    />
                                    <label htmlFor="jenis-vaksin-sinovac">
                                      Sinovac
                                    </label>
                                  </div>
                                  <div className="radio mr-1">
                                    <input
                                      onChange={this.onChange}
                                      checked={
                                        this.state.jenis_vaksin ===
                                        "Astra Zeneca"
                                      }
                                      value="Astra Zeneca"
                                      type="radio"
                                      name="jenis_vaksin"
                                      id="jenis-vaksin-astra-zeneca"
                                    />
                                    <label htmlFor="jenis-vaksin-astra-zeneca">
                                      Astra Zeneca
                                    </label>
                                  </div>
                                  <div className="radio mr-1">
                                    <input
                                      onChange={this.onChange}
                                      checked={
                                        this.state.jenis_vaksin === "Sinopharm"
                                      }
                                      value="Sinopharm"
                                      type="radio"
                                      name="jenis_vaksin"
                                      id="jenis-vaksin-sinopharm"
                                    />
                                    <label htmlFor="jenis-vaksin-sinopharm">
                                      Sinopharm
                                    </label>
                                  </div>
                                  <div className="radio mr-1">
                                    <input
                                      onChange={this.onChange}
                                      checked={
                                        this.state.jenis_vaksin === "Moderna"
                                      }
                                      value="Moderna"
                                      type="radio"
                                      name="jenis_vaksin"
                                      id="jenis-vaksin-moderna"
                                    />
                                    <label htmlFor="jenis-vaksin-moderna">
                                      Moderna
                                    </label>
                                  </div>
                                  <div className="radio mr-1">
                                    <input
                                      onChange={this.onChange}
                                      checked={
                                        this.state.jenis_vaksin === "Pfizer"
                                      }
                                      value="Pfizer"
                                      type="radio"
                                      name="jenis_vaksin"
                                      id="jenis-vaksin-pfizer"
                                    />
                                    <label htmlFor="jenis-vaksin-pfizer">
                                      Pfizer
                                    </label>
                                  </div>
                                  <div className="radio mr-1">
                                    <input
                                      onChange={this.onChange}
                                      checked={
                                        this.state.jenis_vaksin === "Sputnik V"
                                      }
                                      value="Sputnik V"
                                      type="radio"
                                      name="jenis_vaksin"
                                      id="jenis-vaksin-sputnik-v"
                                    />
                                    <label htmlFor="jenis-vaksin-jenis-vaksin-sputnik-v">
                                      Sputnik V
                                    </label>
                                  </div>
                                  <div className="radio mr-1">
                                    <input
                                      onChange={this.onChange}
                                      checked={
                                        this.state.jenis_vaksin === "Janssen"
                                      }
                                      value="Janssen"
                                      type="radio"
                                      name="jenis_vaksin"
                                      id="jenis-vaksin-janssen"
                                    />
                                    <label htmlFor="jenis-vaksin-jenis-vaksin-janssen">
                                      Janssen
                                    </label>
                                  </div>
                                  <div className="radio mr-1">
                                    <input
                                      onChange={this.onChange}
                                      checked={
                                        this.state.jenis_vaksin === "Convidecia"
                                      }
                                      value="Convidecia"
                                      type="radio"
                                      name="jenis_vaksin"
                                      id="jenis-vaksin-convidecia"
                                    />
                                    <label htmlFor="jenis-vaksin-jenis-vaksin-convidecia">
                                      Convidecia
                                    </label>
                                  </div>
                                  <div className="radio mr-1">
                                    <input
                                      onChange={this.onChange}
                                      checked={
                                        this.state.jenis_vaksin === "Novavax"
                                      }
                                      value="Novavax"
                                      type="radio"
                                      name="jenis_vaksin"
                                      id="jenis-vaksin-novavax"
                                    />
                                    <label htmlFor="jenis-vaksin-jenis-vaksin-novavax">
                                      Novavax
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12 mt-2">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onChange}
                                  value={this.state.tanggal_vaksin_1}
                                  type="date"
                                  id="tanggal-vaksin-1"
                                  className="form-control"
                                  name="tanggal_vaksin_1"
                                  placeholder="Tanggal Vaksin ke 1"
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-calendar"></i>
                                </div>
                                <label htmlFor="tanggal-vaksin-1">
                                  Tanggal Vaksin ke 1
                                </label>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12 mt-2">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onChange}
                                  value={this.state.lokasi_vaksin_1}
                                  type="text"
                                  id="lokasi-vaksin-1"
                                  className="form-control"
                                  name="lokasi_vaksin_1"
                                  placeholder="Lokasi Vaksin ke 1"
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-calendar"></i>
                                </div>
                                <label htmlFor="lokasi-vaksin-1">
                                  Lokasi Vaksin ke 1
                                </label>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12 mt-2">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onChange}
                                  value={this.state.tanggal_vaksin_2}
                                  type="date"
                                  id="tanggal-vaksin-2"
                                  className="form-control"
                                  name="tanggal_vaksin_2"
                                  placeholder="Tanggal Vaksin ke 2"
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-calendar"></i>
                                </div>
                                <label htmlFor="tanggal-vaksin-2">
                                  Tanggal Vaksin ke 2
                                </label>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12 mt-2">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onChange}
                                  value={this.state.lokasi_vaksin_2}
                                  type="text"
                                  id="lokasi-vaksin-2"
                                  className="form-control"
                                  name="lokasi_vaksin_2"
                                  placeholder="Lokasi Vaksin ke 2"
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-calendar"></i>
                                </div>
                                <label htmlFor="lokasi-vaksin-2">
                                  Lokasi Vaksin ke 2
                                </label>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12 mt-2">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onChange}
                                  value={this.state.tanggal_vaksin_3}
                                  type="date"
                                  id="tanggal-vaksin-3"
                                  className="form-control"
                                  name="tanggal_vaksin_3"
                                  placeholder="Tanggal Vaksin ke 3"
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-calendar"></i>
                                </div>
                                <label htmlFor="tanggal-vaksin-3">
                                  Tanggal Vaksin ke 3
                                </label>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12 mt-2">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onChange}
                                  value={this.state.lokasi_vaksin_3}
                                  type="text"
                                  id="lokasi-vaksin-3"
                                  className="form-control"
                                  name="lokasi_vaksin_3"
                                  placeholder="Lokasi Vaksin ke 3"
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-calendar"></i>
                                </div>
                                <label htmlFor="lokasi-vaksin-3">
                                  Lokasi Vaksin ke 3
                                </label>
                              </div>
                            </div>
                            <div className="col-12">
                              <h4>
                                <u>BPJS</u>
                              </h4>
                              <hr />
                            </div>
                            <div className="col-sm-6 col-xs-12">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onChange}
                                  type="number"
                                  id="nomor-kartu-bpjs-ketenagakerjaan"
                                  className="form-control"
                                  name="nomor_kartu_bpjs_ketenagakerjaan"
                                  placeholder="No. Kartu BPJS Ketenagakerjaan"
                                  value={
                                    this.state
                                      .nomor_kartu_bpjs_ketenagakerjaan || ""
                                  }
                                />
                                <div className="form-control-position">
                                  <i className="bx bxs-id-card"></i>
                                </div>
                                <label htmlFor="nomor-kartu-bpjs-ketenagakerjaan">
                                  No. Kartu BPJS Ketenagakerjaan
                                </label>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12">
                              <div className="form-group">
                                <div className="input-group">
                                  <div className="input-group-prepend">
                                    <label
                                      className="input-group-text bg-white"
                                      htmlFor="keterangan-bpjs-ketenagakerjaan"
                                    >
                                      KET.
                                    </label>
                                  </div>
                                  <select
                                    value={
                                      this.state
                                        .keterangan_kartu_bpjs_ketenagakerjaan
                                    }
                                    onChange={this.onChange}
                                    name="keterangan_kartu_bpjs_ketenagakerjaan"
                                    className="form-control"
                                    id="keterangan-bpjs-ketenagakerjaan"
                                  >
                                    <option value="Dapat">Dapat</option>
                                    <option value="Belum Dapat">
                                      Belum Dapat
                                    </option>
                                    <option value="Hilang">Hilang</option>
                                  </select>
                                </div>
                                {this.state
                                  .keterangan_kartu_bpjs_ketenagakerjaan ===
                                  "Belum Dapat" && (
                                  <small className="form-text text-muted">
                                    Jika belum memiliki BPJS Ketenagakerjaan,
                                    unggah kartu di form berikutnya tidak
                                    wajib.
                                  </small>
                                )}
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-9">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  onChange={this.onChange}
                                  onBlur={this._onBlur}
                                  type="number"
                                  id="nomor-kartu-bpjs-kesehatan"
                                  className="form-control"
                                  name="nomor_kartu_bpjs_kesehatan"
                                  placeholder="No. Kartu BPJS Kesehatan"
                                  value={
                                    this.state.nomor_kartu_bpjs_kesehatan || ""
                                  }
                                  required
                                />
                                <div className="form-control-position">
                                  <i className="bx bxs-id-card"></i>
                                  <span className="text-danger wajib-diisi">
                                    *
                                  </span>
                                </div>
                                <label htmlFor="nomor-kartu-bpjs-kesehatan">
                                  No. Kartu BPJS Kesehatan
                                </label>
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-3">
                              <div className="form-group">
                                <div className="input-group">
                                  <div className="input-group-prepend">
                                    <label
                                      className="input-group-text bg-white"
                                      htmlFor="keterangan-bpjs-kesehatan"
                                    >
                                      KET.
                                    </label>
                                  </div>
                                  <select
                                    defaultValue={
                                      this.state.keterangan_kartu_bpjs_kesehatan
                                    }
                                    onChange={this.onChange}
                                    name="keterangan_kartu_bpjs_kesehatan"
                                    className="form-control"
                                    id="keterangan-bpjs-kesehatan"
                                  >
                                    <option value="Dapat">Dapat</option>
                                    <option value="Belum Dapat">
                                      Belum Dapat
                                    </option>
                                    <option value="Hilang">Hilang</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            {!(this.state.status_karyawan === "pkl/magang") && (
                              <>
                                <div className="col-12">
                                  <h4>
                                    <u>Rekening Bank</u>
                                  </h4>
                                  <hr />
                                </div>
                                <div className="col-sm-6 col-xs-12">
                                  <div className="form-group">
                                    <label className="d-block">
                                      Bank{" "}
                                      <span className="text-danger wajib-diisi">
                                        *
                                      </span>
                                    </label>
                                    <div className="custom-control-inline">
                                      <div className="radio mr-1 mb-1">
                                        <input
                                          onChange={this.onBankChange}
                                          checked={
                                            this.state.selected_bank ===
                                            "mandiri"
                                          }
                                          value="mandiri"
                                          type="radio"
                                          name="selected_bank"
                                          id="mandiri"
                                          disabled={
                                            this.state.status_karyawan ===
                                            "staff"
                                          }
                                        />
                                        <label htmlFor="mandiri">
                                          Bank Mandiri
                                          <img
                                            width="50px"
                                            src={require("../assets/icons/bank-mandiri.png")}
                                            alt="Icon bank mandiri"
                                            style={{ marginLeft: "5px" }}
                                          />
                                        </label>
                                      </div>
                                      <div className="radio mr-1 mb-1">
                                        <input
                                          onChange={this.onBankChange}
                                          checked={
                                            this.state.selected_bank === "mas"
                                          }
                                          value="mas"
                                          type="radio"
                                          name="selected_bank"
                                          id="mas"
                                          disabled={
                                            this.state.status_karyawan ===
                                            "staff"
                                          }
                                        />
                                        <label htmlFor="mas">
                                          Bank Mas
                                          <img
                                            width="20px"
                                            src={require("../assets/logos/bank_mas_logo.jpg")}
                                            alt="Icon bank mas"
                                            style={{ marginLeft: "5px" }}
                                          />
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-sm-6 col-xs-12 mt-1">
                                  <div className="form-label-group position-relative has-icon-left">
                                    <input
                                      onChange={this.validateRekeningBank}
                                      onBlur={this._onBlur}
                                      required
                                      type="text"
                                      inputMode="numeric"
                                      id="nomor-rekening-bank"
                                      className="form-control"
                                      name="nomor_rekening_bank"
                                      placeholder="Nomor Rekening Bank"
                                      value={this.state.nomor_rekening_bank}
                                      maxLength={
                                        this.state.selected_bank === "mandiri"
                                          ? 13
                                          : this.state.selected_bank === "mas"
                                            ? 10
                                            : 13 // default/fallback
                                      }
                                      disabled={
                                        isNonstaffStatus(
                                          this.state.status_karyawan,
                                        ) &&
                                        this.state.selected_bank === "" &&
                                        this.state.nomor_rekening_bank === ""
                                      }
                                      onKeyPress={(e) => {
                                        /* ...existing logic... */
                                      }}
                                    />
                                    <small className="form-text text-muted">
                                      {this.state.selected_bank === "mandiri" &&
                                        "Nomor rekening Mandiri harus 13 digit"}
                                      {this.state.selected_bank === "mas" &&
                                        "Nomor rekening MAS harus 10 digit"}
                                      {this.state.selected_bank === "" &&
                                        "Pilih bank terlebih dahulu"}
                                    </small>
                                    {this.state.rekening_error && (
                                      <small className="form-text text-danger">
                                        {this.state.rekening_error}
                                      </small>
                                    )}
                                    <div className="form-control-position">
                                      <i className="bx bx-money"></i>
                                      <span className="text-danger wajib-diisi">
                                        *
                                      </span>
                                    </div>
                                    <label htmlFor="nomor-rekening-bank">
                                      Nomor Rekening Bank
                                    </label>
                                  </div>
                                </div>
                              </>
                            )}
                            <div className="col-12 mb-1">
                              <h4>
                                <u>Dokumen Karyawan</u>
                              </h4>
                              <hr />
                            </div>
                            <div className="col-12">
                              <div className="row">
                                <div className="col-xl-4 col-12">
                                  <DocumentOcrUpload
                                    userOcrEnabled={this.state.trial}
                                    documentType="foto_profile"
                                    expectedName=""
                                    title="Foto Pribadi"
                                    placeholderSrc={require("../assets/images/foto-sendiri.png")}
                                    previewUrl={this.state.fotoUrl}
                                    fileLabel={this.state.foto_pribadi_label}
                                    uploadStatus={
                                      this.state.foto_pribadi_status
                                    }
                                    inputId="foto-pribadi"
                                    inputName="foto_pribadi"
                                    required={
                                      !(
                                        typeof this.state.foto_url ===
                                          "string" &&
                                        this.state.foto_url.trim() !== ""
                                      )
                                    }
                                    storageFolder={this.getStorageFolder()}
                                    validateImageFile={this.validateImageFile}
                                    onPreviewChange={this.handleOcrPreviewChange(
                                      "fotoUrl",
                                      "fotoFile",
                                    )}
                                    onStatusChange={(status) =>
                                      this.setState({
                                        foto_pribadi_status: status,
                                      })
                                    }
                                    onLabelChange={(label) =>
                                      this.setState({
                                        foto_pribadi_label: label,
                                      })
                                    }
                                    onUploadComplete={this.handleOcrUploadComplete(
                                      "foto_url",
                                      "foto_pribadi_status",
                                    )}
                                  />
                                </div>
                                <div className="col-xl-4 col-12">
                                  <DocumentOcrUpload
                                    userOcrEnabled={this.state.trial}
                                    documentType="ktp"
                                    expectedName={this.state.nama_lengkap}
                                    expectedNik={this.state.nik || this.state.nomor_ktp}
                                    jobPosition={
                                      this.state.status_karyawan ===
                                      "nonstaff helper"
                                        ? "helper"
                                        : ""
                                    }
                                    title="Foto KTP"
                                    placeholderSrc={require("../assets/images/ktp.png")}
                                    previewUrl={this.state.ktpUrl}
                                    fileLabel={this.state.foto_ktp_label}
                                    uploadStatus={this.state.foto_ktp_status}
                                    inputId="foto-ktp"
                                    inputName="foto_ktp"
                                    required={
                                      !(
                                        typeof this.state.ktp_url ===
                                          "string" &&
                                        this.state.ktp_url.trim() !== ""
                                      )
                                    }
                                    storageFolder={this.getStorageFolder()}
                                    validateImageFile={this.validateImageFile}
                                    onPreviewChange={this.handleOcrPreviewChange(
                                      "ktpUrl",
                                      "ktpFile",
                                    )}
                                    onStatusChange={(status) =>
                                      this.setState({ foto_ktp_status: status })
                                    }
                                    onLabelChange={(label) =>
                                      this.setState({ foto_ktp_label: label })
                                    }
                                    onUploadComplete={this.handleOcrUploadComplete(
                                      "ktp_url",
                                      "foto_ktp_status",
                                    )}
                                  />
                                </div>
                                <div className="col-xl-4 col-12">
                                  <DocumentOcrUpload
                                    userOcrEnabled={this.state.trial}
                                    documentType="npwp"
                                    expectedName={this.state.nama_lengkap}
                                    expectedNik={this.state.nik || this.state.nomor_ktp}
                                    title="Foto NPWP"
                                    placeholderSrc={require("../assets/images/npwp.png")}
                                    previewUrl={this.state.npwpUrl}
                                    fileLabel={this.state.foto_npwp_label}
                                    uploadStatus={this.state.foto_npwp_status}
                                    inputId="foto-npwp"
                                    inputName="foto_npwp"
                                    required={
                                      !(
                                        typeof this.state.npwp_url ===
                                          "string" &&
                                        this.state.npwp_url.trim() !== ""
                                      )
                                    }
                                    storageFolder={this.getStorageFolder()}
                                    validateImageFile={this.validateImageFile}
                                    onPreviewChange={this.handleOcrPreviewChange(
                                      "npwpUrl",
                                      "npwpFile",
                                    )}
                                    onStatusChange={(status) =>
                                      this.setState({
                                        foto_npwp_status: status,
                                      })
                                    }
                                    onLabelChange={(label) =>
                                      this.setState({ foto_npwp_label: label })
                                    }
                                    onUploadComplete={this.handleOcrUploadComplete(
                                      "npwp_url",
                                      "foto_npwp_status",
                                    )}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="row">
                                <div className="col-xl-6 col-12">
                                  <DocumentOcrUpload
                                    userOcrEnabled={this.state.trial}
                                    documentType="kk"
                                    expectedName={this.state.nama_lengkap}
                                    expectedNik={this.state.nik || this.state.nomor_ktp}
                                    title="Foto Kartu Keluarga"
                                    placeholderSrc={require("../assets/images/kk.png")}
                                    previewUrl={this.state.kkUrl}
                                    fileLabel={this.state.foto_kk_label}
                                    uploadStatus={this.state.foto_kk_status}
                                    inputId="foto-kk"
                                    inputName="foto_kk"
                                    required={
                                      !(
                                        typeof this.state.kk_url === "string" &&
                                        this.state.kk_url.trim() !== ""
                                      )
                                    }
                                    storageFolder={this.getStorageFolder()}
                                    validateImageFile={this.validateImageFile}
                                    onPreviewChange={this.handleOcrPreviewChange(
                                      "kkUrl",
                                      "kkFile",
                                    )}
                                    onStatusChange={(status) =>
                                      this.setState({ foto_kk_status: status })
                                    }
                                    onLabelChange={(label) =>
                                      this.setState({ foto_kk_label: label })
                                    }
                                    onUploadComplete={this.handleOcrUploadComplete(
                                      "kk_url",
                                      "foto_kk_status",
                                    )}
                                  />
                                </div>
                                <div className="col-xl-6 col-12">
                                  <DocumentOcrUpload
                                    userOcrEnabled={this.state.trial}
                                    documentType="cv"
                                    expectedName={this.state.nama_lengkap}
                                    expectedNik={this.state.nik || this.state.nomor_ktp}
                                    cvEducationQuery={this.buildCvEducationQuery()}
                                    cvExperienceQuery={this.buildCvExperienceQuery()}
                                    title="CV (Dalam Bentuk File PDF, Maks 3 MB)"
                                    placeholderSrc={require("../assets/images/cv.jpg")}
                                    previewUrl={null}
                                    fileUrl={this.state.cvUrl}
                                    fileLabel={this.state.foto_cv_label}
                                    uploadStatus={this.state.foto_cv_status}
                                    inputId="foto-cv"
                                    inputName="foto_cv"
                                    required={
                                      !(
                                        typeof this.state.cv_url === "string" &&
                                        this.state.cv_url.trim() !== ""
                                      )
                                    }
                                    storageFolder={this.getStorageFolder()}
                                    validateFile={this.validatePdfFile}
                                    accept="application/pdf"
                                    fileTypeHint="file PDF"
                                    previewMode="pdf"
                                    onPreviewChange={this.handleOcrPreviewChange(
                                      "cvUrl",
                                      "cvFile",
                                    )}
                                    onStatusChange={(status) =>
                                      this.setState({ foto_cv_status: status })
                                    }
                                    onLabelChange={(label) =>
                                      this.setState({ foto_cv_label: label })
                                    }
                                    onUploadComplete={this.handleOcrUploadComplete(
                                      "cv_url",
                                      "foto_cv_status",
                                      "cvUrl",
                                    )}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-12">
                              {/* Card kecil untuk menampilkan required field yang belum diisi */}
                              {(Array.isArray(
                                this.state.missingRequiredFields,
                              ) &&
                                this.state.missingRequiredFields.length > 0) ||
                              (Array.isArray(
                                this.state.missingRequiredUploads,
                              ) &&
                                this.state.missingRequiredUploads.length >
                                  0) ? (
                                <div
                                  className="card border-danger shadow-sm mb-3"
                                  style={{
                                    maxWidth: 600,
                                    margin: "0 auto",
                                    background: "#fff6f6",
                                  }}
                                >
                                  <div className="card-body py-2 px-3">
                                    <div className="d-flex align-items-center mb-2">
                                      <i
                                        className="bx bx-error-circle text-danger"
                                        style={{
                                          fontSize: 24,
                                          marginRight: 8,
                                        }}
                                      ></i>
                                      <h6
                                        className="text-danger mb-0"
                                        style={{ fontWeight: 700 }}
                                      >
                                        Kolom wajib & dokumen yang belum
                                        diisi/upload:
                                      </h6>
                                    </div>
                                    {Array.isArray(
                                      this.state.missingRequiredFields,
                                    ) &&
                                      this.state.missingRequiredFields.length >
                                        0 && (
                                        <>
                                          <div
                                            className="mb-1"
                                            style={{ fontWeight: 600 }}
                                          >
                                            Kolom Wajib:
                                          </div>
                                          <ul
                                            className="mb-2 pl-3"
                                            style={{ fontSize: "1em" }}
                                          >
                                            {this.state.missingRequiredFields.map(
                                              (field, idx) => (
                                                <li
                                                  key={idx}
                                                  className="text-danger"
                                                >
                                                  {this.getFieldDisplayName
                                                    ? this.getFieldDisplayName(
                                                        field,
                                                      )
                                                    : field}
                                                </li>
                                              ),
                                            )}
                                          </ul>
                                        </>
                                      )}
                                    {Array.isArray(
                                      this.state.missingRequiredUploads,
                                    ) &&
                                      this.state.missingRequiredUploads.length >
                                        0 && (
                                        <>
                                          <div
                                            className="mb-1"
                                            style={{ fontWeight: 600 }}
                                          >
                                            Dokumen/Foto Wajib:
                                          </div>
                                          <ul
                                            className="mb-0 pl-3"
                                            style={{ fontSize: "1em" }}
                                          >
                                            {this.state.missingRequiredUploads
                                              .filter(
                                                (upload) =>
                                                  upload ===
                                                    "foto_pribadi_complete" ||
                                                  upload ===
                                                    "foto_ktp_complete" ||
                                                  upload ===
                                                    "foto_npwp_complete" ||
                                                  upload ===
                                                    "foto_kk_complete" ||
                                                  upload === "foto_cv_complete",
                                              )
                                              .map((upload, idx) => (
                                                <li
                                                  key={idx}
                                                  className="text-danger"
                                                >
                                                  {upload ===
                                                    "foto_pribadi_complete" &&
                                                    "Foto Pribadi"}
                                                  {upload ===
                                                    "foto_ktp_complete" &&
                                                    "Foto KTP"}
                                                  {upload ===
                                                    "foto_npwp_complete" &&
                                                    "Foto NPWP"}
                                                  {upload ===
                                                    "foto_kk_complete" &&
                                                    "Foto Kartu Keluarga"}
                                                  {upload ===
                                                    "foto_cv_complete" &&
                                                    "File CV (PDF)"}
                                                </li>
                                              ))}
                                          </ul>
                                        </>
                                      )}
                                  </div>
                                </div>
                              ) : null}
                              <div
                                className="alert border-secondary mb-2"
                                role="alert"
                                style={{
                                  background: "rgb(220 223 255)",
                                }}
                              >
                                <div className="d-flex align-items-center">
                                  <div>
                                    <label
                                      htmlFor="agreement"
                                      style={{
                                        textTransform: "capitalize !important",
                                        fontWeight: 800,
                                      }}
                                    >
                                      Demikian Form Data Karyawan ini saya isi
                                      dengan sebenarnya tanpa adanya paksaan
                                      dari pihak lain manapun, sebagai syarat
                                      bekerja di PT.Prakarsa Alam Segar. Apabila
                                      dikemudian hari ditemukan bahwa pernyataan
                                      yang saya buat di atas adalah tidak benar,
                                      maka hal ini dapat dijadikan dasar bagi
                                      Perusahaan untuk melakukan pemutusan
                                      hubungan kerja dan Saya tidak memiliki hak
                                      apapun terkait pemutusan hubungan kerja
                                      tersebut.
                                    </label>
                                  </div>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    position: "relative",
                                  }}
                                >
                                  <button
                                    type="button"
                                    onClick={this.agreementChange}
                                    aria-pressed={this.state.agreement}
                                    style={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      padding: "10px 16px",
                                      fontSize: "1rem",
                                      fontWeight: 600,
                                      borderRadius: 6,
                                      border: "none", // no border
                                      cursor: "pointer",
                                      userSelect: "none",
                                      transition: "transform .05s ease-in-out",
                                      color: this.state.agreement
                                        ? "#FFFFFF"
                                        : "#475F7B",
                                      backgroundColor: this.state.agreement
                                        ? "#28a745"
                                        : "#E7EDF3",
                                      boxShadow: "none", // no shadow
                                    }}
                                    onMouseDown={(e) =>
                                      (e.currentTarget.style.transform =
                                        "scale(0.98)")
                                    }
                                    onMouseUp={(e) =>
                                      (e.currentTarget.style.transform =
                                        "scale(1)")
                                    }
                                    onMouseLeave={(e) =>
                                      (e.currentTarget.style.transform =
                                        "scale(1)")
                                    }
                                  >
                                    <i
                                      className={`bx ${
                                        this.state.agreement
                                          ? "bx-check-circle"
                                          : "bx-circle"
                                      }`}
                                      style={{
                                        fontSize: "1.2rem",
                                        marginRight: 4,
                                      }} // tighter spacing
                                    />
                                    {this.state.agreement
                                      ? "Sudah Disetujui"
                                      : "Setujui"}
                                  </button>

                                  <input
                                    checked={this.state.agreement}
                                    name="agreement"
                                    type="checkbox"
                                    id="agreement"
                                    readOnly
                                    style={{
                                      position: "absolute",
                                      opacity: 0,
                                      pointerEvents: "none",
                                      width: 0,
                                      height: 0,
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-12">
                              <hr />
                            </div>
                            <div className="col-12">
                              <div className="d-flex justify-content-center">
                                <button
                                  disabled={
                                    this.state.submiting || !isFormValid
                                  }
                                  type="submit"
                                  className={`btn mb-1 ${
                                    isFormValid && !this.state.submiting
                                      ? "btn-primary"
                                      : "btn-secondary"
                                  }`}
                                >
                                  {this.state.submiting === true ? (
                                    <span>Submiting.. </span>
                                  ) : (
                                    <span>
                                      {isFormValid ? "Submit" : "Lengkapi Form"}{" "}
                                      {/* ✅ TAMBAH: Dynamic text */}
                                    </span>
                                  )}
                                </button>
                              </div>

                              {!isFormValid && (
                                <div className="w-100">
                                  <small className="text-muted d-block text-center">
                                    <i className="bx bx-info-circle"></i>
                                    Pastikan semua field wajib (*) telah diisi
                                    dan file telah diupload
                                  </small>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Form;
